// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27%3E%3Cg clip-path=%27url%28%23clip0_18928_50018%29%27%3E%3Cpath d=%27M9 11C9 11.7956 9.31607 12.5587 9.87868 13.1213C10.4413 13.6839 11.2044 14 12 14C12.7956 14 13.5587 13.6839 14.1213 13.1213C14.6839 12.5587 15 11.7956 15 11C15 10.2044 14.6839 9.44129 14.1213 8.87868C13.5587 8.31607 12.7956 8 12 8C11.2044 8 10.4413 8.31607 9.87868 8.87868C9.31607 9.44129 9 10.2044 9 11Z%27 stroke=%27%23283D6B%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M17.657 16.6567L13.414 20.8997C13.039 21.2743 12.5306 21.4848 12.0005 21.4848C11.4704 21.4848 10.962 21.2743 10.587 20.8997L6.343 16.6567C5.22422 15.5379 4.46234 14.1124 4.15369 12.5606C3.84504 11.0087 4.00349 9.40022 4.60901 7.93844C5.21452 6.47665 6.2399 5.22725 7.55548 4.34821C8.87107 3.46918 10.4178 3 12 3C13.5822 3 15.1289 3.46918 16.4445 4.34821C17.7601 5.22725 18.7855 6.47665 19.391 7.93844C19.9965 9.40022 20.155 11.0087 19.8463 12.5606C19.5377 14.1124 18.7758 15.5379 17.657 16.6567Z%27 stroke=%27%23283D6B%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27clip0_18928_50018%27%3E%3Crect width=%2724%27 height=%2724%27 fill=%27white%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2721%27 viewBox=%270 0 20 21%27 fill=%27none%27%3E%3Cpath d=%27M10.2447 4.91107C10.5702 4.58563 11.0978 4.58563 11.4232 4.91107L16.4232 9.91107C16.5795 10.0674 16.6673 10.2793 16.6673 10.5003C16.6673 10.7213 16.5795 10.9333 16.4232 11.0896L11.4232 16.0896C11.0978 16.415 10.5702 16.415 10.2447 16.0896C9.91929 15.7641 9.91929 15.2365 10.2447 14.9111L13.8221 11.3337L4.16732 11.3337C3.70708 11.3337 3.33398 10.9606 3.33398 10.5003C3.33398 10.0401 3.70708 9.66699 4.16732 9.66699L13.8221 9.66699L10.2447 6.08958C9.91929 5.76414 9.91929 5.23651 10.2447 4.91107Z%27 fill=%27%230062FF%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2721%27 viewBox=%270 0 20 21%27 fill=%27none%27%3E%3Cg clip-path=%27url%28%23clip0_110_95253%29%27%3E%3Cpath d=%27M7.49805 5.5L12.498 10.5L7.49805 15.5%27 stroke=%27%233264FF%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27clip0_110_95253%27%3E%3Crect width=%2720%27 height=%2720%27 fill=%27white%27 transform=%27matrix%28-1 0 0 1 19.998 0.5%29%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2718%27 height=%2719%27 viewBox=%270 0 18 19%27 fill=%27none%27%3E%3Cpath d=%27M15.4983 4.18945C15.8079 4.46464 15.8358 4.93869 15.5606 5.24828L7.56056 14.2483C7.41824 14.4084 7.21424 14.5 7.00001 14.5C6.78578 14.5 6.58178 14.4084 6.43945 14.2483L2.43945 9.74828C2.16426 9.43869 2.19215 8.96464 2.50174 8.68945C2.81132 8.41426 3.28538 8.44215 3.56056 8.75173L7.00001 12.6211L14.4395 4.25174C14.7146 3.94215 15.1887 3.91426 15.4983 4.18945Z%27 fill=%27%23ffffff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%231e293b%27 stroke-width=%272.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M15 18L9 12L15 6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%231e293b%27 stroke-width=%272.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M9 18L15 12L9 6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%232563eb%27 stroke-width=%272.4%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M15 18L9 12L15 6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%232563eb%27 stroke-width=%272.4%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M9 18L15 12L9 6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27%3E%3Cg clip-path=%27url%28%23clip0_2211_7404%29%27%3E%3Cpath d=%27M16 3V7M8 3V7M4 11H20M11 15H12V18M4 7C4 6.46957 4.21071 5.96086 4.58579 5.58579C4.96086 5.21071 5.46957 5 6 5H18C18.5304 5 19.0391 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V7Z%27 stroke=%27%23555555%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27clip0_2211_7404%27%3E%3Crect width=%2724%27 height=%2724%27 fill=%27white%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --hw-blue-new: #0062FF;
  --hw-blue-new-rgb: 0, 98, 255;
  --hw-star: #F3960A;
  --hw-light-gray: #F4F5F8;
  --hw-blue-new-rgb: 0, 98, 255;
  --green-bg: #0A7519;
  --header-icon: #CDEAFF;
  --header-icon-hover: #60B6FB;
  --social-color: #25579E;
}

/* Skeleton loading animations for additional hotel data */
@keyframes skeleton-pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

.row-gap--null {
  row-gap: 0 !important;
}
.pb-null {
  padding-bottom: 0 !important;
}

.hotel-additional-data-skeleton .skeleton-item {
  animation: skeleton-pulse 1.5s ease-in-out infinite;
}

.hotel-additional-data-loading {
  opacity: 0.7;
}

.hotel-additional-data-error {
  opacity: 0.6;
}

.green-bg {
  background-color: var(--green-bg) !important;
}

.text-right {
  text-align: right !important;
}

.mt-10 {
  margin-top: 1rem !important;
}

.mt-12 {
  margin-top: 1.2rem !important;
}

.mt-20 {
  margin-top: 2rem !important;
}

.mb-20 {
  margin-bottom: 2rem !important;
}

.hw-badge--text {
  background-color: rgba(var(--hw-blue-new-rgb), 0.10);
  color: var(--hw-brand-orange);
  padding: .4rem 1.2rem;
  border-radius: 99.9rem;
  font-weight: 500;
  display: inline-flex;
}

.hw-badge--textSmall {
  font-size: 1.2rem;
  line-height: 1.334;
}

.hw-hotel--list,
.hw-hotes-module,
.hw-hotel--singleList,
.hw-hotel--hotelDetails,
.hotel-search-form {
  --hw-brand-orange: #0062FF;
  --hw-brand-orange-light: #F2F7FF;
}

.hw-icon--blue svg {
  color: var(--hw-brand-orange);
}

.hw-btn--small {
  padding: .6rem 1.2rem !important;
  font-weight: 500 !important;
}

.hw-btn--large {
  padding: 1.4rem 3rem !important;
}

.hw-bprimary--link {
  color: var(--hw-brand-orange);
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
}

.hw-bprimary--link:hover {
  color: var(--hw-brand-blue);
}

.hw-btn--bsecondary,
.hw-btn--bhsecondary {
  border: .1rem solid var(--hw-blue-new) !important;
  color: var(--hw-blue-new) !important;

}

.hw-btn--bprimary {
  background-color: var(--hw-blue-new) !important;
  color: var(--hw-white) !important;
}

.hw-btn--bprimary:hover {
  background-color: var(--hw-brand-blue) !important;
  color: var(--hw-white) !important;
}

.hw-btn--bsecondary:hover {
  background-color: var(--hw-blue-new) !important;
  color: var(--hw-white) !important;
  border-color: var(--hw-blue-new) !important;
}

.hw-btn--bhsecondary:hover {
  color: var(--hw-blue-new) !important;
  background-color: rgba(var(--hw-blue-new-rgb), 0.05) !important;
  border-color: rgba(var(--hw-blue-new-rgb), 0.05) !important;
}

.hw-btn--bhsecondary.active {
  color: var(--hw-blue-new) !important;
  background-color: rgba(var(--hw-blue-new-rgb), 0.05) !important;
  border-color: rgba(var(--hw-blue-new-rgb), 0.05) !important;
}

.hw-mt--10 {
  margin-top: 1rem;
}

.hw-mt--20 {
  margin-top: 2rem;
}

.hw-rc--container {
  width: 100%;
  max-width: 127rem;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}




.hw-hotes-module {
  background-color: var(--hw-gray-100);
}

.hw-hotes-module>.hw-widget--card {
  min-height: 30rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3rem 0;
}

.hw-hotes-module>.hw-widget--card .hw-input--groupCol {
  max-width: 124rem;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  row-gap: 1rem;
}

.hw-input--groupCol {
  padding: 1.4rem 2rem;
  border-radius: 1rem;
  background-color: var(--hw-white);
}


.hw-br--null {
  border-radius: 0 !important;
}

.hw-hotes-module .hw-input--switchGroup>div>div {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.hw-hotes-module .hw-date-range-picker .hw-input--input {
  padding: 0;
  border: none;
  border-radius: 0;
  gap: 0;
}

.hw-date--calender {
  display: flex;
  width: 100%;
}

.hw-date--calender>div {
  border: .1rem solid var(--hw-gray-400);
  padding: .7rem .5rem;
  flex: 1 0 0;
  margin-left: -.1rem;
  min-height: 5.4rem;
  justify-content: center;
}

/* Error state for date calendar */
.hw-input--input.hw--error-cls-date-input .hw-date--calender>div {
  border-color: red !important;
}

.hw-date--calender .hw-date--checkIn {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 1rem;
  min-width: 12rem;
  /* place-content: flex-start; */
}

.hw-date--calender .hw-date--checkOut {
  min-width: 9rem;
}

.hw-date--calender .hw-date--checkIn svg {
  grid-row: span 2;
  color: var(--hw-brand-blue);
  align-self: center;
}

.hw-hotes-module .hw-row--input.hw-row--inputFirst>.hw-input--input {
  width: 100%;
  margin-left: 0;
  max-width: 100%;
}

.hw-hotes-module .hw-input--groupCol .hw-row--inputFirst .react-datepicker-wrapper {
  max-width: 100%;
  width: 100%;
  padding-left: 0;
}

.hw-mBox {
  background-color: var(--hw-white);
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
}

.hw-hotel--slideItem {
  border-radius: 1rem;
  border: 0.5px solid rgba(40, 61, 107, 0.20);
  background: var(--hw-light-gray);
  padding: 2rem;
}

.hw-pt--medium {
  padding-top: 5rem;
}

.hw-hotel--recentSlider:not(.swiper-initialized) {
  display: flex;
  overflow: hidden;
  column-gap: 2.4rem;
}

.hw-hotel--recentSlider:not(.swiper-initialized) .hw-hotel--slideItem {
  min-width: calc(50% - 1.2rem);
  width: 400px;
}

.hw-hotel--slideItem .img-holder {
  position: relative;
  aspect-ratio: 1/1;
  overflow: hidden;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}

.hw-hotel--slideItem .img-holder img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  inset: 0;
}

.hw-whyChoose--section .hw-2col--grid {
  align-items: center;
  background-color: var(--hw-white);
  padding: 2rem;
  border: 0.5px solid rgba(40, 61, 107, 0.20);
  border-radius: 1rem;
}

.hw-modal--hotelDetailsTop>*+* {
  margin-top: 2rem;
}

.h-100 {
  height: 100% !important;
}

@media (min-width: 900px) {
  .hw-date--calender .hw-date--checkIn {
    min-width: 15rem;
  }
}

@media (max-width: 989px) {
  .hw-whyChoose--section .hw-text20 {
    font-size: 1.8rem;
  }
}

@media (max-width: 767px) {
  .hw-whyChoose--section .hw-text20 {
    font-size: 1.6rem;
  }
}

@media (max-width: 479px) {
  .hw-hotes-module>.hw-widget--card {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .hw-hotes-module>.hw-widget--card .hw-input--groupCol {
    padding: 1.5rem;
  }

  .hw-date--calender .hw-date--checkIn {
    column-gap: .5rem;
  }

  .hw-date--calender .hw-date--checkIn>div,
  .hw-date--calender .hw-date--checkOut>div {
    font-size: 1.2rem;
    line-height: 1.5;
  }

  .hw-date--calender .hw-date--checkOut .hw-text14 {
    min-height: 2.125rem;
  }

  .hw-hotel--recentSection .h3 {
    font-size: 2rem;
    line-height: 1.5;
  }
}

/*Holder image*/
.hw-modal--hotelDetailsTop .hw-img--main,
.hw-modal--hotelDetailsTop .hw-img--grid {
  position: relative;
  overflow: hidden;
  background-color: var(--hw-gray-100);
  border-radius: 1rem;
}

.hw-modal--hotelDetailsTop .hw-img--main {
  aspect-ratio: 4/3;
}

.hw-modal--hotelDetailsTop .hw-img--grid {
  height: 100%;
  min-height: 9rem;
}

.hw-modal--hotelDetailsTop .hw-img--main img,
.hw-modal--hotelDetailsTop .hw-img--grid img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.row.hw-hotel--imageGallery {
  row-gap: 1rem;
}

/*End holder image*/
/* .hw-hotes-module .hw-input--multicityGroup > .row > .col-md-2 {
  width: max-content;
} */
.hw-hotes-module .hw-input--switchGroup>div>div {
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}

.hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2>div>div {
  /* border-radius: 0;
  border: none; */
  padding: 0;
  min-height: 5rem;
  width: 100%;
}

.hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2>div>div>div {
  padding-top: 0;
  padding-bottom: 0;
}

.hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2>div>div>div .css-1u9des2-indicatorSeparator {
  width: 0;
}

.hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2>div>div>div .css-1xc3v61-indicatorContainer {
  color: var(--hw-gray-800);
}

.hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2 .css-1jqq78o-placeholder {
  margin-left: 0;
  color: var(--hw-brand-blue);
  font-weight: 500;
}

/* .hw-hotes-module .hw-filter--searchBtn {
 font-weight: 500;
} */
@media (min-width: 641px) {
  .grid-span2 {
    grid-column: span 2 !important;
  }

  .hw-date--calender>div {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (min-width: 768px) {
  .hw-input--groupCol {
    padding: 2.4rem;
    border-radius: 1rem;
  }

  .hw-hotes-module .hw-filter--searchBtn {
    font-size: 1.6rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }

  /* .hw-hotes-module .hw-input--multicityGroup > .row > .col-md-2 > div > div {
  min-height: 6.8rem;
} */
}

@media (min-width: 900px) {
  .hw-hotes-module .hw-input--groupCol .hw-row--inputFirst .react-datepicker-wrapper {
    width: calc(67% - .4rem);
  }

  .hw-hotes-module .hw-row--input.hw-row--inputFirst>.hw-input--input {
    width: 33%;
  }

  .hw-modal--hotelDetailsTop .hw-img--main,
  .hw-modal--hotelDetailsTop .hw-img--grid {
    border-radius: 1.4rem;
  }
}

@media (min-width: 1100px) {
  .hw-hotes-module .hw-row--input.hw-row--inputFirst {
    column-gap: 0;
  }

  .hw-hotes-module .hw-date-range-picker .hw-input--input {
    margin-left: .4rem;
    margin-right: .4rem;
  }

  .hw-hotes-module .hw-input--switchGroup {
    width: 43rem;
    min-width: 26rem;
  }

  /* .hw-hotes-module .hw-input--multicityGroup > .row > .col-md-2 {
    width: calc(34% + calc(var(--bs-gutter-x) / 1.61));
  } */
  .hw-hotes-module .hw-input--groupCol .hw-row--inputFirst .react-datepicker-wrapper {
    width: 42%;
  }

  .hw-hotes-module .hw-row--input.hw-row--inputFirst>.hw-input--input {
    /* width: 24%; */
    width: 20rem;
    flex: 1 0 0;
  }

  .hw-hotes-module .hw-input--switchGroup>div>div {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}

@media (min-width: 1301px) {
  /* .hw-hotes-module .hw-input--switchGroup {
    width: 36.5%;
    
  } */

  .hw-hotes-module .hw-input--groupCol .hw-row--inputFirst .react-datepicker-wrapper {
    width: 33.5%;
  }

  /* .hw-hotes-module .hw-input--multicityGroup > .row > .col-md-2 {
    width: calc(36.5% + calc(var(--bs-gutter-x) / 1.61));
  } */

}

@media (max-width: 1099px) {
  .hw-hotes-module .hw-input--switchGroup>div>div {
    border-top-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  .hw-date--calender .hw-date--checkIn {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  /* .hw-hotes-module .hw-input--multicityGroup > .row.mt-1 {
  margin-top: 0 !important;
} */
}

@media (max-width: 899px) {
  .hw-hotel--imageGallery .row {
    row-gap: 1rem !important;
    --bs-gutter-x: 1rem !important;
  }

  .hw-hotes-module .hw-date--calender .hw-date--nights {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  .hw-hotes-module .hw-row--input.hw-row--inputFirst>.hw-input--input {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .hw-hotes-module .hw-row--input .hw-input--switchGroup>div>div {
    background-position: left 1rem center;
    padding-left: 4.4rem !important;
  }
}

@media (max-width: 640px) {
  .hw-hotes-module .hw-row--input.hw-row--inputFirst>.hw-input--input {
    padding-left: .5rem;
    padding-right: .5rem;
  }

  .hw-hotes-module .hw-row--input .hw-input--switchGroup>div>div {
    background-position: left .6rem center;
    padding-left: 3rem !important;
    background-size: 2rem 2rem;
  }
}

/*slider css*/
.hw-countryExplore--slider {
  margin-top: 2rem;
}

.hw-countryExplore--slider {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  column-gap: 2rem;
}

.hw-countryExplore--slideItem {
  cursor: pointer;
}

.hw-countryExplore--slideItem__image {
  position: relative;
  aspect-ratio: 1/1.2;
  overflow: hidden;
  border-radius: 2rem;
}

.hw-countryExplore--slideItem__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease-in-out;
  will-change: transform;
}

.hw-countryExplore--slideItem:hover .hw-countryExplore--slideItem__image img {
  transform: scale(1.2);
}

.hw-countryExplore--slideItem__dt {
  padding-top: 2rem;
  color: var(--hw-black);
  font-size: 1.8rem;
  line-height: 1.55556;
  font-weight: 500;
}

.hw-hotes-module.hw-hotel--widget {
  overflow-x: hidden;
}

/*slider css*/
/*Hotels List*/
.hw-hotel--filterWidgetMain .hw-input--groupCol {
  background: rgba(0, 0, 0, 0) !important;
  padding: 0 !important;
  border-radius: 0 !important;
}

.hw-hotel--filterWidgetMain {

  padding-top: 2rem;
  padding-bottom: 2rem;
  background-color: var(--hw-white);
  /* box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05); */
  overflow: visible !important;
}

.hw-hotel--list {
  position: relative;
}

.hw-hotel--asideFilter {
  grid-template-rows: auto 1fr;
  display: grid;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--hw-gray-200) var(--hw-gray-100);
  transition: .2s ease-in-out;
  background-color: var(--hw-white);
  border-radius: 0.5rem;
}

.hw-hotel--asideFilter__top {
  background-color: var(--hw-white);
}



.hw-hotel--filter__action {
  display: flex;
  justify-content: space-between;
  column-gap: .5rem;
  align-items: center;
  padding: 1.4rem 1.6rem;
  min-height: 5.6rem;
}

.hw-hotel--filter__actionFilter {
  color: var(--hw-black);
  font-size: 1.8rem;
  line-height: 1.55556;
  font-weight: bold;
}

.hw-no--link {
  background-color: rgba(0, 0, 0, 0);
  border: none;
  color: var(--hw-body-color);
  font-size: 1.6rem;
  line-height: 1.75;
  padding: 0;
  cursor: pointer;
}

.hw-hotel--filterResult {
  background-color: var(--hw-gray-100);
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;
}

.hw-hotel--filterResultTop {
  min-height: 5.7rem;
  align-items: center;
  padding: 1.4rem 0;
}

.hw-blue {
  color: var(--hw-brand-blue) !important;
}

.hw-hotel--filterResult__listItem {
  background-color: var(--hw-white);
  border-radius: 1rem;
  padding: 1.5rem;
  display: flex;
  column-gap: 1.6rem;
  row-gap: 1rem;
  position: relative;
  /* box-shadow: 0px 4px 20px rgba(15, 23, 42, 0.06); */
  /* margin-top: 1rem; */
}

.hw-hotel--filterResult__listItem::after {
  content: '';
  border: 1px solid rgba(0, 0, 0, 0);
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  border-radius: 1rem;
  transition: border-color .2s ease-out;
  pointer-events: none;
}

.hw-hotel--filterResult__listItem:hover:after {
  border-color: var(--hw-brand-orange);
}

.hw-hotel--filterResult__listItemRight {
  flex: 1;
}

.hw-hotel--filterResult__listItemRightWrapper {
  display: flex;
  column-gap: 2rem;
  /* height: 100%; */
  flex-grow: 1;
}

.hw-hotel--filterResult__listItemInfo {
  border-right: .1rem solid var(--hw-gray-400);
  padding-right: 1.5rem;
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  /* row-gap: 1rem; */
  row-gap: 0.5rem;
}

.hw-hotel--filterResult__listItemSelect {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  row-gap: 0.8rem;
}

.hw-hotel--filterResult .hw-search--flightFilterResult__body {
  min-height: 50vh;
}

.hw-hotel--filterResult__title {
  /* font-size: 2rem; */
  font-size: 1.8rem;
  color: var(--hw-black);
  line-height: 1.4;
  font-weight: bold;
  text-transform: capitalize;
  cursor: pointer;
}

.hw-hotel--filterResult__listItemInfo .hw-link.hw-link--icon {
  font-size: 1.4rem;
}

.hw-hotel--filterResult__listItemInfo .hw-link.hw-link--icon svg {
  width: 2rem;
  height: 2.1rem;
}

.hw-hotel--filterResult__listItemTimage {
  margin-top: 0.8rem;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: .4rem;
}

.hw-hotel--listItemm {
  position: relative;
  overflow: hidden;
  border-radius: 1rem;
  aspect-ratio: 1/.7;
}
.hw-hotel--listItemm svg,.hw-img--main svg,.hw-img--grid svg {
  width: -webkit-fill-available;
  height: -webkit-fill-available;
}
.hw-singleListOut--image svg {
  width: 100%;
  height: 250px;
}
.hw-singleListOut--image .slick-slider svg {
  width: 25px;
  height: 25px;
}
.hw-singleListOut--imgPlaceholder {
  width: 100%;
  height: 25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  background: linear-gradient(135deg, #eef2f9 0%, #e2e8f4 100%);
  border-radius: 1rem;
}
.hw-singleListOut--image .hw-singleListOut--imgPlaceholder svg {
  width: 6rem;
  height: 6rem;
  color: #9aa6be;
  opacity: 0.85;
}
.hw-singleListOut--imgPlaceholder span {
  font-size: 1.3rem;
  font-weight: 500;
  color: #9aa6be;
}
.hw-hotel--listItemt {
  position: relative;
  overflow: hidden;
  border-radius: 1rem;
  aspect-ratio: 1/1;
}

.hw-hotel--listItemm img,
.hw-hotel--listItemt img {
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  object-fit: cover;
}

.hw-hotel--filterResult__location {
  display: flex;
  align-items: center;
  column-gap: .4rem;
}

.hw-hotel--filterResult__listItemInfo .hw-hotel--filterResult__location {
  align-items: flex-start;
  font-size: 1.4rem;
  line-height: 1.71429;
}

.hw-hotel--filterResult__listItemInfo .hw-hotel--filterResult__location svg {
  margin-top: .2em;
  width: 2rem;
  height: 2rem;
}

.hw-hotel--filterResult__location svg,
.hw-hotel--filterResult__iconText li svg {
  flex-shrink: 0;
}

.hw-hotel--filterResult__iconText {
  margin-top: auto !important;
  text-transform: capitalize;
}

.hw-hotel--filterResult__iconText li {
  display: flex;
  align-items: center;
  column-gap: .4rem;
  font-size: 1.4rem;
  line-height: 1.71429;
  font-weight: 500;
}

.hw-hotel--filterResult__iconText>li:not(:first-child) {
  margin-top: .4rem;
}

.hw-modal--footer .room {
  flex-shrink: 0;
}

.hw-modal--footer .room>span,
.hw-hotel--filterResult__listItemSelect .room>span {
  font-weight: 500;
}

.hw-hotel--filterResult__listItem+.hw-hotel--filterResult__listItem {
  margin-top: 1.2rem;
}

/* ---------- Sticky-stacking rate list (hotel list item) ----------
   Each hotel's main card + its expanded rate list are wrapped in
   .hw-hotel--stickyGroup. When expanded, the two merge into one continuous
   card: the main card pins to the top of the viewport while the rate rows
   scroll up and tuck behind it. */
.hw-hotel--stickyGroup {
  position: relative;
  margin-bottom: 20px;
}

/* Keep the same spacing between hotels now that each item is wrapped. */
.hw-hotel--stickyGroup+.hw-hotel--stickyGroup,
.hw-hotel--stickyGroup+.hw-hotel--filterResult__listItem {
  margin-top: 1.2rem;
}

/* Expanded: main card becomes the pinned, opaque header of a single card. */
.hw-hotel--stickyGroup.is-expanded .hw-hotel--filterResult__listItem {
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: var(--hw-white);
  border-radius: 0;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}

/* Separate divider line, inset 16px (matching the rate list padding), pinned
   to the card bottom so it stays put while the rates scroll behind. */
.hw-hotel--stickyGroup.is-expanded .hw-hotel--filterResult__listItem::before {
  content: '';
  position: absolute;
  left: 1.6rem;
  right: 1.6rem;
  bottom: 0;
  height: 1px;
  background: #DFDFDF;
  z-index: 2;
  pointer-events: none;
}

/* The rate list continues the card: same shadow, rounded only at the bottom,
   and sitting behind the sticky header so rows disappear cleanly under it. */
.hw-hotel--stickyGroup.is-expanded .hw-rateList {
  position: relative;
  z-index: 1;
}

/* Expanded: the hover highlight wraps the WHOLE box (main card + rates),
   not just the pinned header, so the two read as a single box. */
.hw-hotel--stickyGroup.is-expanded .hw-hotel--filterResult__listItem:hover:after {
  border-color: transparent;
}

.hw-hotel--stickyGroup.is-expanded::after {
  content: '';
  position: absolute;
  inset: 0;
  border: 1px solid var(--hw-brand-orange);
  border-radius: 1rem;
  pointer-events: none;
  z-index: 6;
}


.hw-modal--footer .room>span:not(:last-child)::after,
.hw-hotel--filterResult__listItemSelect .room>span:not(:last-child)::after {
  content: '';
  border-right: .1rem solid var(--hw-gray-200);
  margin-left: .5rem;
  margin-right: .5rem;
}

.hw-rating--value {
  color: var(--hw-white);
  padding-left: .4rem;
  padding-right: .4rem;
  border-radius: .4rem;
}

.hw-hotel--listItemt .icon-up {
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: var(--hw-white);
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(2px);
}



.hw-hotel--filterSearch {
  position: relative;
}

.hw-hotel--filterSearch .hw-form--input {
  padding: 0.8rem 4.5rem 0.8rem 1rem;
}

.hw-hotel--filterSearch .hw-form--input:hover,
.hw-hotel--filterSearch .hw-form--input:focus {
  border-color: var(--hw-brand-orange);
}

.hw-hotel--filterSearch svg {
  position: absolute;
  right: 1.6rem;
  top: 50%;
  transform: translateY(-50%);
  width: 2rem;
  height: 2rem;
  color: var(--hw-brand-orange);
}

.hw-hotel--Checkbox li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .6rem 0;
  column-gap: .5rem;
}

.hw-hotel--Checkbox li label {
  display: grid;
  align-items: center;
  column-gap: 1rem;
  grid-template-columns: auto 1fr;
  width: 100%;
}

.hw-hotel--asideFilter .hw-search--flightFilter__widget {
  background-color: var(--hw-white);
  border-radius: 0.5rem;
}

.hw-hotel--asideFilter .hw-hotel--Checkbox {
  padding-bottom: .5rem;
}

.hw-search--flightFilter__widgetContent .hw-hotel--filterSearch {
  margin-bottom: .5rem;
}

.hw-form--input.hw-input--outline:not(:hover),
.hw-form--input.hw-input--outline:not(:focus) {
  border-color: var(--hw-gray-200);
}

.hw-hotel--stars {
  color: var(--hw-star);
  line-height: 1;
  font-size: 2rem;
}

.hw-img--main img,
.hw-img--grid img {
  max-width: 100%;
}

.hw-gapx15 {
  row-gap: 1.5rem !important;
}

.hw-modal--hotelDetailsMap,
.hw-modal--hotelPopular {
  margin-top: 2.4rem;
  border-top: .1rem solid var(--hw-gray-400);
  padding-top: 2.4rem;
}

.hw-modal--hotelDetails .hw-modal--footer {
  background-color: var(--hw-gray-300);
  padding: 1.5rem;
}

.hw-modal--footer .hw-view--more {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  column-gap: 2rem;
  flex-shrink: 0;
}

.hw-modal--footer .hw-view--more .room {
  grid-row: 2;
}

.hw-modal--footer .hw-view--more .hw-btn {
  grid-row: span 2;
}

.hw-modal--hotelDetails .hw-modal-header {
  align-items: flex-start;
}

.hw-img--grid .hw-btn {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  z-index: 1;
  font-size: 1.4rem;
  padding: .7rem 1.5rem;
  line-height: 1.143;
}

.hw-btn.hw-btn--circleWhite {
  background-color: var(--hw-white);
  border-radius: 99.9rem;
  color: var(--hw-black);
  transition: all 0.2s ease;
  cursor: pointer;
  border: none;
  font-weight: 500;
  box-shadow: 0 0.2rem 0.8rem rgba(0, 0, 0, 0.1);
}

.hw-btn.hw-btn--circleWhite:hover {
  background-color: var(--hw-brand-orange-light);
  transform: translateY(-0.1rem);
  box-shadow: 0 0.4rem 1.2rem rgba(0, 0, 0, 0.15);
  color: var(--hw-blue-new);
}

.hw-icon--div svg {
  flex-shrink: 0;
}
.hw-icon--div{
  text-transform: capitalize;
}

/*Hotel popup*/
.hw-rating--tool {
  position: relative;
}

.hw-rating--toolTip {
  position: absolute;
  border-radius: 4px;
  background: var(--hw-white);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
  padding: .6rem 1rem;
  width: 100%;
  min-width: 22.4rem;
  right: -1.5rem;
  font-size: 1.2rem;
  line-height: 1.334;
  top: 50%;
  opacity: 0;
  transition:
    opacity .2s ease-out, top .2s ease-out;
}

.hw-rating--tool:hover .hw-rating--toolTip {
  opacity: 1;
  top: 60%;
  z-index: 1;
}

.hw-rating--toolTip b {
  color: var(--hw-black);
  font-weight: 500;
}

.hotel-content--block .hw-icon--div svg {
  width: 2.4rem;
  height: 2.4rem;
}

/*single*/
.hw-hotel--singleList__hotel .hotel-content {
  background-color: var(--hw-white);
  border-radius: 1rem;
  padding: 1.5rem;
  border: .1rem solid var(--hw-gray-400);
}

.hw-hotel--singleList__hotel .hotel-content+.hotel-content {
  margin-top: 1rem;
}

.hw-hotel--singleList__hotel .hotel-content> :not(:first-child) {
  margin-top: 1rem;
}

.hotel-content--block.heading.hw-price--wrap {
  position: relative;
  border-bottom: .1rem solid var(--hw-gray-200);
  padding-bottom: 1rem;
}

.hw-price--wrapHover {
  position: absolute;
  border-radius: 1rem;
  background-color: var(--hw-white);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
  padding: .5rem 1rem;
  left: 0;
  right: 0;
  top: calc(100% - 1.5rem);
  pointer-events: none;
  opacity: 0;
  transition: opacity .2s, top .2s;
}

.hotel-content--block.heading.hw-price--wrap:hover .hw-price--wrapHover {
  opacity: 1;
  top: calc(100% - 0.5rem);
  z-index: 1;
  pointer-events: visible;
}

.date-badge--show {
  display: inline-flex;
  background-color: rgba(var(--hw-blue-new-rgb), .1);
  padding: 1rem 2rem;
  border-radius: 2rem;
  align-items: center;
  column-gap: 2rem;
}

.hw-price--wrapHover .wrapHover-item {
  font-size: 1.4rem;
  line-height: 1.71429;
  display: grid;
  grid-template-columns: 1fr auto;
  padding: .5rem 1rem;
}

.arrow-ul {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  row-gap: .4rem;
  list-style: none;
}

.arrow-ul li {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: top .25em left;
  padding-left: 3rem;
  background-size: 2rem 2rem;
}

.cc-code {
  color: var(--hw-brand-orange);
  font-weight: inherit;
}

.wrapHover-itemGroup {
  background-color: var(--hw-gray-200);
  border-radius: 1rem;
  padding-top: .4rem;
  padding-bottom: .4rem;
}

.hw-hotel--singleList__hotel .hw-img--main,
.hw-hotel--singleList__hotel .hw-img--grid {
  position: relative;
  overflow: hidden;
  background-color: var(--hw-gray-200);
  border-radius: 1rem;
  height: 100%;
  min-height: 16rem;
}

.hw-hotel--singleList__hotel .hw-img--main img,
.hw-hotel--singleList__hotel .hw-img--grid img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hw-hotel--singleList__hotelGallery .row {
  --bs-gutter-x: 1rem;
}

.hw-sticky--scroller {
  position: sticky;
  z-index: 10;
  top: 11.1rem;
  overflow: hidden;

}

.hw-hotel--singleListScroller {
  display: flex;
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background-color: var(--hw-gray-100);
  column-gap: .5rem;
  overflow-x: auto;
}

.hw-hotel--singleListScrollerTab {
  border: .1rem solid var(--hw-gray-400);
  background-color: var(--hw-white);
  padding: .5rem .8rem;
  font-size: 1.6rem;
  line-height: 1.55556;
  color: var(--hw-black);
  font-weight: 500;
  text-transform: capitalize;
  border-radius: 99.9rem;
  min-width: 9.8rem;
  text-align: center;
  cursor: pointer;
  transition: border-color .2s ease-out;
}

.hw-hotel--singleListScrollerTab:hover {
  border-color: var(--hw-brand-orange);
}

.hw-section--box {
  background-color: var(--hw-white);
  border-radius: 1rem;
  padding: 1.6rem;
  border: .1rem solid var(--hw-gray-400);
}

.hw-hotel--singleListScrollerItem>.hw-hotel--singleListSection:not(:first-child) {
  padding-top: 4rem;
}

.hw-hotel--singleListOut {
  background-color: var(--hw-white);
  border: .1rem solid var(--hw-gray-400);
  border-radius: 1rem;
  padding: 1.5rem;
}

.hw-singleListOut--content {
  display: flex;
  flex-direction: column;
}

.hw-singleListOut--content .hw-hotel--filterResult__listItemSelect {
  padding-bottom: 2rem;
}

.hw-singleListOut--content>.hw-hotel--filterResult__listItemRightWrapper:not(:first-child) {
  border-top: .1rem solid var(--hw-gray-400);
}

.hw-singleListOut--content>.hw-hotel--filterResult__listItemRightWrapper:not(:first-child) .hw-hotel--filterResult__listItemInfo,
.hw-singleListOut--content>.hw-hotel--filterResult__listItemRightWrapper:not(:first-child) .hw-hotel--filterResult__listItemSelect {
  padding-top: 2rem;
}

.hw-section--box .box-ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
}

.hw-hotel--listItem__info .info-list svg,
.hw-hotel--facilitiesList .hw-icon--div svg {
  width: 2rem;
  height: 2rem;
  display: block;
}

.hw-hotel--facilitiesList .hw-icon--div svg {
  color: var(--hw-gray-800);
}

.hw-hotel--listItem__info .info-list {
  margin-top: 2rem;
  text-transform: capitalize;
}

.hw-hotel--singleListOut>.row {
  --bs-gutter-x: 2rem;
}

.hw-hotel--listItem__info .info-list+.info-list {
  border-top: .1rem solid var(--hw-gray-200);
  padding-top: 2rem;
}

.hw-hotel--singleListOut+.hw-hotel--singleListOut {
  margin-top: 2rem;
}

.hw-hotel--facilitiesPopular {
  padding-bottom: 2rem;
  border-bottom: .1rem solid var(--hw-gray-200);
  margin-bottom: 2rem;
}

.hw-amenity--chips {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.hw-amenity--chip {
  display: inline-flex;
  align-items: center;
  gap: .8rem;
  padding: .9rem 1.4rem;
  background: #f5f7fb;
  border: .1rem solid var(--hw-gray-200);
  border-radius: 10rem;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--hw-gray-900);
  text-transform: capitalize;
  transition: border-color .15s ease, background .15s ease;
}

.hw-amenity--chip:hover {
  background: var(--hw-brand-orange-light);
  border-color: var(--hw-blue-new);
}

.hw-amenity--chip svg {
  width: 1.8rem;
  height: 1.8rem;
  flex-shrink: 0;
  color: var(--hw-blue-new);
}

.hw-hotel--facilitiesList .no-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.hw-hotel--facilitiesList .no-list>li {
  margin-top: 1rem;
}

/* facilities: masonry columns so categories pack tightly (no big row gaps) */
.hw-hotel--facilitiesGrid {
  column-count: 4;
  column-gap: 2.4rem;
}
.hw-hotel--facilityCol {
  break-inside: avoid;
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
  margin-bottom: 2.8rem;
}
@media (max-width: 1199px) {
  .hw-hotel--facilitiesGrid {
    column-count: 3;
  }
}
@media (max-width: 767px) {
  .hw-hotel--facilitiesGrid {
    column-count: 2;
  }
}
@media (max-width: 479px) {
  .hw-hotel--facilitiesGrid {
    column-count: 1;
  }
}

.hw-section--box ul:not(:last-child) {
  margin-bottom: 2rem;
}

.hw-hotel--facilitiesList:not(.show)>.row {
  max-height: 14rem;
  overflow: hidden;
}

/* smooth expand/collapse of the extra facility categories */
.hw-hotel--facilitiesReveal {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.35s ease;
}
.hw-hotel--facilitiesReveal.is-open {
  grid-template-rows: 1fr;
}
.hw-hotel--facilitiesReveal__inner {
  min-height: 0;
  overflow: hidden;
}
.hw-hotel--facilitiesReveal.is-open .hw-hotel--facilitiesReveal__inner {
  padding-top: 2.8rem;
}

/* .hw-rating--graph {
  display: grid;
  row-gap: .5rem;
} */
.hw-rating--graphRow {
  display: flex;
  align-items: center;
  column-gap: 1rem;
}

.hw-rating--graphRow {
  display: flex;
  align-items: center;
  column-gap: 1rem;
}

.hw-rating--graphRow .hw-rating--graphBar {
  flex: 1 0 0;
  height: .4rem;
  background-color: var(--hw-gray-400);
  border-radius: .2rem;
  position: relative;
  overflow: hidden;
}

.hw-rating--graphBarProgress {
  position: absolute;
  top: 0;
  background-color: var(--hw-brand-orange);
  left: 0;
  height: 100%;
  border-radius: .2rem;
}

.rating-star {
  color: var(--hw-star);
  line-height: 0;
  font-size: 2rem;
}

.hw-graph--text {
  min-width: 1rem;
  text-align: center;
}

.hw-review--box {
  background-color: var(--hw-white);
  border: .1rem solid var(--hw-gray-400);
  border-radius: 1rem;
  padding: 2rem;
  min-height: 26.3rem;
}

.hw-review--top {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 1rem;
  align-items: center;
}

.hw-review--avtar {
  grid-row:
    span 2;
  background-color: var(--hw-brand-blue);
  width: 4rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--hw-white);
  font-family: var(--hw-head-font-family);
  font-size: 2.2rem;
  font-weight: 600;
  line-height: 0;
  border-radius: 99.9rem;
  overflow: hidden;
  padding: 1rem;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.hw-review--user {
  font-size: 1.8rem;
  line-height: 1.55556;
  font-weight: 500;
  color: var(--hw-black);
}

.overflowx-hidden {
  overflow-x: auto;
}

/*slider*/
.hw-rating--graphRow>.d-flex {
  line-height: 1.5;
}

.hw-review--slider {
  display: flex;
  overflow: hidden;
  column-gap: 2rem;
}

.hw-review--slider .hw-review--box {
  min-width: 25.8rem;
}

.hw-review--text:not(.hw-read--more) {
  max-height: 13rem;
  overflow: hidden;
}

/*End slider*/
.hw-hotel--recentSection .slick-list,
.hw-countryExplore--section .slick-list {
  margin-left: -1.2rem;
  margin-right: -1.2rem;
}

.hw-hotel--recentSection .slick-slider .slick-slide,
.hw-countryExplore--section .slick-slider .slick-slide {
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}

.hw-hotel--recentSection .slick-arrow {
  background-color: var(--hw-brand-blue-light);
  padding: .5rem 1rem;
  width: 4rem;
  height: 3rem;
  opacity: 1;
  margin: 0;
  top: -5.5rem;
  transform: translateY(0);
}

.hw-hotel--recentSection .slick-arrow.slick-prev {
  right: 5rem;
  left: auto;
  border-radius: 5rem 0 0 5rem;
}

.hw-hotel--recentSection .slick-arrow.slick-next {
  right: 0;
  border-radius: 0 5rem 5rem 0;
}

.hw-hotel--recentSection .slick-prev::before,
.hw-hotel--recentSection .slick-next::before {
  content: '';
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-size: 0;
  background-size: 2rem 2rem;
  width: 2rem;
  height: 2rem;
  display: block;
  background-position: center center;
  opacity: 1;
}

.hw-hotel--recentSection .slick-prev::before {
  transform: scaleX(-1);
}

.hw-hotel--recentSection .slick-arrow:hover {
  background-color: var(--hw-gray-100);
}

.hw-hotes-module .hw-input--input:not(.active):hover {
  border-color: var(--hw-brand-orange);
}

.hw-hotes-module .hw-input--multicityGroup {
  row-gap: .5rem;
}

.hw-hotel--singleList.hw-passenger--pageList {
  background-color: rgba(0, 0, 0, 0);
  grid-template-columns: 100%;
}

/* .hw-countryExplore--section .slick-list {
  padding-left: 10rem;
} */
.hw-rating--graph {
  overflow: hidden;
}

.hw-icon--divTop svg {
  margin-top: .2em;
}

.hw-section--box>.map-section {
  margin-top: 1.6rem;
}

.hw-loader--patchFix .hw-before-loader--status {
  left: 0;
}

.hw-hotelContact--listShow__widget .hw-passenger--detailsGroup #react-select-2-placeholder {
  white-space: nowrap;
  overflow: hidden;
}

.hw-hotel--singleListOut .hw-singleListOut--image .slick-slide img {
  border-radius: 1rem;
}

@media (min-width: 576px) {
  .hw-review--slider .hw-review--box {
    min-width: 41.8rem;
    min-height: 26.3rem;
  }

  .hw-hotel--singleListScroller {
    column-gap: 1rem;
  }

  .hw-modal--hotelDetails .hw-modal-dialog {
    max-width: 94.4rem;
  }

  .hw-modal--footer .room>span:not(:last-child)::after,
  .hw-hotel--filterResult__listItemSelect .room>span:not(:last-child)::after {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .hw-rating--sectionCol {
    min-height: 26.3rem;
    display: flex;
    flex-direction: column;
  }
}

@media (min-width: 768px) {
  .hw-section--box>.map-section {
    margin-top: 2rem;
  }

  .hw-hotel--singleListScroller {
    padding-top: 2rem;
    padding-bottom: 2rem;
    column-gap: 1.4rem;
  }

  .hw-hotel--singleListScrollerTab {
    padding: 1rem 1.6rem;
    font-size: 1.8rem;
  }

  .hw-modal--hotelDetails .hw-modal-header {
    padding: 2.4rem 2.4rem 1rem 2.4rem;
  }

  .hw-modal--hotelDetails .hw-modal-body {
    padding: 2.4rem;
  }

  .hw-modal--hotelDetails .hw-modal--footer {
    padding: 1.6rem 2.4rem;
  }

  .hw-hotel--singleList__hotel .hotel-content {
    border-radius: 2rem;
    padding: 2rem;
  }

  .hw-hotel--singleList__hotel .hotel-content> :not(:first-child) {
    margin-top: 1.5rem;
  }

  .hw-hotel--singleListOut>.row {
    --bs-gutter-x: 2rem;
  }

  .hw-singleListOut--content {
    border-left: .1rem solid var(--hw-gray-400);
  }

  .hw-review--text:not(.hw-read--more) {
    max-height: 11.6rem;
    overflow: hidden;
  }

  /* .hw-hotel--singleListOut>.row {
    align-items: flex-start;
  } */

  .hw-hotel--singleListOut .hw-singleListOut--image {
    position: sticky;
    top: 21rem;
    z-index: 1;
  }
}

@media (min-width: 901px) {
  .hw-hotel--singleListOut {
    border-radius: 2rem;
    padding: 2rem;
  }

  .hw-hotel--filterResultTop {
    padding-top: 2.4rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .hw-hotel--filterResult .hw-search--flightFilterResult__body {
    padding-left: 2rem;
  }

  .hw-hotel--filterResult {
    row-gap: 2rem;
  }

  /* .hw-hotel--filter__body {
  padding: 2rem 1.6rem;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
} */
}

@media (min-width: 992px) {

  .hw-hotel--singleList__hotel .hw-img--main,
  .hw-hotel--singleList__hotel .hw-img--grid {
    border-radius: 1.4rem;
  }

  .hw-hotel--singleListOut>.row {
    --bs-gutter-x: 4rem;
  }

  .hw-section--box {
    padding: 2.4rem;
  }
}

@media (min-width: 1080px) {
  .hw-singleListOut--content .hw-hotel--filterResult__listItemInfo {
    padding-left: 2rem;
    padding-bottom: 2rem;
  }

  .hw-singleListOut--content .hw-hotel--filterResult__listItemSelect {
    max-width: 30.8rem;
    width: 40%;
  }
}

@media (min-width: 1200px) {
  #hotel_guest_reviews>.row {
    --bs-gutter-x: 3rem;
  }
}

@media (min-width: 1400px) {

  .hw-hotel--singleList__hotel .hw-img--main,
  .hw-hotel--singleList__hotel .hw-img--grid {
    border-radius: 2rem;
  }

  .hw-hotel--singleList__hotel .hotel-content,
  .hw-hotel--singleListOut {
    padding: 2.4rem;
  }

  .hw-hotel--singleList__hotel .hotel-content> :not(:first-child) {
    margin-top: 2rem;
  }
}

@media (max-width: 991px) {
  .row.hw-hotel--singleList__hotel {
    row-gap: 1.5rem;
  }

  .hw-hotelContact--listShow__widget .hw-passenger--detailsGroup #react-select-2-placeholder {
    font-size: 1.4rem;
  }
}

@media (max-width: 767px) {
  .hw-modal--hotelDetailsTop .hw-text18 {
    font-size: 1.6rem;
    line-height: 1.5;
  }
}

@media (max-width: 599px) {
  .hw-modal--hotelDetails .hw-modal--footer>.d-flex {
    flex-direction: column;
    row-gap: .5rem;
  }

  .hw-modal--hotelDetails .hw-modal--footer>.d-flex>div {
    width: 100%;
  }

  .hw-sticky--scroller {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .hw-hotel--singleListScroller {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .hw-hotel--facilitiesPopular .hw-text20.hw-icon--div {
    font-size: 1.6rem;
    line-height: 1.75;
  }
}

@media (max-width: 479px) {
  .hw-modal--footer .hw-view--more .hw-btn {
    padding: .9rem 1.5rem !important;
  }

  .hw-hotel--recentSection .slick-arrow {
    top: -5rem;
  }

  .hw-hotel--singleList__hotel .hw-img--main,
  .hw-hotel--singleList__hotel .hw-img--grid {
    min-height: 10rem;
  }
}

/*End Hotel popup*/

@media (min-width: 901px) {
  .hide-up900 {
    display: none !important;
  }

  .filter-collapsed .hw-search--flightFilterResult__body .hw-before-loader--status {
    left: 32rem;
  }

  .hw-hotes-module>.hw-widget--card .hw-input--groupCol {
    row-gap: 1.6rem;
  }

  .hw-hotel--filterResult__listItem {
    padding: 1.6rem;
  }

  .hw-hotel--list {
    display: flex;
    flex: 1;
    align-items: flex-start;
  }

  .hw-hotel--asideFilter {
    width: 32rem;
    position: sticky;
    min-width: 32rem;
    max-height: calc(100dvh - 12rem);
    top: 12rem;
    /* border-right: .1rem solid var(--hw-gray-400); */
    min-height: calc(100dvh - 12rem);
    margin-top: 2.4rem;
  }

  .hw-hotel--asideFilter__top {
    position: sticky;
    top: 0;
    border-bottom: .1rem solid var(--hw-gray-400);
    z-index: 1;
  }

  .hw-rating--toolTip {
    right: -2rem;
  }
}

/* @media (min-width: 990px) {
  .hw-hotel--asideFilter {
    max-height: calc(100dvh - 9.6rem);
    top: 9.6rem;
    min-height: calc(100dvh - 9.6rem);
  }
} */

/* @media (min-width: 1240px) {
  .hw-hotes-module>.hw-widget--card .hw-input--groupCol {
    row-gap: 2.4rem;
  }
} */



@media (min-width: 1400px) {
  .hw-rating--toolTip {
    right: -2.4rem;
  }
}

@media (max-width: 1079px) {
  .hw-hotel--filterResult__listItemSelect .hw-mt--20 {
    margin-top: 1rem !important;
  }

  .hw-hotel--filterResult__location {
    font-size: 1.4rem;
    line-height: 1.71429;
  }

  .hw-hotel--filterResult__title {
    font-size: 1.8rem;
    line-height: 1.556;
  }
}

/* Prevent browser scroll anchoring from jumping when new hotel cards are added */
.hw-hotel--filterResult__list {
  overflow-anchor: none;
}

@media (min-width: 901px) and (max-width: 1079px) {
  .hw-hotel--filterResult__list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 1rem;
  }

  .hw-hotel--filterResult__listItem {
    flex-direction: column;
  }

  .hw-hotel--filterResult__listItemRightWrapper {
    flex-direction: column;
    row-gap: .5rem;
  }

  .hw-hotel--filterResult__listItemSelect {
    align-items: flex-start;
  }

  .hw-hotel--filterResult__listItemInfo {
    row-gap: .5rem;
    border-right-width: 0;
    padding-right: 0;
  }

  .hw-hotel--filterResult__listItem+.hw-hotel--filterResult__listItem {
    margin-top: 0;
  }
}

@media (min-width: 768px) and (max-width: 900px) {
  .hw-hotel--filterResult__listItemLeft {
    width: 33.33%;
    max-width: 28rem;
  }
}

@media (min-width: 1080px) {
  .hw-hotel--filterResult__listItemLeft {
    width: 33.33%;
    /* max-width: 28rem; */
    max-width: 24rem;
  }

  .hw-hotel--filterResult__listItemSelect {
    max-width: 22.1rem;
  }
  .hw-hotel--filterResult__listItemRightWrapper {
    align-items: flex-end;
  }
  .hw-singleListOut--content .hw-hotel--filterResult__listItemInfo {
      align-self: stretch;
  }
  .hw-hotel--filterResult__listItemRightWrapper .hw-hotel--filterResult__listItemSelect {
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}

@media (min-width: 1440px) {
  .hw-hotel--filterResult__listItemRightWrapper {
    column-gap: 4rem;
  }
}



@media (min-width: 901px) and (max-width: 1079px) {
  .hw-hotel--filterResult__listItemSelect .text-right {
    text-align: left !important;
  }

  .hw-hotel--filterResult__listItemSelect>* {
    width: 100%;
  }
}

@media (min-width: 480px) and (max-width: 900px) {
.hw-hotel--filterResult__listItemRightWrapper {
    align-items: flex-end;
  }
   .hw-singleListOut--content .hw-hotel--filterResult__listItemInfo {
      align-self: stretch;
  }
  .hw-hotel--filterResult__listItemRightWrapper .hw-hotel--filterResult__listItemSelect {
    position: sticky;
    bottom: 0;
  }
  .hw-hotel--filterResult__listItemRightWrapper > .hw-hotel--filterResult__listItemInfo {
  padding-bottom: 2rem;
}
}

@media (max-width: 900px) {
  .hide-down900 {
    display: none !important;
  }

  body.filter-collapsed {
    height: 100%;
    overflow: hidden;
  }

  .hw-hotel--asideFilter__top {
    position: fixed;
    border-top: .1rem solid var(--hw-gray-400);
    bottom: 0;
    left: 0;
    right: 0;
    top: auto;
    z-index: 11112;
  }

  .hw-hotel--filter__body {
    position: fixed;
    width: 100%;
    height: calc(100dvh + -5rem);
    background-color: rgba(0, 0, 0, 0.6);
    top: 0;
    z-index: 111111;
    left: 0;
    right: 0;
    transition: opacity 0.3s ease-in-out;
  }

  /* .filter-collapsed .hw-hotel--filter__body {
  display: flex;
} */
  body:not(.filter-collapsed) .hw-hotel--filter__body {
    opacity: 0;
    pointer-events: none;
  }

  .hw-hotel--asideFilter__top .hw-hotel--filter__action {
    background-color: var(--hw-brand-orange);
    color: var(--hw-white);
    cursor: pointer;
  }

  .hw-hotel--asideFilter__top .hw-hotel--filter__action .hw-hotel--filter__actionFilter,
  .hw-hotel--asideFilter__top .hw-no--link {
    color: inherit;
  }
}

@media (min-width: 480px) and (max-width: 899px) {
  .hw-hotel--filterResult__listItemSelect {
    max-width: 18.1rem;
  }
}

@media (max-width: 767px) {

.hw-hotel--singleListOut > .row > .hw-singleListOut--content {
  margin-top: 1.6rem;
}
  .hw-hotel--filterResult__listItem {
    background-color: var(--hw-white);
    border-radius: 1rem;
    padding: 1.5rem;
    display: flex;
    column-gap: 1.6rem;
    row-gap: 1rem;
    flex-direction: column;
  }
}

@media (max-width: 479px) {


  .hw-hotel--filterResult__listItemRightWrapper {
    flex-direction: column;
    row-gap: 1rem;
  }

  .hw-hotel--filterResult__listItemInfo {
    row-gap: .5rem;
    border-right-width: 0;
    padding-right: 0;
  }

  .hw-hotel--filterResult__listItemSelect {
    align-items: flex-start;
  }

  .hw-hotel--filterResult__listItemSelect .text-right {
    text-align: left !important;
  }

  .hw-hotel--filterResult__listItemSelect>* {
    width: 100%;
  }
}

/*Hotels List End*/

/*Hotel order section*/
.hw-hotel--steps {
  overflow: hidden;
  background-color: var(--hw-gray-100);
  display: grid;
}

.hw-hotel--steps .row {
  --bs-gutter-x: 2rem;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.hw-hotel--steps .row>.hw-step:not(:last-child)::after {
  content: '';
  background-color: var(--hw-gray-400);
  height: .2rem;
  min-width: 10rem;
  display: inline-flex;
  flex: 1;
}

.hw-hotel--steps .row>.hw-step.complete::after {
  background-color: var(--hw-green);
}

.radius-null {
  border-radius: 0 !important;
}

.hw-hotel--hotelDetails.hw-passenger--pageList {
  background-color: var(--hw-gray-100);
}

/* .hw-hotel--hotelDetails.hw-passenger--pageList .hw-flight--stepsWrapper {

  top: 11.1rem;
  position: relative;
} */
.hw-hotel--hotelDetails .hw-passenger--wrapper {
  background-color: rgba(0, 0, 0, 0);
}

.hw-hotel--hotelDetails .hw-passenger--fareSummary {
  border-radius: 1rem;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.10);
  margin-top: 1rem;
}


.hw-hotel--hotelDetails .hw-passenger--list .hw-passenger--head {
  border-bottom-width: 0;
}

.hw-primary--icon svg {
  color: var(--hw-brand-orange);
}

.hw-pointer {
  cursor: pointer;
}

.hw-hotel--hotelDetails .hw-passenger--listShow,
.hw-hotel--hotelDetails .hw-passenger--list .hw-passenger--head {
  padding-left: 0;
}

.hw-hotel--hotelDetails .hw-radio--inline {
  gap: 1.2rem;
}

.hw-radio--btnIcon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.hw-radio--btnIcon input[type="radio"] {
  border: .1rem solid var(--hw-brand-orange);
  min-width: 9.6rem;
  min-height: 4rem;
  border-radius: .4rem;
  outline: none !important;
  box-shadow: none !important;
  background: var(--hw-white);
  transition: .12s ease-in-out;
  cursor: pointer;
}

.hw-radio--btnIcon input[type="radio"]:hover {
  background-color: var(--hw-brand-orange-light);
  border-color: var(--hw-brand-orange-light);
}

.hw-radio--btnIcon input[type="radio"]:checked {
  background-color: var(--hw-brand-orange);
  border-color: var(--hw-brand-orange);
  color: var(--hw-white);
}

.hw-radio--btnText {
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: .4rem;
  color: var(--hw-brand-orange);
  font-weight: 500;
  pointer-events: none;
}

.hw-radio--btnIcon input[type="radio"]:checked~.hw-radio--btnText {
  color: var(--hw-white);
}

.hw-radio--btnText svg {
  width: 2rem;
  height: 2rem;
  display: block;
}

/* .hw-hotel--hotelDetails .hw-passenger--fareSummary__tfoot {
  border-top: .1rem solid var(--hw-gray-400);
  margin-left: 2rem;
  margin-right: 2rem;
  padding-left: 0;
  padding-right: 0;
} */
.hw-hotel--hotelDetails .hw-term--conditionInput {
  column-gap: 1rem;
}

.hw-hotel--bookingConfirmed {
  background-color: var(--hw-brand-blue);
  padding-top: 2rem;
  padding-bottom: 2rem;
  color: var(--hw-white);
}

.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary__box {
  padding: 0;
}

.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary {
  top: 0;
  margin-top: 0;
  background-color: rgba(0, 0, 0, 0) !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

.hw-hotel--summaryTotal {
  border-top: .1rem solid var(--hw-gray-200);
  padding-top: 1rem;
}

.hw-hotel-checkout--preview .hw-passenger--fareShowToggleContent {
  padding: 0;
  border-width: 0;
}

.hw-passenger--listShow__widget.hw-hotel-checkout--terms {
  padding: 0;
}

.hw-passenger--listShow__widget.hw-hotel-checkout--terms .hw-passenger--fareShowToggle {
  padding: 1.5rem;
}

.hw-passenger--listShow__widget.hw-hotel-checkout--terms .arrow-ul {
  padding: 1.5rem;
  border-top: .1rem solid var(--hw-gray-400);
}

.arrow-ul ul {
  list-style: none;
  padding: 0;
}

.hw-hotel-checkout--preview .hw-table--defaultDiv {
  margin-top: 0;
}

.hotel-loader {
  /* position: relative; */
  padding-top: 4rem;
  padding-bottom: 4rem;
  background-color: var(--hw-brand-orange-light);
}

.hw-before-loader--status.hotel {
  height: 100%;
}

/* Room Selection Loader - Simple Centered Spinner */
.hw-room-selection-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  background: transparent;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out, background 0.3s ease-in-out;
}

.hw-before-loader--status.hotel {
  height: 100%;
  z-index: 0;
  position: relative;
}

.hw-before-loader--status-half.hotel {
  z-index: 0;
  position: relative;
}

@media (min-width: 901px) {
  .hw-loader--text {
    font-size: 1.8rem;
  }

  .hw-before-loader--status,
  .hw-before-loader--status-half {
    left: 0 !important;
  }

  .filter-collapsed .hw-before-loader--status,
  .filter-collapsed .hw-before-loader--status-half {
    left: 7.4rem;
  }
}

.hw-room-selection-loader.show {
  opacity: 1;
  visibility: visible;
  background: rgba(242, 242, 242, 0.747);
}

.hw-room-selection-loader-spinner {
  width: 4.8rem;
  height: 4.8rem;
  border: 0.5rem solid var(--hw-brand-orange-light);
  border-top-color: var(--hw-brand-orange);
  border-radius: 50%;
  animation: hw-room-selection-spin 2s linear infinite;
}

@keyframes hw-room-selection-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Responsive adjustments for room selection loader */
@media (max-width: 768px) {
  .hw-room-selection-loader-spinner {
    width: 4rem;
    height: 4rem;
    border-width: 0.3rem;
  }
}

@media (max-width: 480px) {
  .hw-room-selection-loader-spinner {
    width: 3.6rem;
    height: 3.6rem;
    border-width: 0.3rem;
  }
}

.hw-hotelPassenger--listShow__widget .hw-passenger--detailsGroup {
  margin-top: 1.5rem;
}

.hw-hotelContact--listShow__widget .hw-passenger--fareShowToggleContent {
  padding: 0;
  border-top-width: 0;
}

.hw-hotelContact--listShow__widget .hw-passenger--detailsGroup {
  margin-top: 1.5rem;
}

@media (min-width: 480px) {
  .hw-passenger--listShow__widget.hw-hotel-checkout--terms .hw-passenger--fareShowToggle {
    padding: 2rem;
  }

  .hw-passenger--listShow__widget.hw-hotel-checkout--terms .arrow-ul {
    padding: 2rem;
  }
}

@media (min-width: 992px) {
  .hw-hotel--steps .row {
    --bs-gutter-x: 4rem;
  }

  .hw-hotel--hotelDetails .hw-passenger--fareSummary__box,
  .hw-hotel--hotelDetails .hw-passenger--listShow__widget {
    padding: 2rem;
  }
}

@media (max-width: 1024px) {

  .hw-hotel--hotelDetails .hw-passenger--listShow,
  .hw-hotel--hotelDetails .hw-passenger--list .hw-passenger--head {
    padding-right: 0;
  }

  .hw-hotel--hotelDetails .hw-passenger--fareSummary {
    position: relative;
    max-height: 100%;
  }

  .hw-hotel--bookingConfirmed {
    margin-bottom: 1rem;
  }
}

/* @media (min-width: 1025px) {
  .hw-hotel--hotelDetails .hw-passenger--fareSummary {
     top: 24rem;
  }
} */
/*End hotel order section*/


/*This design related header footer & structure changes*/
html,
body {
  min-height: 100dvh;
  height: auto;

  /* height: 100%; */
}

body>#root {
  display: grid;
  grid-template-columns: 100%;
  min-height: 100dvh;
  height: auto;

  /* display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 100%;
  min-height: 100%; */
  /* height: 100%; */
}

.hw-app--main {

  background-color: var(--hw-gray-100);
}

/*Header*/

.hw-main--menuItem {
  display: flex;
}

.hw-main--menuItemLink {
  display: inline-flex;
  align-items: center;
  column-gap: .8rem;
  color: var(--hw-gray-700);
  position: relative;
  font-weight: normal;
  cursor: pointer;
  font-size: 14px;
}

.hw-main--menuItemLink.show {
  color: var(--hw-brand-orange);
}

.hw-main--menuItemLink.show span {
  color: inherit !important;
}

.hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink.show::after {
  width: 100%;
}

.hw-main--menuItem.active .hw-main--menuItemLink {
  color: var(--hw-brand-orange);
}

.dropdown-menu .hw-main--menuItemLink {
  column-gap: 1rem;
}

.hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink::after {
  content: '';
  background-color: var(--hw-brand-orange);
  position: absolute;
  bottom: -1px;
  width: 0;
  height: .2rem;
  transition: width .2s ease-out;
}

.hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink:hover::after {
  width: 100%;
  transform-origin: right;
}

.hw-main--menuItemLink span {
  font-weight: bold;
  color: var(--hw-gray-700);
}

.dropdown-menu .hw-main--menuItemLink span {
  font-weight: 500;
}

.hw-main--menuItemLink:hover span {
  color: var(--hw-brand-orange);
}

.hw-main--menuItem.active .hw-main--menuItemLink span {
  color: var(--hw-brand-orange);
}




.pe-10 {
  padding-left: 1rem;
}

.hw-opacity7 {
  opacity: 0.7 !important;
}

.hw-nav--notification {
  cursor: pointer;
}

.hw-nav--notification .hw-nav--icon {
  color: var(--hw-brand-blue);
}

.header-nav .nav-item.dropdown>.nav-link.nav-currency {
  color: var(--hw-brand-blue);
}

.hw-main--menuItem.dropdown .dropdown-menu .hw-main--menuItemLink,
.hw-profile--dropdown .dropdown-menu .hw-main--menuItemLink {
  width: 100%;
}

.hw-main--menuItem.dropdown .dropdown-menu>.hw-main--menuItem:not(:first-child) .hw-main--menuItemLink,
.hw-profile--dropdown .dropdown-menu>.hw-main--menuItem:not(:first-child) .hw-main--menuItemLink {
  padding-top: 1rem;
}

.hw-header--wrapper .hw-main--menu>.hw-main--menuItem {
  position: relative;
}

.hw-header--wrapper .hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink {
  column-gap: 1.6rem;
  min-width: 5rem;
  row-gap: 0.4rem;
}

.hw-header--wrapper .hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink span {
  font-weight: bold;
  color: var(--hw-brand-blue);
}

.hw-header--wrapper .hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink .hw-main--menuIcon {
  width: 3.5rem;
  height: 3.5rem;
  color: var(--header-icon);
  transition: color 0.3s ease-out;
}

.hw-header--wrapper .hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink:hover .hw-main--menuIcon,
.hw-header--wrapper .hw-main--menu>.hw-main--menuItem.active>.hw-main--menuItemLink .hw-main--menuIcon {
  color: var(--header-icon-hover);
}

.new-menu--badge {
  border-radius: 2px;
  background: linear-gradient(90deg, #F696FF 0%, #8A38F5 100%);
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight: bold;
  color: var(--hw-white);
  min-height: 1.8rem;
  min-width: 5rem;
  text-align: center;
  max-width: 5rem;
}

.hw-header--avtar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  /*min-width: 9.6rem;*/
}
.hw-profile-text {
    display: flex;
    flex-direction: column;
    line-height: 1;
    white-space: nowrap;
}

.hw-avtar--circle {
  border-radius: 50%;
  background: linear-gradient(180deg, #3264FF -11%, #668BFF 111%);
  line-height: 1;
  font-weight: bold;
  color: var(--hw-white);
  width: 40px;
  height: 40px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* .hw-wallet--boxDropdown svg {
  position: absolute;
  right: 0;
  top: 0.7rem;
  width: 2.4rem;
  height: 2.4rem;
  display: block;
} */

.hw-main--menuItem .hw-main--menuIcon svg {
  display: block;
  width: 100%;
  height: 100%;
}
.hw-profile--dropdown::before{
      content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    background: var(--hw-gray-400);
    width: 1px;
    height: 100%;
    left: 0;
}

@media (min-width: 990px) {
  .hw-profile--dropdown {
    padding-left: 2.4rem;
  }
  .new-menu--badge {
    position: absolute;
    top: 0.4rem;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }

  .hw-header--wrapper .hw-main--menu>.hw-main--menuItem,
  .hw-header--wrapper .header-nav>ul {
    padding-top: 1.2rem;
  }

  .hw-header--avtar {
    row-gap: 0.4rem;
  }

  .hw-main--menu>.hw-main--menuItem.active>.hw-main--menuItemLink::after {
    width: 100%;
  }
}

/* .dropdown-menu.hw-header--dropdown {
  margin-top: -1rem !important;
} */

/*sidebar toggle*/
.hw-nav--profile.show .icon-chevronDown {
  transform: scaleY(-1);
}

.hw-wallet--amount {
  background-color: #E6EFFF;
  padding: 0.4rem 1.2rem;
  border-radius: 999px;
  white-space: nowrap;
  font-size: 1.2rem;
  line-height: 1.33333;
  color: var(--hw-brand-orange) !important;
  margin-left: 0.4rem;
  overflow: hidden;
}

@media (min-width: 1250px) {
  span.hw-wallet--amount {
    margin-left: 0.8rem;
  }

  .hw-toggle--sidebarBtn {
    display: none !important;
  }

  .hw-header--wrapper .hw-main--menu {
    flex: 1 0 0;
    padding-left: 1rem;
    padding-right: 1rem;
    justify-content: center;
  }

  .hw-main--menu {
    display: flex;
    column-gap: 1.6rem;
    flex-wrap: wrap;
  }

  .dropdown-menu .hw-main--menuItemLink {
    column-gap: 1.6rem;
  }

  .hw-header--wrapper .hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink {
    flex-direction: column;
    height: 100%;
    justify-content: center;
  }
}

@media (min-width: 990px) and (max-width: 1080px) {
  .hw-main--menuItemLink {
    font-size: 1.5rem;
  }
}

@media (min-width: 1200px) {
  .hw-header--wrapper .hw-main--menu {
    padding-right: 2.8rem;
  }

  .hw-main--menuItem.dropdown .dropdown-menu>.hw-main--menuItem:not(:first-child) .hw-main--menuItemLink,
  .hw-profile--dropdown .dropdown-menu>.hw-main--menuItem:not(:first-child) .hw-main--menuItemLink {
    padding-top: 1.6rem;
  }

  .hw-main--menu {
    column-gap: 2rem;
  }
}

@media (min-width: 1400px) {
  /* .hw-main--menu {
    column-gap: 3rem;
    justify-content: center;
  } */
}


@media (max-width: 1250px) {
  .sidebar-collapsed {
    height: 100%;
    overflow: hidden;
  }

  .hw-sidebar {
    transition: left .2s ease;
  }

  .hw-main--menu {
    position: fixed;
    top: 11rem;
    left: 0;
    bottom: 0;
    width: 95%;
    z-index: 1000;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: var(--hw-brand-orange-light) var(--hw-gray-100);
    background-color: var(--hw-white);
    border-top-right-radius: 1rem;
    max-width: 50rem;
    border-bottom-right-radius: 1rem;
    padding: 2rem !important;
    transition: left 0.3s ease-in-out, opacity 0.6s ease-in-out;
  }

  .hw-main--menu>.hw-main--menuItem {
    margin-bottom: 1rem;
    align-items: center;
    column-gap: 1rem;
  }

  .hw-main--menu>.hw-main--menuItem .hw-main--menuItemLink {
    /* width: 100%; */
    padding: 0.8rem 0;
  }

  .hw-main--menu>.hw-main--menuItem.dropdown .dropdown-menu {
    box-shadow: none !important;
    border-radius: 0;
    min-width: 26.1rem;
    border: none;
    padding: 0 0 0 2rem;
  }

  body:not(.sidebar-collapsed) .hw-sidebar {
    left: -26.5rem;
  }

  body:not(.sidebar-collapsed) .hw-main--menu {
    left: -26.5rem;
    pointer-events: none;
    opacity: 0;
  }

  .hw-toggle--sidebarBtn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
    margin-left: -1rem;
    cursor: pointer;
  }

  .hw-toggle--hamburg {
    display: block;
    width: 2rem;
    height: 2rem;
  }

  .hw-toggle--hamburg span {
    display: block;
    width: 1.8rem;
    height: .2rem;
    margin-bottom: .4rem;
    position: relative;
    background: var(--hw-black);
    transform-origin: 4px 0px;
    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0), background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0), opacity 0.55s ease;
  }

  .hw-toggle--hamburg>span:nth-of-type(3) {
    transform-origin: 0% 0%;
  }

  .sidebar-collapsed .hw-toggle--hamburg span {
    opacity: 1;
    transform: rotate(45deg) translate(1px, 1px);
  }

  .sidebar-collapsed .hw-toggle--hamburg span:nth-of-type(2) {
    opacity: 0;
    transform: rotate(0deg) scale(0.2, 0.2);
  }

  .sidebar-collapsed .hw-toggle--hamburg span:nth-of-type(3) {
    transform: rotate(-45deg) translate(0, -1px);
  }

  body:not(.sidebar-collapsed) .hw-menu--overlay {
    opacity: 0;
  }

  .hw-menu--overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(var(--hw-brand-blue-rgb), .5);
    z-index: 99;
    pointer-events: none;
    opacity: 1;
    transition: opacity .3s ease;
  }
}

@media (max-width: 599px) {
  .hw-mhide {
    display: none !important;
  }

  .hw-header--logo img {
    max-width: 30vw;
    max-height: 5rem;
  }

  .header-nav .pe-10 {
    padding-left: .5rem;
  }
}

@media (max-width: 900px) {
  /* compact, shrink-safe header: AED switcher never gets clipped */
  .hw-header--wrapper { gap: 8px; align-items: center; }
  .hw-header--wrapper .header-nav { flex: 0 1 auto; min-width: 0; }
  .header-nav > ul { gap: 8px; flex-wrap: nowrap; min-width: 0; }
  .header-nav > ul > li { min-width: 0; }
  .hw-profile--dropdown { min-width: 0; }
  .hw-nav--profile .hw-profile-text .hw-text14 {line-height: 2.4 !important; min-width: 0; }
  .hw-nav--profile { column-gap: 6px; min-width: 0;padding-right: 0 !important; }
  .hw-header--avtar { gap: 6px; min-width: 0; }
  .hw-avtar--circle { width: 32px; height: 32px; flex: none; }
  .hw-profile-text { min-width: 0; }
  .hw-nav--profile .hw-profile-text .hw-text12 { display: none; }
  .hw-nav--profile .hw-profile-text .hw-text14 { font-size: 1.3rem !important; line-height: 2.4 !important; min-width: 0; }
  .hw-nav--profile .hw-profile-text .hw-text14 > div { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .hw-profile--dropdown::before { display: none; }
  .hw-currency-switch-li { flex: 0 0 auto; }
}

@media (max-width: 575px) {
  /* phones: bar shows avatar + chevron + AED; balance moves to the avatar dropdown (My Wallet) */
  .hw-nav--profile .hw-profile-text .hw-text14 > div { display: none; }
}

@media (max-width: 479px) {
  .hw-input--switchGroup .hw-text14 {
    font-size: 1.2rem !important;
    line-height: normal;
  }
  .hw-header--logo img { max-width: 26vw; }
  .hw-avtar--circle { width: 30px; height: 30px; }
}

@media (max-width: 1250px) {
  /* hamburger layout: logo stays left, profile + currency pinned right (overrides the centered desktop grid) */
  .hw-header .hw-header--wrapper { display: flex; align-items: center; }
  .hw-header .hw-header--wrapper .header-nav { margin-left: auto; margin-right: 0; align-items: center; }
}

@media (min-width: 768px) and (max-width: 989px) {
  /* tablet / iPad: clean, overflow-safe (balance stays visible) */
  .hw-nav--profile .hw-profile-text .hw-text12 { display: none; }
  .hw-nav--profile { column-gap: 1rem; min-width: 0; }
  .hw-header--avtar { gap: 8px; min-width: 0; }
  .hw-header--wrapper .header-nav { min-width: 0; }
  .header-nav > ul { flex-wrap: nowrap; min-width: 0; }
  .header-nav > ul > li { min-width: 0; }
  .hw-nav--profile .hw-profile-text { min-width: 0; }
  .hw-nav--profile .hw-profile-text .hw-text14 > div { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .hw-currency-switch-li { flex: 0 0 auto; }
}

/*End sidebar toggle*/

/*End header*/

.hw-page--width {
  max-width: 144rem;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

@media (min-width: 600px) {
  .hw-page--width {
    padding-left: 3rem;
    padding-right: 3rem;
  }
}

@media (min-width: 1200px) {
  .hw-page--width {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}

@media (min-width: 1300px) {
  .hw-page--width {
    padding-left: 6rem;
    padding-right: 6rem;
  }
}

@media (min-width: 1400px) {
  .hw-page--width {
    padding-left: 10rem;
    padding-right: 10rem;
  }
}

/*End This design related header footer & structure changes*/
#hotel_guest_reviews .slick-list {
  margin-left: -1rem;
  margin-right: -1rem;
}

#hotel_guest_reviews .slick-slide {
  padding-left: 1rem;
  padding-right: 1rem;
}

.hw-passenger--listShow__widget.hw-hotel-checkout--terms {
  padding: 0;
}



/*Date-Picker Mobile*/
@media (max-width: 479px) {
  body main .react-datepicker {
    font-size: 1rem;
    border-radius: 0.4rem;
    padding: .2rem;
  }

  body main .react-datepicker__current-month,
  body main .react-datepicker-time__header,
  body main .react-datepicker-year-header {
    font-size: 1.2rem;
    line-height: 1.5;
  }

  body main .react-datepicker .react-datepicker__navigation {
    background-size: 1.8rem 1.8rem;
    width: 1.8rem;
    height: 1.8rem;
    top: 4px;
  }

  body main .react-datepicker__day-names {
    column-gap: 0;
    margin-bottom: -4px;
    margin-top: 0;
  }

  body main .react-datepicker__day-name {
    font-size: 1rem;
  }
}

@media (max-width: 360px) {
  body main .react-datepicker {
    font-size: 0.8rem;
    padding: .1rem;
  }

  body main .react-datepicker__current-month,
  body main .react-datepicker-time__header,
  body main .react-datepicker-year-header {
    font-size: 1rem;
  }

  body main .react-datepicker__day-name {
    font-size: 0.8rem;
  }

  body main .react-datepicker .react-datepicker__navigation {
    background-size: 1.4rem 1.4rem;
    width: 1.4rem;
    height: 1.4rem;
    top: 1px;
  }
}

/*End Date-Picker Mobile*/

/* Image Gallery Popup Styles */
.hw-gallery-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.hw-gallery-modal.show {
  opacity: 1;
  visibility: visible;
}

.hw-gallery-modal-dialog {
  width: 100%;
  /* max-width: 90vw; */
  max-width: clamp(50vw,90vw,80rem);
  max-height: 90vh;
  margin: 2rem;
  position: relative;
}

.hw-gallery-modal-content {
  background: var(--hw-white);
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  box-shadow: 0 2rem 6rem rgba(0, 0, 0, 0.3);
  overflow: hidden;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.hw-gallery-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.6rem;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.10);
  background: var(--hw-white);
  flex-shrink: 0;
}

.hw-gallery-modal-headerTitle {
  font-size: 2rem;
  font-weight: bold;
  color: var(--hw-brand-blue);
}

.hw-gallery-modal-close {
  background: none;
  border: none;
  padding: 0.8rem;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  color: #6b7280;
}

.hw-gallery-modal-close:hover {
  background-color: #f3f4f6;
  color: #374151;
}

.hw-gallery-modal-close svg {
  width: 2.4rem;
  height: 2.4rem;
}

.hw-gallery-modal-body {
  padding: 1.6rem;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  row-gap: 1.2rem;
}

.hw-gallery-main-image-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40rem;
  background: #f9fafb;
  border-radius: 1.2rem;
  overflow: hidden;
}

.hw-gallery-main-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hw-gallery-main-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 0.8rem;
  transition: transform 0.3s ease;
}

.hw-gallery-main-image img:hover {
  transform: scale(1.02);
}

.hw-gallery-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 4.8rem;
  height: 4.8rem;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 10;
  box-shadow: 0 0.4rem 1.2rem rgba(0, 0, 0, 0.15);
}

.hw-gallery-nav-btn:hover {
  background: rgba(255, 255, 255, 1);
  transform: translateY(-50%) scale(1.05);
  box-shadow: 0 0.6rem 1.8rem rgba(0, 0, 0, 0.2);
}

.hw-gallery-nav-btn svg {
  width: 2.4rem;
  height: 2.4rem;
  color: #374151;
}

.hw-gallery-nav-prev {
  left: 2rem;
}

.hw-gallery-nav-next {
  right: 2rem;
}

.hw-gallery-thumbnails {
  display: flex;
  gap: 1.2rem;
  overflow-x: auto;
  padding: 0.8rem 0;
  scrollbar-width: thin;
  scrollbar-color: #d1d5db #f3f4f6;
   scrollbar-width: none;      
  -ms-overflow-style: none;
}




.hw-gallery-thumbnails::-webkit-scrollbar {
  height: 0.8rem;
}

.hw-gallery-thumbnails::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 0.4rem;
}

.hw-gallery-thumbnails::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 0.4rem;
}

.hw-gallery-thumbnails::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

.hw-gallery-thumbnails::-webkit-scrollbar {
  display: none;               /* Chrome, Safari, Opera */
}

.hw-gallery-thumbnail {
  flex-shrink: 0;
  width: 8rem;
  height: 8rem;
  border-radius: 0.8rem;
  overflow: hidden;
  cursor: pointer;
  border: 0.2rem solid transparent;
  transition: all 0.2s ease;
  position: relative;
}

.hw-gallery-thumbnail:hover {
  border-color: #0062FF;
  transform: scale(1.05);
}

.hw-gallery-thumbnail.active {
  border-color: #0062FF;
  box-shadow: 0 0 0 0.2rem rgba(0, 98, 255, 0.2);
}

.hw-gallery-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s ease;
}

.hw-gallery-thumbnail:hover img {
  transform: scale(1.1);
}

.hw-gallery-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* z-index: 10000; */
  z-index: 99999;
  cursor: pointer;
}

/* Responsive Design */
@media (min-width: 768px) {
  .hw-gallery-modal-header {
   padding: 2rem 2.4rem;
}
.hw-gallery-modal-body {
  padding: 2.4rem;
}
}

@media (max-width: 768px) {
  .hw-gallery-modal-dialog {
    max-width: 95vw;
    margin: 1rem;
  }

 

  .hw-gallery-modal-headerTitle {
    font-size: 1.8rem;
  }

  .hw-gallery-modal-body {
    padding: 1.6rem;
    gap: 1.6rem;
  }

  .hw-gallery-main-image-container {
    min-height: 30rem;
  }

  .hw-gallery-nav-btn {
    width: 4rem;
    height: 4rem;
  }

  .hw-gallery-nav-btn svg {
    width: 2rem;
    height: 2rem;
  }

  .hw-gallery-nav-prev {
    left: 1rem;
  }

  .hw-gallery-nav-next {
    right: 1rem;
  }

  .hw-gallery-thumbnail {
    width: 6rem;
    height: 6rem;
  }
}

@media (max-width: 480px) {
  .hw-gallery-modal-dialog {
    max-width: 98vw;
    margin: 0.5rem;
  }




  .hw-gallery-modal-body {
    padding: 1.2rem;
    gap: 1.2rem;
  }

  .hw-gallery-main-image-container {
    min-height: 25rem;
  }

  .hw-gallery-nav-btn {
    width: 3.6rem;
    height: 3.6rem;
  }

  .hw-gallery-nav-btn svg {
    width: 1.8rem;
    height: 1.8rem;
  }

  .hw-gallery-thumbnail {
    width: 5rem;
    height: 5rem;
  }
}

/* Animation for popup */
@keyframes galleryFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.hw-gallery-modal.show .hw-gallery-modal-content {
  animation: galleryFadeIn 0.3s ease-out;
}

/* Touch-friendly navigation for mobile */
@media (hover: none) and (pointer: coarse) {
  .hw-gallery-nav-btn {
    width: 5.6rem;
    height: 5.6rem;
  }

  .hw-gallery-nav-btn svg {
    width: 2.8rem;
    height: 2.8rem;
  }

  .hw-gallery-thumbnail {
    width: 7rem;
    height: 7rem;
  }
}

/* Gallery Zoom Styles */
.hw-gallery-clickable-image {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.hw-gallery-clickable-image:hover {
  transform: scale(1.02);
}

.hw-gallery-zoom-hint {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 0.6rem 1.2rem;
  border-radius: 2rem;
  font-size: 1.2rem;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.hw-gallery-main-image:hover .hw-gallery-zoom-hint {
  opacity: 1;
}

/* Full Screen Zoom Overlay */
.hw-gallery-zoom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.95);
  z-index: 99999990;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: zoomFadeIn 0.3s ease-out;
}

.hw-gallery-zoom-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.hw-gallery-zoom-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 3rem;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8), transparent);
  z-index: 10;
}

.hw-gallery-zoom-title {
  color: white;
  font-size: 1.8rem;
  font-weight: 600;
}

.hw-gallery-zoom-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  padding: 1rem;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: white;
}

.hw-gallery-zoom-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.hw-gallery-zoom-close svg {
  width: 2.4rem;
  height: 2.4rem;
}

.hw-gallery-zoom-image-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 8rem 3rem 12rem 3rem;
}

.hw-gallery-zoom-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.hw-gallery-zoom-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 0.8rem;
  transition: transform 0.3s ease;
  box-shadow: 0 2rem 6rem rgba(0, 0, 0, 0.5);
}

.hw-gallery-zoom-image img:hover {
  transform: scale(1.02);
}

.hw-gallery-zoom-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 10;
  color: white;
}

.hw-gallery-zoom-nav-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-50%) scale(1.1);
}

.hw-gallery-zoom-nav-btn svg {
  width: 3rem;
  height: 3rem;
}

.hw-gallery-zoom-nav-prev {
  left: 3rem;
}

.hw-gallery-zoom-nav-next {
  right: 3rem;
}

.hw-gallery-zoom-instructions {
  position: absolute;
  bottom: 3rem;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.4rem;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  padding: 1rem 2rem;
  border-radius: 2rem;
  backdrop-filter: blur(10px);
}

@keyframes zoomFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsive Zoom Styles */
@media (max-width: 768px) {
  .hw-gallery-zoom-header {
    padding: 1.5rem 2rem;
  }

  .hw-gallery-zoom-title {
    font-size: 1.6rem;
  }

  .hw-gallery-zoom-image-container {
    padding: 6rem 2rem 10rem 2rem;
  }

  .hw-gallery-zoom-nav-btn {
    width: 5rem;
    height: 5rem;
  }

  .hw-gallery-zoom-nav-btn svg {
    width: 2.5rem;
    height: 2.5rem;
  }

  .hw-gallery-zoom-nav-prev {
    left: 2rem;
  }

  .hw-gallery-zoom-nav-next {
    right: 2rem;
  }

  .hw-gallery-zoom-instructions {
    font-size: 1.2rem;
    padding: 0.8rem 1.6rem;
    bottom: 2rem;
  }
}

@media (max-width: 480px) {
  .hw-gallery-zoom-header {
    padding: 1rem 1.5rem;
  }

  .hw-gallery-zoom-title {
    font-size: 1.4rem;
  }

  .hw-gallery-zoom-image-container {
    padding: 5rem 1.5rem 8rem 1.5rem;
  }

  .hw-gallery-zoom-nav-btn {
    width: 4.5rem;
    height: 4.5rem;
  }

  .hw-gallery-zoom-nav-btn svg {
    width: 2.2rem;
    height: 2.2rem;
  }

  .hw-gallery-zoom-nav-prev {
    left: 1.5rem;
  }

  .hw-gallery-zoom-nav-next {
    right: 1.5rem;
  }

  .hw-gallery-zoom-instructions {
    font-size: 1.1rem;
    padding: 0.6rem 1.2rem;
    bottom: 1.5rem;
  }
  .hw-header-line {display: none !important;}
}

/* Hotel Gallery Image Styles */
.hw-hotel--imageGallery .hw-img--main,
.hw-hotel--imageGallery .hw-img--grid {
  position: relative;
  overflow: hidden;
  background-color: var(--hw-gray-100);
  border-radius: 1rem;
}

.hw-hotel--imageGallery .hw-img--main img,
.hw-hotel--imageGallery .hw-img--grid img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* .hw-hotel--imageGallery .hw-img--main {
  aspect-ratio: 4/3;
} */

.hw-hotel--imageGallery .hw-img--grid {
  height: 100%;
  min-height: 9rem;
}

.row.hw-hotel--imageGallery {
  row-gap: 1rem;
}



/*New flight design*/
.hw-top--fixImg {
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  overflow: hidden;

}

.hw-excursion-banner-img {
  height: 436px;
  /* background-image: url('../../../assets/img/excursion-banner-img.jpg'); */
}
.hw-excursion-banner-title{
  color: var(--White, #FFF);
font-family: Poppins;
font-size: 35px;
font-style: normal;
font-weight: 600;
line-height: normal;
max-width: 500px;
}

.hw-top--fixImg img {
  width: 100%;
  object-fit: cover;
  display: block;
  height: 100%;
}

.hw-widget.hw-widget--flight:not(.hw-widget--flight__open) {
  margin-top: 4.8rem;
}

.hw-widget.hw-widget--flight .hw-widget--card {
  background-color: var(--hw-white);
  position: relative;
}

.hw-widget.hw-widget--flight .hw-input--groupCol {
  padding: 0;
}

.hw-recent--viewedList {
  margin-top: 1.6rem !important;
  display: flex;
  column-gap: 2.4rem;
  overflow-x: auto;
  padding-bottom: 1.4rem !important;
}

.hw-recent--viewedList li,
.hw-recent--viewedList .swiper-slide {
  border: 1px solid rgba(var(--hw-brand-orange-rgb), 0.2);
  padding: 1.6rem;
  border-radius: 0.5rem;
  min-width: 38.1rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: 0.6rem;
  /* max-height: 13rem;
  overflow-y: auto; */
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.hw-recent--viewedList .swiper-slide:hover {
  border-color: var(--hw-brand-orange);
}

.hw-recent--innerList+.hw-recent--innerList {
  border-top: 1px solid var(--hw-gray-200);
  margin-top: 0.6rem;
  padding-top: 0.6rem;
}

.hw-twoLine--iconFilter {
  display: flex;
  width: 100%;
}

.hw-flight--cTab {
  background-color: var(--hw-white);
  padding: 0.1rem 1rem 0.6rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;
  /* flex-grow: 1; */
}

.hw-twoLine--iconFilter>.hw-flight--cTab:first-child {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.hw-twoLine--iconFilter>.hw-flight--cTab:last-child {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

/* .hw-flight--cTab::before {
  content: '';
  position: absolute;
  width: 0;
  height: 0.4rem;
  background-color: var(--hw-brand-orange);
  left: 0;
  bottom: 0px;
  transition: width 0.2s linear;
} */

.hw-flight--cTab.active,
.hw-flight--cTab:hover {
  background-color: var(--hw-brand-blue-light);
}

.hw-flight--cTab.active {
  background: linear-gradient(90deg, #3264FF 21.17%, #1846D6 82.33%);
}
.hw-flight--cTab.active .hw-black900 {
  color: var(--hw-white) !important;
}
.hw-flight--cTab.active .hw-no-price {
  color: var(--hw-white);
  opacity: 0.8;
}

/* .hw-flight--cTab.active::before {
  width: 100%;
} */

.hw-twoLine--iconFilter>.hw-flight--cTab:not(:last-child) {
  border-right: 1px solid var(--hw-gray-600);
}

.hw-search--flightFilter__stops {
  display: flex;
  flex-direction: column;
  /* row-gap: 0.8rem; */
  row-gap: 0.2rem;
}

.hw-search--flightFilter__widget.stops-widget {
  margin-top: 1rem;
}

.hw-search--flightFilter__stops>span {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  cursor: pointer;
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: 0.8rem;
  color: var(--hw-black-900);
  font-size: 1.4rem;
  line-height: 1.71429;
}

.hw-search--flightFilter__stops>span::before {
  content: '';
  border: 1px solid var(--hw-gray-700);
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 0.4rem;
  background-color: var(--hw-white);
}

.hw-search--flightFilter__stops>span.active::before {
  --hw-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-color: var(--hw-brand-orange);
  border-color: var(--hw-brand-orange);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-image: var(--hw-form-check-bg-image);
}

.hw-search--flightCheckbox .hw-grid--2auto {
  grid-template-columns: auto 1fr;
}

.hw-flight--listBoxAction {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.hw-flight--listOut .f-place {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.1rem;
}

.hw-flight--listOut {
  display: flex;
  column-gap: 1.2rem;
  position: relative;
}

.hw-flight--marker {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 12px;
}

.hw-flight--marker .dot {
  width: 1rem;
  height: 1rem;
  background-color: rgba(18, 24, 38, 0.30);
  border-radius: 50%;
  position: relative;
  margin-top: 7px;
}

.hw-flight--marker .line {
  width: 2px;
  background-color: var(--hw-black);
  flex-grow: 1;
  opacity: 0.3;
  margin-top: 7px;
}

@media (min-width: 600px) {
  .hw-flight--listOut {
    column-gap: 2.4rem;
  }

  .hw-flight--listBox .destination .destination-from,
  .hw-flight--listBox .destination .destination-to {
    width: 9rem;
  }

  .hw-flight--marker .dot {
    width: 1.4rem;
    height: 1.4rem;
  }

  .hw-flight--listOut .f-place {
    margin-top: 0.4rem;
  }
  .hw-flight--cTab {
  padding: 0.5rem 2rem 1rem;
  /* min-width: 22.5rem; */
  min-width: 14rem;
}
}

@media (min-width: 1101px) {
  .hw-flight--listBoxAction {
    flex-direction: column;
  }

  .hw-flight--listBox .destination {
    max-width: 62.6rem;
  }
}

@media (max-width: 1100px) {
  .hw-flight--listBoxAction {
    width: 100%;
    justify-content: space-between;
  }
}

@media (max-width: 599px) {
  /* .hw-twoLine--iconFilter {
    flex-wrap: wrap;
  } */

  .hw-twoLine--iconFilter>.hw-flight--cTab:not(:last-child) {
    border-right-width: 0;
  }

  .hw-flight--cTab {
    flex-grow: 1;
  }

  .hw-search--flightFilterResult>h3 {
    font-size: 2rem;
    line-height: 1.5;
  }
}

@media (max-width: 479px) {
  .hw-twoLine--iconFilter > .hw-flight--cTab .hw-no-price {
    line-height: 1.25;
  }
}

/*Flight Popup - Modern Redesign*/
.hw-modal--flightBook .hw-modal-dialog {
  max-width: 100rem;
  width: 95%;
}

.hw-modal--flightBook .hw-modal-content {
  border-radius: 1.2rem;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.15);
  background-color: var(--hw-white);
}

.hw-fare-modal-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem 2.4rem 1.2rem;
  background-color: #ffffff;
  border-bottom: 1px solid #f1f5f9;
}

.hw-fare-modal-title {
  font-size: 2.5rem;
  font-weight: 600;
  color: var(--hw-brand-blue);
  margin: 0;
}

.hw-fare-header-close {
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  padding: 0.6rem;
  border-radius: 50%;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.hw-fare-header-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

/* Collapsible Flight Details Strip matching Reference Image */
.hw-fare-collapse-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 2.4rem;
  background-color: #ffffff;
  cursor: pointer;
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.2s ease;
  user-select: none;
}

.hw-fare-collapse-bar:hover {
  background-color: #f8fafc;
}

.hw-fare-collapse-bar.return-bar {
  border-top: 1px dashed #e2e8f0;
}

.hw-fare-collapse-bar-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  font-size: 1.35rem;
  color: #334155;
  line-height: 1.3;
}

.hw-fare-header-airline-img {
  width: 2.4rem;
  height: 2.4rem;
  object-fit: contain;
  border-radius: 4px;
}

.hw-fare-collapse-airline {
  font-weight: 500;
  color: #1e293b;
  margin-right: 0.2rem;
}

.hw-fare-collapse-station {
  font-weight: 700;
  color: #0f172a;
  font-size: 1.45rem;
}

.hw-fare-collapse-blue-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #2563eb;
  margin: 0 0.1rem;
}

.hw-fare-collapse-blue-arrow svg {
  stroke: #2563eb !important;
}

.hw-fare-collapse-meta-text {
  font-weight: 400;
  color: #475569;
}

.hw-fare-collapse-dot {
  color: #94a3b8;
  font-size: 1.3rem;
  margin: 0 0.1rem;
}

.hw-fare-collapse-toggle-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0f172a;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0.4rem;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s ease;
}

.hw-fare-collapse-toggle-icon.is-open {
  transform: rotate(180deg);
}

.hw-fare-collapse-toggle-icon:hover {
  color: #2563eb;
}

/* Smooth Accordion Drawer Transitions */
.hw-fare-drawer-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.38s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.hw-fare-drawer-wrapper.is-open {
  grid-template-rows: 1fr;
}

.hw-fare-drawer-inner {
  min-height: 0;
  overflow: hidden;
}

.hw-fare-drawer-wrapper .hw-fare-itinerary-drawer {
  opacity: 0;
  transform: translateY(-8px);
  transition: opacity 0.3s ease, transform 0.38s cubic-bezier(0.4, 0, 0.2, 1);
}

.hw-fare-drawer-wrapper.is-open .hw-fare-itinerary-drawer {
  opacity: 1;
  transform: translateY(0);
}

/* Collapsible Itinerary Drawer */
.hw-fare-itinerary-drawer {
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  padding: 2.2rem 2.4rem 2.6rem;
  /* margin-bottom: 2rem; */
  max-height: 48rem;
  overflow-y: auto;
}

.hw-itinerary-combo-section:not(:first-child) {
  margin-top: 2rem;
  padding-top: 1.6rem;
  border-top: 1px dashed #e2e8f0;
}

.hw-itinerary-section-heading {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2563eb;
  margin-bottom: 1.4rem;
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

/* ========================================================
   Clean Vertical Itinerary Timeline (matching Reference Image)
   ======================================================== */
.hw-flight-timeline {
  position: relative;
  padding: 0.6rem 0 0.6rem 3rem;
  display: flex;
  flex-direction: column;
}

/* Continuous vertical track */
.hw-flight-timeline::before {
  content: '';
  position: absolute;
  left: 0.9rem;
  top: 0.4rem;
  bottom: 0.4rem;
  width: 2px;
  background-color: #cbd5e1;
}

.hw-tl-step {
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
}

.hw-tl-step:last-child {
  margin-bottom: 0;
}

.hw-tl-step.is-layover-step {
  margin-bottom: 2rem;
  justify-content: center;
}

/* Timeline Nodes */
.hw-tl-node {
  position: absolute;
  left: -2rem;
  top: 1.1rem;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  box-sizing: border-box;
  z-index: 2;
}

/* Start & End Nodes: Navy circle with light halo ring */
.hw-tl-node.is-start,
.hw-tl-node.is-end {
  width: 1.4rem;
  height: 1.4rem;
  background-color: #0f172a;
  border: 3px solid #e2e8f0;
}

/* Mid Nodes: Solid light gray dot */
.hw-tl-node.is-mid {
  width: 1rem;
  height: 1rem;
  background-color: #cbd5e1;
}

/* Layover Node: Solid amber dot, vertically centered with the banner */
.hw-tl-step.is-layover-step .hw-tl-node.is-layover {
  top: 50%;
  width: 1rem;
  height: 1rem;
  background-color: #f59e0b;
}

/* Main Row: Datetime, Airport Code, Airport Name, Terminal */
.hw-tl-main-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.9rem;
  line-height: 1.3;
}

.hw-tl-datetime {
  display: inline-flex;
  align-items: baseline;
  line-height: 1.2;
}

.hw-tl-date {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
}

.hw-tl-date.is-next-day {
  color: #0f172a;
}

.hw-tl-comma {
  font-size: 1.55rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0.4rem 0 0.1rem;
}

.hw-tl-time {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.01em;
  white-space: nowrap;
}

.hw-tl-code {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.hw-tl-name {
  font-size: 1.4rem;
  font-weight: 500;
  color: var(--hw-brand-blue);
}

.hw-tl-terminal-badge {
  font-size: 1.15rem;
  font-weight: 600;
  color: #64748b;
  background-color: #f1f5f9;
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
  line-height: 1.2;
}

/* Sub Row: Airline · FlightNumber • Flight time */
.hw-tl-sub-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-top: 0.5rem;
  font-size: 1.3rem;
  color: #64748b;
  line-height: 1.3;
}

.hw-tl-airline-info {
  font-weight: 500;
  color: var(--hw-brand-blue);
}

.hw-tl-bullet {
  color: var(--hw-brand-blue);
  font-size: 1.1rem;
}

.hw-tl-duration-info {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--hw-brand-blue);
  font-weight: 500;
}

.hw-tl-clock-icon {
  color: var(--hw-brand-blue);
  flex-shrink: 0;
}

/* Layover Amber Banner */
.hw-tl-layover-banner {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  max-width: 450px;
  background-color: #fffdf5;
  border: 1px solid #fef3c7;
  border-radius: 8px;
  padding: 1.1rem 1.6rem;
  box-sizing: border-box;
  gap: 1.2rem;
}

.hw-tl-layover-left {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex-wrap: wrap;
}

.hw-tl-layover-clock {
  color: #d97706;
  flex-shrink: 0;
}

.hw-tl-layover-text {
  font-size: 1.35rem;
  font-weight: 600;
  color: #78350f;
}

.hw-tl-layover-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #fef3c7;
  color: #b45309;
  border-radius: 6px;
  padding: 0.4rem 0.9rem;
  font-size: 1.2rem;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.hw-modal--flightBook .hw-modal-body {
  padding: 1.8rem 2.4rem 2.4rem !important;
  padding-top: 0 !important;
  background-color: #fbfcfd;
}

.hw-modal--bodyFares {
  padding-top: 0;
  position: relative;
}

/* Modern Fare Cards matching Image 2 */
.hw-fare--slider .swiper-slide {
  min-width: 28rem !important;
  max-width: 31rem !important;
  border: 1px solid #e2e8f0;
  border-radius: 0.8rem;
  background-color: #ffffff;
  transition: all 0.2s ease;
  overflow: hidden;
}

.hw-fare--slider .swiper-slide:hover {
  border-color: var(--hw-brand-orange, #ff4f17);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

/* .hw-fare--slideItem.is-selected,
.hw-fare--slider .swiper-slide:has(.is-selected) {
  border: 2px solid #008cff !important;
  box-shadow: 0 4px 16px rgba(0, 140, 255, 0.15) !important;
} */

.hw-fare--slideItem {
  height: 100%;
}

.hw-fare--slideBox {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
}

.hw-fare--slideItem .b-top {
  display: flex;
  flex-direction: column;
  padding: 1.6rem 1.6rem 1.2rem;
  border-bottom: 1px solid #f1f5f9;
  background: #ffffff;
}

.hw-fare--slideItem .b-top--header-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
}

.hw-fare--slideItem .hw-price-amount {
  font-size: 2.2rem;
  font-weight: 800;
  color: #111827;
  line-height: 1.2;
}

.hw-fare--slideItem .hw-per-adult {
  font-size: 1.2rem;
  color: #6b7280;
  font-weight: 500;
  margin-left: 0.6rem;
}

.hw-fare-card-badge {
  border: 1px solid var(--hw-brand-orange);
  color: var(--hw-brand-orange);
  font-size: 1.05rem;
  font-weight: 700;
  border-radius: 4px;
  padding: 0.2rem 0.6rem;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  background: #ffffff;
  white-space: nowrap;
}

.hw-fare-identifier {
  font-size: 1.3rem;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 0.4rem;
}

.hw-fare--slideBox .b-middle {
  padding: 1.4rem 1.6rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}

.hw-fare--slideBox .b-section {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.hw-fare--slideBox .b-middle .b-mmiddle--title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
  text-transform: capitalize;
}

.hw-fare--slideBox .b-mmiddle--list {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  font-size: 1.25rem;
  color: #374151;
  line-height: 1.6;
  margin: 0;
}

.hw-fare-icon-green,
.hw-fare-icon-amber,
.hw-fare-icon-red {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 0.2rem;
}

.hw-text-teal {
  color: #0d9488;
  font-weight: 700;
}

.b-bundle-box {
  background: #fffbeb;
  border: 1px solid #fef3c7;
  border-radius: 6px;
  padding: 0.8rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: #92400e;
}

.hw-fare--slideBox .b-footer {
  padding: 1.4rem 1.6rem 1.6rem;
  background: #ffffff;
  /* border-top: 1px solid #f8fafc; */
}

.hw-btn--book-now {
  background: rgba(50, 100, 255, 0.10) !important;
  color: var(--hw-brand-orange) !important;
  font-weight: 700 !important;
  font-size: 1.4rem !important;
  padding: 1.2rem 1.6rem !important;
  border-radius: 6px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border: none !important;
  transition: all 0.2s ease;
  width: 100%;
}

.hw-btn--book-now:hover {
  background: var(--hw-blue-new) !important;
  color: #ffffff !important;
}

.hw-btn--selected-fare {
  background: var(--hw-blue-new) !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 1.4rem !important;
  padding: 1.2rem 1.6rem !important;
  border-radius: 6px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border: none !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
}

/* Swiper top-right navigation buttons - placed side-by-side near each other */
.hw-fare--slider {
  position: relative;
}

.hw-fare--slider .swiper {
  position: relative;
  padding-top: 4.8rem !important;
  padding-bottom: 1.6rem;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
}

.hw-fare--slider .swiper-button-prev,
.hw-fare--slider .swiper-button-next {
  position: absolute !important;
  top: 0.4rem !important;
  bottom: auto !important;
  margin-top: 0 !important;
  transform: none !important;
  width: 3.6rem !important;
  height: 3.6rem !important;
  border-radius: 50% !important;
  background-color: #ffffff !important;
  border: 1.5px solid #e2e8f0 !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
  z-index: 25 !important;
  cursor: pointer !important;
  outline: none !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  background-size: 1.8rem 1.8rem !important;
  transition: all 0.2s ease !important;
  font-size: 0 !important;
}

.hw-fare--slider .swiper-button-prev::after,
.hw-fare--slider .swiper-button-next::after {
  display: none !important;
}

/* Prev button: placed near next button on the top right */
.hw-fare--slider .swiper-button-prev {
  left: auto !important;
  right: 4.8rem !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) !important;
}

/* Next button: placed at right side top corner */
.hw-fare--slider .swiper-button-next {
  left: auto !important;
  right: 0.6rem !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) !important;
}

.hw-fare--slider .swiper-button-prev:hover {
  background-color: #f8fafc !important;
  border-color: #2563eb !important;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.18) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) !important;
}

.hw-fare--slider .swiper-button-next:hover {
  background-color: #f8fafc !important;
  border-color: #2563eb !important;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.18) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) !important;
}

/* Disabled state */
.hw-fare--slider .swiper-button-prev.swiper-button-disabled,
.hw-fare--slider .swiper-button-next.swiper-button-disabled {
  opacity: 0.3 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
  background-color: #f1f5f9 !important;
  border-color: #e2e8f0 !important;
  box-shadow: none !important;
}

.hw-search--flightListBottomFooter {
  /* position: sticky; */
  position: fixed;
  bottom: 5.2rem;
  left: 0;
  right: 0;
  z-index: 101;
  background-color: var(--hw-brand-blue-light);
  min-height: 6.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* .hw-flight--listBoxInner.hw-mlCity {
  max-width: 57.6rem;
} */

.hw-fare--slider .swiper-container {
  user-select: none;
  /* Prevent text selection */
}

.hw-fare--slider .swiper-slide {
  user-select: none;
  /* Prevent text selection */
}

.hw-fare--slider {
  /* margin-top: 1.2rem; */
}

@media (min-width: 576px) {
  /* .hw-modal--flightBook .hw-modal-dialog {
    --bs-modal-width: 97.4rem;
  max-width: var(--bs-modal-width);
  } */
}

@media (min-width: 768px) {
  .hw-widget.hw-widget--flight:not(.hw-widget--flight__open) {
    margin-top: 11rem;
  }

  .hw-modal--flightBook .hw-modal-body {
    padding: 1.8rem 2.4rem 2.4rem;
  }

  .hw-fare--slider {
    /* margin-top: 1.4rem; */
    margin-left: 0;
  }

  .hw-fare--slider .swiper {
    padding: 4.8rem 0.4rem 1.6rem !important;
  }

  .hw-modal--bodyFares {
    margin-right: 0;
  }
}

@media (min-width: 901px) {
  .hw-search--flightListBottomFooter {
    bottom: 0;
    margin-top: 4rem;
  }
}

@media (min-width: 990px) {
  .hw-modal--bodyFares {
    padding-top: 0.8rem;
  }

  .hw-modal--flightBook .hw-modal-headerTitle {
    column-gap: 0.8rem;
    font-size: 2.5rem;
  }

  .hw-modal--bodyTop {
    row-gap: 1.6rem;
  }

  .hw-fare--slideItem .b-top {
    padding: 1.6rem 1.6rem 1.2rem 1.6rem;
    gap: 0.4rem;
  }

  .hw-fare--slideBox .b-footer {
    /* padding-top: 2.4rem; */
  }

  .hw-fare--slideBox .b-middle {
    padding: 1.2rem 1.6rem 0;
  }

  /* .hw-fare--slideItem {
    min-width: 35rem;
    max-width: 35rem;
  } */
  .hw-fare--slider .swiper-slide {
    min-width: 29rem !important;
    max-width: 32rem !important;
  }
}

@media (min-width: 1440px) {
  .hw-modal--bodyFares {
    /* padding-top: 4rem; */
    /* padding-top: 3rem; */
  }
}

@media (max-width: 900px) {
  .hw-modal.hw-modal--flightBook .hw-modal-dialog {
    margin-top: 5rem;
    margin-bottom: 5rem;
    min-height: calc(100% - 6rem * 2);
    height: calc(100% - 6rem * 2);
  }
}

@media (max-width: 989px) {
  .hw-fare--slideItem .b-top .hw-text20 {
    font-size: 1.8rem;
  }

  .hw-fare--slideItem .b-top .hw-text18 {
    font-size: 1.4rem;
  }
}

@media (max-width: 749px) {
  .hw-flight--listOut .f-place .hw-text18 {
    font-size: 1.4rem;
    line-height: 1.5;
  }
}

@media (max-width: 575px) {
  .hw-search--flightListBottomFooter .col-fix-right {
    flex-direction: column;
    row-gap: 0.2rem;
  }

  .hw-search--flightListBottomFooter .hw-text20.hw-dtr--dtext {
    font-size: 1.6rem;
  }
}

/*End flight Popup*/
.hw-inner--flightBookingBox {
  display: flex;
  flex-direction: column;
  row-gap: 1.6rem;
}

.hw-inner--flightBookingBox .flight-list {
  background-color: rgba(29, 78, 229, 0.03);
  padding: 1.6rem;
}

.hw-inner--flightBookingBox .flight-list .hw-baggage--line {
  border-top: 1px solid var(--hw-gray-600);
  padding-top: 1.6rem;
  margin-top: 1.6rem;
}

.f-timeDate--inline {
  display: flex;
  align-items: center;
  column-gap: 0.8rem;
}

.f-timeDate .f-dot {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #d9d9d9;
  border-radius: 1rem;
}

.hw-recent--viewedList {
  margin-left: -1.6rem !important;
  padding-left: 1.6rem !important;
  padding-right: 1.6rem !important;
}

.hw-divider--clickShow {
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 1rem;
  cursor: pointer;
  min-height: 3.6rem;
}

.hw-divider--clickShow::before,
.hw-divider--clickShow::after {
  content: '';
  background-color: var(--hw-gray-600);
  flex-grow: 1;
  height: 1px;
}

.hw-divider--clickShow .span-svgWrap {
  border: 1px solid var(--hw-gray-600);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 3.2rem;
  min-height: 3.2rem;
  color: var(--hw-brand-blue);
  transition: .2s ease-in-out;
}

.hw-divider--clickShow .span-svgWrap:hover {
  background-color: var(--hw-brand-blue-light);
  color: var(--hw-brand-orange);
  border-color: var(--hw-brand-orange);
}

.hw-divider--clickShow .span-svgWrap:hover {
  background-color: var(--hw-brand-blue-light);
  color: var(--hw-brand-orange);
  border-color: var(--hw-brand-orange);
}

.hw-divider--clickShow .span-svgWrap svg {
  width: 2rem;
  height: 2rem;
}

.hw-modal--bodyTop.hw-modal--bodyTopPrev:not(.active) .hw-divider--clickShow~.hw-flight--timelineColumn {
  display: none;
}

.hw-exchk--sectionHead {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding-bottom: 1.4rem;
  margin-bottom: 2rem;
  border-bottom: 0.1rem solid var(--hw-gray-200);
}
.hw-exchk--sectionIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.6rem;
  height: 3.6rem;
  flex-shrink: 0;
  border-radius: 1rem;
  background: var(--hw-brand-orange-light);
  color: var(--hw-brand-orange);
}
.hw-exchk--sectionIcon svg {
  width: 1.8rem;
  height: 1.8rem;
  color: var(--hw-brand-orange);
}
.hw-exchk--sectionTitle {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--hw-black);
  letter-spacing: -0.01em;
}
.hw-hotelContact--listShow__widget .hw-exchk--sectionHead,
.hw-hotel--reviewContact .hw-exchk--sectionHead {
  margin-top: 2.8rem;
}

.hw-exchk--sectionHead__toggle {
  cursor: pointer;
  user-select: none;
  margin-bottom: 0;
  transition: margin-bottom 0.2s ease;
}
.hw-exchk--sectionHead__toggle.is-open {
  margin-bottom: 2rem;
}
.hw-exchk--sectionToggle {
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  margin-left: auto;
}
.hw-exchk--sectionMeta {
  font-size: 1.3rem;
  font-weight: 600;
  color: black;
}
.hw-exchk--sectionChevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: black;
  transition: transform 0.25s ease;
}
.hw-exchk--sectionChevron svg {
  width: 2rem;
  height: 2rem;
}
.hw-exchk--sectionHead__toggle.is-open .hw-exchk--sectionChevron {
  transform: rotate(180deg);
}

.hw-passenger--toggleChevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.25s ease;
}
.hw-passenger--toggleChevron svg {
  width: 2.4rem;
  height: 2.4rem;
}
.hw-passenger--toggleChevron.is-open {
  transform: rotate(180deg);
}

.hw-hotel--guestRoom + .hw-hotel--guestRoom {
  margin-top: 2.8rem;
}
.hw-hotel--guestRoomTitle {
  margin-bottom: 0.4rem;
}

/* tax-not-included warning (shown under the price breakdown instead of a tooltip) */
.hw-hotel--taxNote {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  margin-top: 1.4rem;
  padding: 1rem 1.2rem;
  background: #fff6e9;
  border: 0.1rem solid #f3d9a8;
  border-radius: 0.8rem;
  font-size: 1.2rem;
  line-height: 1.5;
  color: #8a6d3b;
}
.hw-hotel--taxNote__icon {
  flex: none;
  display: inline-flex;
  margin-top: 0.1rem;
  color: #d9962b;
}
.hw-hotel--taxNote__icon svg {
  width: 1.6rem;
  height: 1.6rem;
}

@media (min-width: 641px) {
  .hw-recent--viewedList {
    margin-left: -2.4rem !important;
    padding-left: 2.4rem !important;
    padding-right: 2.4rem !important;
  }
}

@media (min-width: 768px) {
  .hw-widget.hw-widget--flight .hw-widget--card {
    padding: 1.6rem;
  }
}

@media (min-width: 990px) {
  .hw-recent--viewedList {
    margin-top: 3.2rem !important;
  }
}


.hw-input--switchGroup .icon-chevronDown,
.hw-input--switchGroup .icon-chevronUp {
  display: none;
}

.hw-search--flightFilterResult__tab .hw-nav--tabFareRules .hw-table--border tr>td+td {
  color: var(--hw-gray-800);
}

.hw-contact--inputSingleField {
  border: 1px solid var(--hw-gray-600);
  border-radius: 0.5rem;
  display: grid;
  grid-template-columns: auto 1fr;
}

.hw-passenger--listShow .hw-contact--inputSingleField .hw-inner--fullWidth>div>div {
  border: none !important;
}

.hw-contact--inputSingleField .hw-form--input {
  border: none !important;

}

.hw-contact--inputSingleField>div {
  position: relative;
}
.hw-hotel-number {
  border-left: 1px solid var(--hw-gray-600);
}

.hw-contact--inputSingleField .hw-p-error-cls {
  position: absolute;
  margin: 0;
}

.hw-contact--inputSingleField>.hw-inner--fullWidth {
  min-width: 15rem;
}

.hw-modal--bodyTop.hw-modal--bodyTopPrev-multi-city:not(.multicity-active)~.hw-modal--bodyTop.hw-modal--bodyTopPrev-multi-city {
  display: none;
}

.hw-modal--bodyTop.hw-modal--bodyTopPrev-multi-city:not(.multicity-active) .hw-divider--clickShow~* {
  display: none;
}

.hw-inputCheck--airline .css-1u9des2-indicatorSeparator {
  display: none;
}

.hw-inputCheck--airline svg {
  color: var(--hw-brand-blue) !important;
}

.hw-inputCheck--airline .css-1p3m7a8-multiValue {
  margin: 1px;
  color: var(--hw-brand-blue);
  background-color: var(--hw-brand-blue-light);
}

.hw-hover--underline:hover {
  text-decoration: underline;
  text-underline-offset: 0.8rem;
}

/* .hw-contact--inputSingleField .css-1u9des2-indicatorSeparator {
  display: none !important;
} */
.hw-contact--inputSingleField .css-1xc3v61-indicatorContainer {
  padding: 0 !important;
}

.hw-contact--inputSingleField .input-m--field .hw-form--input {
  padding-left: 2.3rem;
}

.hw-row--s2 .react-datepicker-wrapper .hw-form--input {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: left 1.2rem center;
  background-size: 2.4rem 2.4rem;
  padding-left: 4.2rem;
}

.react-datepicker__close-icon::after {
  background-color: var(--hw-brand-orange);
}

.hw-table--baggage tbody td {
  color: var(--hw-gray-800);
}

.hw-table--baggage tbody tr>td:not(:last-child) {
  border-right: 1px solid var(--hw-gray-600);
}

.hw-table--responsive {
  width: 100%;
  overflow-x: auto;
}

.hw-flight--ntavailable,
.hw-hotel--ntavailable {
  margin-top: 2.4rem;
  background-color: var(--hw-white);
  /* margin: 0 !important; */
  padding: 4rem 1.6rem;
  border-radius: 0.5rem;
}

.hw-flight--ntavailable>div {
  max-width: 48rem;
  margin-left: auto;
  margin-right: auto;
}
@media (min-width: 480px) {
  .hw-contact--inputSingleField > .hw-inner--fullWidth {
    min-width: 18rem;
  }
}

@media (max-width: 1100px) {
.hw-mauto--1100 {
  margin-left: auto;
}
.hw-hotel--hotelDetails .hw-passenger--fareSummary__box .mt-6 {
  margin-top: 2.4rem !important;
}
}

@media (max-width: 599px) {
  .hw-passenger--head .h3 {
    font-size: 2rem;
    line-height: 1.5;
  }

  .hw-flight--listBoxAction {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}

@media (max-width: 599px) {
.hw-xs--grow1 {
  flex-grow: 1;
}
.hw-xs--grow1--leftAlign {
  justify-content: flex-start !important;
}
.hw-flight--listBoxAction {
  row-gap: 0.4rem;
}
}

/* .hw-contact--inputSingleField .icon-chevronDown */

/*End new flight design*/



@media (min-width: 901px) {
  main:has(.hw-search--flightListBottomFooter)~.hw-footer {
    padding-bottom: 10rem;
  }

  main:has(.hw-search--flightListBottomFooter) .hw-search--flightFilter {
    max-height: calc(100dvh - 19rem);
  }
}

@media (max-width: 900px) {
  main:has(.hw-search--flightListBottomFooter)~.hw-footer {
    padding-bottom: 14rem;
  }
}


/* main:has(.hw-search--flightListBottomFooter) .hw-search--flightFilter */

/*New hotel design css*/


.hw-hotes-module .hw-input--multicityGroup .hw-input--input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.hw-hotes-module .DT--section {
  padding-bottom: 1.6rem;
}

/* .hw-hotel--asideFilter .hw-search--flightFilter__title {
  padding: 1rem;
}

.hw-hotel--asideFilter .hw-search--flightFilter__widgetContent {
  padding: 0 1rem;
} */

.hw-hotel--singleListExtra .hw-sticky--scroller {
  top: 33.8rem;
}

.hw-hotel-checkout--preview>.hw-passenger--detailsGroup+.hw-blue {
  margin-top: 1.6rem;
}
@media (min-width: 491px) {
  .hw-hotel--singleListExtra .hw-sticky--scroller {
    top: 27.2rem;
  }
}
@media (min-width: 641px) {
  .hw-hotel--singleListExtra .hw-sticky--scroller {
    top: 22.2rem;
  }
}
@media (min-width: 768px) {
  .hw-hotes-module .hw-input--switchGroup>div {
    max-width: 100%;
  }
}

@media (min-width: 901px) {

  .hw-hotel--asideFilter .hw-search--flightFilter__body {
    display: flex !important;
  }
}

@media (min-width: 990px) {
  .hw-hotel--singleListExtra .hw-sticky--scroller {
    /* top: 8.8rem; */
    /* top: 9.6rem; */
     top: 9.4rem;
  }
}

/* @media (min-width: 1240px) {
  .hw-hotes-module .hw-date--calender {
    min-height: 76px;
  }
} */

@media (max-width: 479px) {
  .wrap-this--mob {
    flex-wrap: wrap;
    row-gap: 1rem;
  }
}

/*End New hotel design css*/



.hw-fare--slider .swiper-slide {
  height: auto;
  min-height: 100%;
}

.hw-fare--slideItem {
  height: 100%;
}

.fixed-top {
  z-index: 99999;
}

.hw-hotes-module .DT--section select {
  min-height: 3.2rem;
}
.hw-passenger--fareShowToggleContent .hw-p-error-cls {
  margin-bottom: 0;
}

@media (min-width: 768px) and (max-width: 1099px) {
  .hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2 {
    width: 50%
  }
}

@media (min-width: 900px) and (max-width: 1099px) {
  .hw-hotes-module .hw-input--groupCol .hw-row--inputFirst .react-datepicker-wrapper {
    width: calc(67% - 1.2rem);
  }

  .hw-hotes-module .hw-input--groupCol .hw-row--input.hw-row--inputFirst {
    row-gap: 1.2rem;
    column-gap: 1.2rem;
  }
}

@media (min-width: 1025px) and (max-width: 1099px) {
  .hw-hotes-module .hw-input--groupCol .hw-input--switchGroup {
    width: 100%;
  }
}

@media (min-width: 1100px) {
  .hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2 {
    width: 35%
  }
}

@media (max-width: 899px) {
  .hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2 {
    width: 100%;
  }
}

@media (max-width: 479px) {
  .hw-hotel--hotelDetails .hw-passenger--wrapper .hw-p-error-cls {
    font-size: 1.2rem;
  }
}

.hw-row--input.hw-row--inputFirst>.hw-input--input {
  place-content: center;
}

@media screen and (min-width: 768px) {

  /* .hw-hotelContact--listShow__widget #email.hw-form--input {
    height: 100%;
  } */
}

@media screen and (min-width: 641px) and (max-width: 991px) {
  .hw-hotel--imageGallery .hw-img--grid {
    min-height: 14rem;
  }
}

@media screen and (min-width: 480px) and (max-width: 640px) {
  .hw-hotel--imageGallery .hw-img--grid {
    min-height: 10rem;
  }
}

.hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2>div>div>div .css-1xc3v61-indicatorContainer svg {
  color: var(--hw-brand-blue) !important;
}

body .hw-modal-backdrop {
  z-index: 99999;
}

body .hw-modal {
  z-index: 999999;
}

/* Wrapper spacing fix */
.hw-page--width {
  width: 100%;
}

.skeleton-gallery {
  display: flex;
  gap: 1rem;
  width: 100%;
}

.skeleton-gallery-left {
  width: 70%;
}

.skeleton-gallery-right {
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Stack gallery on mobile */
@media (max-width: 768px) {
  .skeleton-gallery {
    flex-direction: column;
  }

  .skeleton-gallery-left,
  .skeleton-gallery-right {
    width: 100%;
  }
}

.skeleton-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.skeleton-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.skeleton-rooms {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.skeleton-room-group {
  display: flex;
  gap: 1rem;
}

.skeleton-room-left {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 40%;
}

.room-img {
  width: 30%;
}

@media (max-width: 768px) {

  .skeleton-room-group {
    flex-direction: column;
  }

  .skeleton-room-left,
  .room-img {
    width: 100%;
  }
}

@media (min-width: 1301px) {
  .hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2 {
    width: 37.5%;
  }
}


.hw-hotel-search .css-1dimb5e-singleValue{
  color: var(--hw-brand-blue);
  font-weight: bold;
}
.hw-hotel-search .css-15lsz6c-indicatorContainer svg {
  color: var(--hw-brand-blue) !important;
}

/* Hotel Tax Warning Box */
.hw-hotel--taxWarningBox {
  border-radius: 0.5rem;
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.3);
  padding: 1rem 1.2rem;
  margin-top: 1rem;
}

.hw-hotel--taxWarningIcon {
  color: #FFC107;
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
}

.hw-hotel--taxWarningIcon svg {
  width: 20px;
  height: 20px;
  min-width: 20px;
}

.hw-hotel--taxWarningText {
  flex: 1;
  color: #856404;
}

.hw-hotel--taxWarningText p {
  color: #856404;
  line-height: 1.5;
  margin: 0;
}

/*End latest css*/

.hw-countryExplore--section .slick-list{
  overflow: visible;
}
.hw--hotel-phonecode .css-1wy0on6{
  flex-direction: row-reverse !important;
}

.hw--hotel-phonecode {
  display: flex;
}
.hw--hotel-phonecode p {
  margin-top: 48px !important;
}
.hw-contact--inputSingleField > .hw-inner--fullWidth.hw--hotel-phonecode {
  width: 18rem;
  min-width: 14rem;
}
.hw--hotel-phonecode .hw-pcsel {
  position: relative;
  width: 100%;
}
.hw--hotel-phonecode .hw-pcsel--menu {
  z-index: 1000;
  max-height: 42rem;
}
.hw--hotel-phonecode .hw-pcsel--list {
  max-height: 38rem;
}




.hw-top--fixImg:not(.hw-excursion-banner-img) {
  max-height: 27rem;
}

.hw-rateList {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding-inline: 1.6rem;
  padding-top: 8px;
  padding-bottom : 1.6rem;
  background: white;
  min-width: 0;
  box-sizing: border-box;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}

.hw-rateList__card {
  display: flex;
  gap: 20px;
  background: transparent;
  border: 0;
  border-radius: 0;
  padding: 16px 0;
  min-width: 0;
}

.hw-rateList__card:not(:first-child) {
  border-top: 1px solid #DFDFDF;
}

.hw-rateList__card:hover {
  border-color: #DFDFDF;
  box-shadow: none;
}

.hw-rateList__main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.hw-rateList__aside {
  flex: 0 0 190px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 20px;
  padding-left: 18px;
}

.hw-rateList__head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.hw-rateList__name {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 600;
  color:  Black;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.hw-rateList__class {
  font-size: 12px;
  font-weight: 500;
  color: #0062ff;
  background: #e9f0ff;
  border-radius: 20px;
  padding: 3px 10px;
  white-space: nowrap;
}

.hw-rateList__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  color: #55617a;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
}

.hw-rateList__meta span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.hw-rateList__meta svg {
  width: 16px;
  height: 16px;
  flex: none;
}

.hw-rateList__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}

.hw-rateList__chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  font-weight: 500;
  color: #384152;
  background: #f1f4f9;
  border-radius: 8px;
  padding: 5px 10px;
}

.hw-rateList__chip svg {
  width: 14px;
  height: 14px;
  color: #1d9e75;
}

.hw-rateList__chip--more {
  color: #0062ff;
  background: #e9f0ff;
}

.hw-rateList__cancel {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13.5px;
  line-height: 1.5;
}

.hw-rateList__cancel svg {
  width: 18px;
  height: 18px;
  flex: none;
  margin-top: 1px;
}

.hw-rateList__cancel.is-free {
  color: #0f6e56;
}

.hw-rateList__cancel.is-nonref {
  color: #b42318;
}

.hw-rateList__cancelText {
  display: flex;
  flex-direction: column;
}

.hw-rateList__cancelMain {
  font-weight: 500;
}

.hw-rateList__cancelSub {
  color: #7a8598;
  font-size: 12.5px;
}

.hw-rateList__cancelSub svg {
  width: 13px;
  height: 13px;
  vertical-align: -2px;
}

.hw-rateList__priceLabel {
  font-size: 12px;
  color: #7a8598;
}

.hw-rateList__price {
  font-size: 22px;
  font-weight: 700;
  color: #1f2a44;
  white-space: nowrap;
  text-align: right;
  display: flex;
  flex-direction: column;
}
.hw-rateList__price p{
  font-size: 16px;
  font-weight: 500;
  color: #555;
  white-space: nowrap;
  margin-bottom: 0 !important;
}

.hw-rateList__aside .hw-btn {
  margin-top: 6px;
}

.hw-rateList__viewAll {
  display: flex;
  justify-content: center;
  padding-top: 4px;
}

.hw-rateList__viewAll .hw-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: auto;
  padding-inline: 24px;
}

.hw-rateList__viewAll .hw-btn svg {
  width: 16px;
  height: 16px;
}

@media (max-width: 767px) {
  .hw-rateList__card {
    flex-direction: column;
    gap: 14px;
  }
  .hw-rateList__aside {
    flex-basis: auto;
    border-left: 0;
    padding-left: 0;
    border-top: 1px solid #eef1f6;
    padding-top: 12px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .hw-rateList__aside .hw-btn {
    width: auto;
    margin-top: 0;
  }
}
.hw-select-btn {
  padding : 15px;
  display : flex;
  gap : 10px;
  border-radius : 10px;
  background-color: transparent;
  border : 1px solid #0062FF;
  justify-content : center;
  align-items : center;
  font-size : 16px;
  color : #0062FF;
  font-weight : 700;
  line-height: 28px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.hw-select-btn:hover {
  color:white;
  background-color: #0062FF;
  border-color:transparent;
}
.hw-select-btn:hover svg path{
  fill : white;
}
.hw-book-btn {
  padding-block : 15px;
  padding-inline : 30px;
  display : flex;
  gap : 10px;
  border-radius : 10px;
  background-color: #0062FF;
  border : none;
  justify-content : center;
  align-items : center;
  font-size : 16px;
  color : #ffffff;
  font-weight : 700;
  line-height: 28px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.detail-btn{
  width: 172px;
}
.hw-book-btn:hover {
  color:white;
  background-color: var(--hw-brand-blue);
  border-color:transparent;
}

.hw-rateList__moreLink {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 0;
  background: none;
  border: 0;
  color: #0062ff;
  font-size: 14px !important;
  font-weight: 700;
  cursor: pointer;
  line-height: 1.71429;
}
.hw-rateList__moreLink svg {
  width: 16px;
  height: 16px;
}

/* ---------- Room details popup (rate row > View More Details) ---------- */
.hw-roomDetail--dialog {
  max-width: 560px;
  width: 100%;
  margin-inline: auto;
}
.hw-roomDetail--header .hw-modal-headerTitle {
  color: #1f2a44;
  font-size: 1.8rem;
  font-weight: 700;
}
.hw-roomDetail--features {
  background: #f6f8fb;
  border-radius: 12px;
  padding: 16px 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}
.hw-roomDetail--feature {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 16px;
  font-weight: 500;
  color: #555;
  text-transform: capitalize;
}
.hw-roomDetail--feature svg {
  width: 18px;
  height: 18px;
  flex: none;
  color: #1d9e75;
}
.hw-roomDetail--policies {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}
.hw-roomDetail--policie {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.hw-roomDetail--policy {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 16px;
  font-weight: 500;
  color: #555;
  line-height: 28px;
}
.hw-roomDetail--policy svg {
  width: 20px;
  height: 20px;
  flex: none;
}
.hw-hotel--detailListOut {
  padding: 24px;
  border-radius: 20px;
  border: 1px solid #DFDFDF;
  display: flex;
  padding: 24px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  background: #fff;
  margin-bottom: 20px;
}
.hw-hotel--detailListOut img {
  object-fit: cover;
  aspect-ratio: 5/4;
}
.hw-hotel--detailList {
  display: flex;
  gap: 24px;
}
.hw-hotel--detailList h4 {
  overflow: hidden;
color: var(--General-Colors-Brand-Black, #000);
text-overflow: ellipsis;
font-family: "DM Sans";
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 28px;
}
.hw-hotel--detailList h6 {
  overflow: hidden;
  color: var(--General-Colors-Brand-Black, #555);
  text-overflow: ellipsis;
  font-family: "DM Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  text-transform: capitalize;
  max-width: 600px;
}
.hw-hotel--detailListContent__price {
  display: flex;
align-items: center;
gap: 20px;
font-size: 14px;
}
.hw-hotel--detailListContent__price span {
  display: flex;
align-items: center;
gap: 4px;
}
.hw-hotel--detailListContent__price svg {
  width: 18px;
  height: 18px;
}


@media (max-width: 1024px) {
  .hw-book-btn {
    white-space: nowrap;
  }
}
@media (max-width: 768px) {
  .hw-hotel--detailListContent__price {
    font-size: 12px;
    gap: 12px;
  }
  .detail-btn {width: 100%;}
}
@media (max-width: 468px) {
  .hw-hotel--detailList,.hw-hotel--detailListOut {
    flex-direction: column;
  }
  .hw-hotel--detailListOut{
    align-items: start;
  }
  .hw-hotel--detailListOut .price span{
    text-align: left !important;
  }
  .hw-rateList__price div{text-align: left !important;}
  .hw-hotel--detailListOut img {
    width: 100%;
    height: 200px;
  }
}

/* Smooth height reveal when "Select a room" expands the rate list. */
.hw-rateList__reveal {
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  transition: grid-template-rows 0.35s cubic-bezier(0.22, 1, 0.36, 1),
              opacity 0.3s ease;
}
.hw-rateList__reveal.is-open {
  grid-template-rows: 1fr;
  opacity: 1;
}
.hw-rateList__revealInner {
  min-height: 0;
  overflow: hidden;
}
@keyframes hw-rateReveal {
  from { grid-template-rows: 0fr; opacity: 0; }
  to   { grid-template-rows: 1fr; opacity: 1; }
}
.hw-currency-switch-li {
  display: flex;
  justify-content: end;
  align-items: center;
}

/* ── Sort By tab strip ──────────────────────────────────────── */
.hw-sortby--strip {
  display: flex;
  align-items: center;
  overflow: hidden;
  flex-shrink: 0;
  gap: 0.8rem;
}

.hw-sortby--tab {
  flex-shrink: 0;
  padding: 0.8rem 2rem;
  height: 3.8rem;
  border: 1px solid transparent;
  background: #fff;
  font-size: 1.4rem;
  color: #444;
  cursor: pointer;
  white-space: nowrap;
  border-radius: 0.7rem;
  transition:
    background 0.15s,
    color 0.15s,
    border-color 0.15s;
}

.hw-sortby--tab:hover {
  background: #ebf3ff;
  color: #0062ff;
  border-color: #0062ff;
}

.hw-sortby--tab.active {
  background: #ebf3ff;
  color: #0062ff;
  font-weight: 600;
  border-color: #0062ff;
}

.hw-sortby--clear {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0 1.2rem;
  height: 3.8rem;
  border: 1px solid transparent;
  border-radius: 0.7rem;
  background: #fff;
  font-size: 1.35rem;
  color: #666;
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;
  transition:
    background 0.15s,
    color 0.15s,
    border-color 0.15s;
}

.hw-sortby--clear:hover {
  background: #FBE7E9;
  color: #d32f2f;
  font-weight: 600;
  border-color: #d32f2f;
}

.hw-sortby--clear:hover .hw-sortby--clear-icon {
  stroke-width: 0.3rem;
}

/* ── Sort By — mobile responsive ───────────────────────────── */
@media (max-width: 768px) {
  /* Parent wrapper: stack label above the strip */
  .d-flex.align-items-center.hw-gapy10.mt-12 {
    flex-wrap: wrap;
    gap: 0.6rem;
  }

  /* Strip: allow tabs to wrap and scroll horizontally */
  .hw-sortby--strip {
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;       /* Firefox */
    gap: 0.5rem;
    width: 100%;
    padding-bottom: 2px;         /* room for scrollbar on some browsers */
  }

  .hw-sortby--strip::-webkit-scrollbar {
    display: none;     
  }

  /* Tabs: smaller padding, full height on touch */
  .hw-sortby--tab {
    padding: 0.6rem 1.2rem;
    height: 3.2rem;
    font-size: 1.2rem;
    white-space: nowrap;
  }

  /* Clear button: keep it compact */
  .hw-sortby--clear {
    padding: 0 0.8rem;
    height: 3.2rem;
    font-size: 1.2rem;
    white-space: nowrap;
  }
}

/* ===== Hotel checkout — new brand design (scoped) ===== */
.hw-hotel--hotelDetails .hw-flight--stepsWrapper { background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%); box-shadow: none; color: #fff; padding: 6px 0 10px; }
.hw-hotel--hotelDetails .hw-flight--steps { padding-top: 8px; }
.hw-hotel--hotelDetails .hw-step .hw-text14,
.hw-hotel--hotelDetails .hw-step .hw-black900 { color: rgba(255,255,255,.65) !important; font-weight: 600; }
.hw-hotel--hotelDetails .hw-step.active .hw-text14 { color: #fff !important; }
.hw-hotel--hotelDetails .hw-step.complete .hw-text14,
.hw-hotel--hotelDetails .hw-step.complete .hw-black { color: #fff !important; }
.hw-hotel--hotelDetails .lm-i { background: rgba(255,255,255,.16); color: #fff; }
.hw-hotel--hotelDetails .hw-step.active .lm-i { background: #fff; color: #283D6B; }
.hw-hotel--hotelDetails .hw-step.complete .lm-i { background: #4ade80; border-color: #4ade80; }
.hw-hotel--hotelDetails .hw-flight--steps .row > .hw-step:not(:last-child)::after { background: rgba(255,255,255,.28); }
.hw-hotel--hotelDetails .hw-expire--session { color: #fff; border-top-color: rgba(255,255,255,.18); }
.hw-hotel--hotelDetails .hw-expire--session .hw-primary,
.hw-hotel--hotelDetails .hw-expire--session svg { color: #fff; }
.hw-hotel--hotelDetails .hw-expire--session .hw-text14 { color: rgba(255,255,255,.9); }

/* confirm success banner on the dark hero */
.hw-hotel--hotelDetails .hw-expire--session__bookingConfirmed,
.hw-hotel--hotelDetails .hw-expire--session__bookingConfirmed h4,
.hw-hotel--hotelDetails .hw-expire--session__bookingConfirmed .hw-black900,
.hw-hotel--hotelDetails .hw-expire--session__bookingConfirmed .color-inherit,
.hw-hotel--hotelDetails .hw-expire--session__bookingConfirmed .hw-bookId { color: #fff !important; background: transparent; }
.hw-hotel--hotelDetails .hw-expire--session__bookingConfirmed .hw-icon--tickcircleBox { background: rgba(255,255,255,.16); color: #fff; }

/* floating cards */
.hw-hotel--hotelDetails .hw-passenger--listShow__widget { border: 1px solid #eceef3; border-radius: 12px; box-shadow: 0 1px 2px rgba(16,24,40,.04); padding: 20px; }
.hw-hotel--hotelDetails .hw-passenger--fareSummary { border-radius: 12px; box-shadow: 0 1px 2px rgba(16,24,40,.04); border: 1px solid #eceef3; }
.hw-hotel--hotelDetails .hw-passenger--fareSummary__box { padding: 18px; }

/* sticky right summary */
.hw-hotel--asideCol { display: block; background: #fff; border: 1px solid #eceef3; border-radius: 6px; box-shadow: 0 1px 2px rgba(16,24,40,.04); overflow: hidden; }
.hw-hotel--asideCol .hw-hcard { border: 0; box-shadow: none; border-radius: 0; }
.hw-hotel--asideCol .hw-passenger--fareSummary { border: 0; box-shadow: none; border-radius: 0; margin: 0; background: transparent; }
.hw-hotel--asideCol .hw-passenger--fareSummary__box { padding-top: 0; }
@media (min-width: 990px) {
  .hw-hotel--hotelDetails .hw-hotel--asideCol { position: sticky; top: 16px; align-self: start; }
}
/* hotel card fits the narrower right column */
.hw-hotel--asideCol .hw-hcard--thumb { width: 100px; height: 70px; }
.hw-hotel--asideCol .hw-hcard--title { font-size: 18px; }

/* payment method as brand cards */
.hw-hotel--hotelDetails .hw-radio--inline { display: flex; flex-wrap: wrap; gap: 12px; margin-top: 10px; }
.hw-hotel--hotelDetails .hw-radio--btnIcon { flex: 1 1 150px; min-width: 0; }
.hw-hotel--hotelDetails .hw-radio--btnIcon input[type="radio"] { width: 100%; min-width: 0; min-height: 54px; border-radius: 12px; border: 1.5px solid #e2e6ee; background: #fff; }
.hw-hotel--hotelDetails .hw-radio--btnIcon input[type="radio"]:hover { background: #f5f8ff; border-color: #c3ccdb; }
.hw-hotel--hotelDetails .hw-radio--btnIcon input[type="radio"]:checked { background: #f5f8ff; border-color: #3264FF; }
.hw-hotel--hotelDetails .hw-radio--btnText { color: #283D6B; font-weight: 700; }
.hw-hotel--hotelDetails .hw-radio--btnIcon input[type="radio"]:checked ~ .hw-radio--btnText { color: #3264FF; }
.hw-hotel--hotelDetails .hw-radio--btnIcon input[type="radio"]:checked ~ .hw-radio--btnText svg { color: #3264FF; }

/* confirm: download tickets side by side + price breakup heading */
.hw-hotel--hotelDetails .hw-after--bookingWidget.tickets { display: flex; flex-wrap: wrap; gap: 10px; }
.hw-hotel--hotelDetails .hw-after--bookingWidget.tickets > .d-flex { flex: 1 1 100%; }
.hw-hotel--hotelDetails .hw-after--bookingWidget.tickets > div:not(.d-flex) { flex: 1 1 200px; min-width: 0; }
.hw-hotel--hotelDetails .hw-after--bookingWidget.tickets > div:not(.d-flex) > .hw-btn { width: 100%; padding: 11px 14px; font-size: 14px; }
.hw-hotel--hotelDetails .hw-after--bookingWidget.price-backup { padding-top: 0;}
.hw-hotel--hotelDetails .hw-after--bookingWidget.price-backup h4 { font-size: 16px; font-weight: 700; }
.hw-hotel--hotelDetails .hw-hotel--summaryTotal .hw-text22 { font-size: 18px !important; }


/* Hotel summary card (sticky sidebar) */
.hw-hotel--summaryCard { padding: 18px; }
.hw-hotel--summaryCard .hw-exchk--tourImg { width: 96px; height: 66px; border-radius: 8px; object-fit: cover; flex: none; }
.hw-hotel--summaryIcon { display: inline-flex; align-items: center; justify-content: center; background: #f2f5fb; color: #283D6B; }
.hw-hotel--summaryIcon svg { width: 34px; height: 34px; }
.hw-hotel--summaryStars { color: #f5a623; font-size: 13px; letter-spacing: 1px; margin-bottom: 2px; }
.hw-hotel--policyLink { margin-top: 14px; padding-top: 14px; border-top: 1px solid #eef1f7; display: inline-block; }

.hw-hotel--roomBlock { padding-top: 14px; margin-top: 14px; border-top: 1px solid #eef1f7; }
.hw-hotel--roomBlock:first-of-type { padding-top: 0; margin-top: 10px; border-top: 0; }

/* Hotel hero (excursion-style) */
.hw-hotel--hero { padding: 16px 0 60px; }
.hw-hotel--heroTimer { display: inline-flex; align-items: center; gap: 8px; color: rgba(255,255,255,.9); font-size: 13px; font-weight: 500; white-space: nowrap;min-width: 250px; }
.hw-hotel--heroTimer svg { color: #fff; width: 18px; height: 18px; }
.hw-hotel--hotelDetails .hw-page--width > .hw-passenger--wrapper { padding-top: 0; margin-top: -34px; position: relative; z-index: 1; }

/* Hotel details card — clean modern layout */
.hw-hcard { padding: 18px; }
.hw-hcard--head { display: flex; gap: 14px; align-items: center; }
.hw-hcard--thumb { width: 108px; height: 84px; border-radius: 10px; overflow: hidden; flex: none; background: #f2f5fb; display: flex; align-items: center; justify-content: center; }
.hw-hcard--thumb img { width: 100%; height: 100%; object-fit: cover; }
.hw-hcard--thumb svg { width: 40px; height: 40px; color: #283D6B; }
.hw-hcard--headInfo { min-width: 0; }
.hw-hcard--titleRow { display: flex; flex-direction: column; }
.hw-hcard--title { margin: 0; font-size: 18px; color: #1b2439; line-height: 1.25; }
.hw-hcard--stars { color: #f5a623; font-size: 14px; letter-spacing: 1px; }
.hw-hcard--addr { display: flex; align-items: center; gap: 6px; color: #3264FF; font-weight: 500; font-size: 14px; margin-top: 16px; }
.hw-hcard--addr svg { width: 16px; height: 16px; flex: none; color: #3264FF; }
.hw-hcard--divider { height: 1px; background: #eef1f7; margin: 12px 0; }
.hw-hcard--roomName { font-size: 14px; font-weight: 600; color: #000; }
.hw-hcard--features { display: flex; flex-wrap: wrap; gap: 6px 14px; margin-top: 8px; }
.hw-hcard--feat { display: inline-flex; align-items: center; gap: 6px; font-size: 13.5px; font-weight: 500; }
.hw-hcard--feat svg { width: 16px; height: 16px; color: #98a2b6; }
.hw-hcard--featOk { color: #137333; }
.hw-hcard--featOk svg { color: #137333; }
.hw-hcard--stay { display: grid; grid-template-columns: 1fr 1fr; align-items: center; gap: 12px; margin-top: 16px; padding: 14px 16px; border: 1px solid #3264FF; border-radius: 6px; background: #f5f8ff; }
.hw-hcard--stayCol { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.hw-hcard--stayCol--out { text-align: right; }
.hw-hcard--stayLbl { font-size: 11px; text-transform: uppercase; letter-spacing: .04em; font-weight: 700; }
.hw-hcard--stayDate { font-size: 14px; font-weight: 700; color: #1b2439; line-height: 1.25; }
.hw-hcard--stayTime { font-size: 12.5px; color: #6b7280; font-weight: 500; }
.hw-hcard--stayArrow { display: flex; align-items: center; justify-content: center; color: #3264FF; flex: none; }
@media (max-width: 400px) {
  .hw-hcard--stay { grid-template-columns: 1fr; }
  .hw-hcard--stayCol--out { text-align: left; }
  .hw-hcard--stayArrow { transform: rotate(90deg); justify-content: flex-start; }
}
.hw-hcard--policy { display: inline-flex; align-items: center; gap: 6px; margin-top: 12px; background: none; border: 0; padding: 0; color: #3264FF; font-weight: 600; font-size: 13.5px; cursor: pointer; }
.hw-hcard--policy svg { width: 14px; height: 14px; color: #3264FF; }
.hw-hcard--policy:hover { text-decoration: underline; }


/* info tooltip (tax note) */
.hw-tip { position: relative; display: inline-flex; align-items: center; margin-left: 5px; color: #b8860b; cursor: help; vertical-align: middle; outline: none; }
.hw-tip svg { width: 15px; height: 15px; }
.hw-tip__box { position: absolute; bottom: calc(100% + 8px); left: 0; width: 230px; max-width: 62vw; background: #1b2439; color: #fff; font-size: 12px; font-weight: 500; line-height: 1.45; padding: 10px 12px; border-radius: 8px; box-shadow: 0 10px 26px rgba(16,24,40,.28); opacity: 0; visibility: hidden; transform: translateY(4px); transition: opacity .15s, transform .15s; z-index: 30; text-align: left; white-space: normal; }
.hw-tip:hover .hw-tip__box, .hw-tip:focus-within .hw-tip__box { opacity: 1; visibility: visible; transform: translateY(0); }
.hw-tip__box::after { content: ""; position: absolute; top: 100%; left: 12px; border: 6px solid transparent; border-top-color: #1b2439; }

.hw-hotel--hero .hw-exchk--heroBar { gap: 16px 24px; }

/* merged guest + contact single card */
.hw-hotel--hotelDetails .hw-hotel--guestCard { border: 1px solid #eceef3; border-radius: 6px; box-shadow: 0 1px 2px rgba(16,24,40,.04); background: #fff; padding: 20px; }
.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-passenger--listShow__widget { border: 0; border-radius: 0; box-shadow: none; padding: 0; background: transparent; }
.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotelPassenger--listShow__widget,
.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotelContact--listShow__widget { border: 0; border-radius: 0; box-shadow: none; padding: 0; background: transparent; }
.hw-hotel--guestDivider { height: 1px; background: #eef1f7; margin: 12px 0; }
.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotel--guestFoot { position: sticky; bottom: 0; z-index: 3; display: flex; justify-content: flex-end; background: #fff; margin: 22px -20px -20px; padding: 14px 20px; border-top: 1px solid #eef1f7; border-radius: 0 0 6px 6px; }
.hw-hotel--guestFoot .hw-btn { min-width: 220px; }
@media (max-width: 767px) {
  .hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotel--guestFoot { margin: 18px -20px -20px; padding: 12px 20px; }
  .hw-hotel--guestFoot .hw-btn { min-width: 0; flex: 1; }
}
.hw-hotel--hotelDetails .hw-passenger--list {
  display: block !important;
  height: auto !important;
  overflow: visible !important;
}
.hw-hotel--hotelDetails .hw-passenger--wrapper,
.hw-hotel--hotelDetails .hw-passenger--listShow,
.hw-hotel--hotelDetails .hw-hotel--guestCard {
  overflow: visible !important;
}
@media (min-width: 1025px) {
  .hw-hotel--hotelDetails .hw-passenger--list {
    display: block !important;
    height: auto !important;
    overflow: visible !important;
  }
}

/* review step: clean guest details preview (excursion style) */
.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotel--reviewGuests,
.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotel--reviewContact { padding: 0; border: 0; box-shadow: none; background: transparent; }
.hw-hotel--reviewRoomCard { border: 1px solid #eef1f7; border-radius: 6px; overflow: hidden; margin-top: 12px; }
.hw-hotel--reviewRoomCard:first-of-type { margin-top: 10px; }
.hw-hotel--reviewRoomHead { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 14px; background: #F8FAFC; border-bottom: 1px solid #e2e6ee; }
.hw-hotel--reviewRoomBadge { font-size: 13px; font-weight: 700; color: #283D6B; letter-spacing: .01em; }
.hw-hotel--reviewRoomCount { font-size: 12px; font-weight: 600; color: #64748b; }
.hw-hotel--reviewList { list-style: none; margin: 0; padding: 0; }
.hw-hotel--reviewGuest { display: flex; align-items: center; gap: 12px; padding: 12px 14px; background: #fff; }
.hw-hotel--reviewGuest + .hw-hotel--reviewGuest { border-top: 1px solid #f0f2f7; }
.hw-hotel--reviewGuestIcon { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%; background: #eaf0ff; color: #3264FF; flex: none; }
.hw-hotel--reviewGuestIcon svg { width: 16px; height: 16px; }
.hw-hotel--reviewGuestName { font-size: 14.5px; font-weight: 600; color: #283D6B; flex: 1 1 auto; min-width: 0; }
.hw-hotel--reviewGuestType { font-size: 11.5px; font-weight: 600; color: #64748b; background: #f7f9fc; border: 1px solid #e2e6ee; border-radius: 999px; padding: 3px 11px; flex: none; }
.hw-hotel--reviewSubTitle { font-size: 16px; font-weight: 700; color: #384152; margin-bottom: 6px; }
.hw-hotel--reviewContactRows { display: flex; flex-direction: column }
.hw-hotel--reviewRow { display: flex; align-items: baseline; gap: 12px; }
.hw-hotel--reviewRowLbl { font-size: 13px; color: #6b7280; font-weight: 500; min-width: 62px; flex: none; }
.hw-hotel--reviewRowVal { font-size: 14px; color: #283D6B; font-weight: 600; word-break: break-word; }

/* review step: payment method (inside guest card, excursion cards) */
.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-exchk--panelTitle { margin: 0 0 14px; }
.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-exchk--panelTitle.hw-hotel--reviewPayTitle { margin-top: 32px; }
.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-exchk--pay-wrap { margin: 0; }

/* left payment: booking ref + terms spacing */
.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotel--payField { margin-top: 16px; }
.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-term--condition { margin-top: 16px; }

/* confirm: download tickets label + buttons on one line */
.hw-hotel--dlInline { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
.hw-hotel--dlInline .hw-exchk--panelSubTitle { margin: 0; white-space: nowrap; flex: none; }
.hw-hotel--dlInline .hw-tk--dlRow { margin: 0; flex: 1 1 auto; }
@media (max-width: 575px) {
  .hw-hotel--dlInline { flex-direction: column; align-items: stretch; gap: 10px; }
  .hw-contact--inputSingleField > .hw-inner--fullWidth.hw--hotel-phonecode {
    width: 145px;
    min-width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/Hotel.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,0DAA0D;AAC1D;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oDAAoD;EACpD,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,iDAAiD;EACjD,oCAAoC;;AAEtC;;AAEA;EACE,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;EACE,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;EAC/C,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,+DAA+D;EAC/D,2DAA2D;AAC7D;;AAEA;EACE,oCAAoC;EACpC,+DAA+D;EAC/D,2DAA2D;AAC7D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;;;;AAKA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iCAAiC;AACnC;;;AAGA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yDAA2yC;AAC7yC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,eAAe;AACf;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;;GAEG;AACH;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE;iBACe;EACf,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;GAEG;AACH;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;GAEC;AACH;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;KAEG;EACH;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,wCAAwC;EAC1C;AACF;;AAEA;EACE;;;KAGG;;EAEH;IACE,YAAY;EACd;;EAEA;;KAEG;;AAEL;;AAEA;EACE;IACE,6BAA6B;IAC7B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;;GAEC;AACH;;AAEA;EACE;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,sCAAsC;IACtC,6BAA6B;IAC7B,0BAA0B;EAC5B;AACF;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,aAAa;AACb,cAAc;AACd;EACE,uCAAuC;EACvC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;EACjC,iDAAiD;EACjD,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sDAAsD;EACtD,2BAA2B;EAC3B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;;;AAIA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,6DAA6D;EAC7D,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;kCAIkC;AAClC;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE;;EAEE,kBAAkB;AACpB;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,iCAAiC;EACjC,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;sEACsE;AACtE;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;AAEA;6EAC6E;AAC7E;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;iEACiE;AACjE;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,wCAAwC;EACxC,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;;AAGA;;EAEE,WAAW;EACX,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,oCAAoC;EACpC,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;;;AAIA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,8BAA8B;EAC9B,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,gDAAgD;EAChD,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;0CACwC;AAC1C;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,gDAAgD;EAChD,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,wBAAwB;EACxB,oBAAoB;EACpB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,kDAAkD;EAClD,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yDAAyqB;EACzqB,4BAA4B;EAC5B,mCAAmC;EACnC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6EAA6E;AAC7E;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;;;GAGG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,wCAAwC;EACxC,OAAO;EACP,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;UACQ;EACR,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,aAAa;AACb;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;EACX,yDAAkf;EAClf,YAAY;EACZ,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;GAEG;AACH;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;KAEG;;EAEH;IACE,gBAAgB;IAChB,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;;;;;GAKC;AACH;;AAEA;;EAEE;;IAEE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;;EAEE;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA,kBAAkB;;AAElB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,OAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,UAAU;IACV,kDAAkD;IAClD,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,6CAA6C;IAC7C,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;;;;;GAMG;;AAEH;;;;GAIG;;;;AAIH;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,iFAAiF;AACjF;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;IACb,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;MACI,mBAAmB;EACvB;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;;AAIA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;AACA;IACI,qBAAqB;EACvB;GACC;MACG,mBAAmB;EACvB;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;EACA;EACA,oBAAoB;AACtB;AACA;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,0CAA0C;IAC1C,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,4BAA4B;IAC5B,oCAAoC;IACpC,MAAM;IACN,eAAe;IACf,OAAO;IACP,QAAQ;IACR,oCAAoC;EACtC;;EAEA;;GAEC;EACD;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,wCAAwC;IACxC,sBAAsB;IACtB,eAAe;EACjB;;EAEA;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;;AAEA;EACE,kBAAkB;AACpB;EACE;IACE,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;;;EAGE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,kBAAkB;;AAElB,sBAAsB;AACtB;EACE,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,OAAO;AACT;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;GAIG;AACH;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;EAChD,gBAAgB;AAClB;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;;;GAMG;AACH;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,MAAM;EACN,aAAa;EACb,6CAA6C;EAC7C,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,8FAA8F;AAChG;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iDAAiD;EACjD,wCAAwC;EACxC,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;IACd,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;;EAEE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;;;GAIG;AACH,0BAA0B;;;AAG1B,wDAAwD;AACxD;;EAEE,kBAAkB;EAClB,YAAY;;EAEZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;;EAEZ;;;qBAGmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,SAAS;;AAET;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;;;;AAKA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,4DAA4D;EAC5D,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;EAClB,+DAA+D;EAC/D,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;;;GAOG;;AAEH;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;MACM,WAAW;IACb,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,8BAA8B;IAC9B,UAAU;IACV,YAAY;IACZ,OAAO;AACX;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;GAEG;;AAEH,iBAAiB;AACjB;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;KAGG;AACL;;;AAGA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,UAAU;IACV,OAAO;IACP,SAAS;IACT,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,gEAAgE;IAChE,iCAAiC;IACjC,6BAA6B;IAC7B,gBAAgB;IAChB,gCAAgC;IAChC,wBAAwB;IACxB,2DAA2D;EAC7D;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;IACzB,qIAAqI;EACvI;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,4CAA4C;EAC9C;;EAEA;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oDAAoD;IACpD,WAAW;IACX,oBAAoB;IACpB,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,iEAAiE;EACjE,sBAAsB,QAAQ,EAAE,mBAAmB,EAAE;EACrD,kCAAkC,cAAc,EAAE,YAAY,EAAE;EAChE,mBAAmB,QAAQ,EAAE,iBAAiB,EAAE,YAAY,EAAE;EAC9D,wBAAwB,YAAY,EAAE;EACtC,wBAAwB,YAAY,EAAE;EACtC,8CAA8C,2BAA2B,EAAE,YAAY,EAAE;EACzF,mBAAmB,eAAe,EAAE,YAAY,CAAC,2BAA2B,EAAE;EAC9E,oBAAoB,QAAQ,EAAE,YAAY,EAAE;EAC5C,oBAAoB,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE;EAC3D,mBAAmB,YAAY,EAAE;EACjC,+CAA+C,aAAa,EAAE;EAC9D,+CAA+C,4BAA4B,EAAE,2BAA2B,EAAE,YAAY,EAAE;EACxH,qDAAqD,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;EACnI,gCAAgC,aAAa,EAAE;EAC/C,yBAAyB,cAAc,EAAE;AAC3C;;AAEA;EACE,+FAA+F;EAC/F,qDAAqD,aAAa,EAAE;AACtE;;AAEA;EACE;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;EACA,uBAAuB,eAAe,EAAE;EACxC,oBAAoB,WAAW,EAAE,YAAY,EAAE;AACjD;;AAEA;EACE,6GAA6G;EAC7G,iCAAiC,aAAa,EAAE,mBAAmB,EAAE;EACrE,6CAA6C,iBAAiB,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACxG;;AAEA;EACE,gEAAgE;EAChE,+CAA+C,aAAa,EAAE;EAC9D,mBAAmB,gBAAgB,EAAE,YAAY,EAAE;EACnD,oBAAoB,QAAQ,EAAE,YAAY,EAAE;EAC5C,kCAAkC,YAAY,EAAE;EAChD,mBAAmB,iBAAiB,EAAE,YAAY,EAAE;EACpD,wBAAwB,YAAY,EAAE;EACtC,oCAAoC,YAAY,EAAE;EAClD,qDAAqD,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;EACnI,yBAAyB,cAAc,EAAE;AAC3C;;AAEA,qBAAqB;;AAErB,aAAa;;AAEb;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;;;AAIA,qBAAqB;AACrB;EACE;IACE,eAAe;IACf,qBAAqB;IACrB,cAAc;EAChB;;EAEA;;;IAGE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,aAAa;IACb,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,aAAa;IACb,cAAc;IACd,QAAQ;EACV;AACF;;AAEA,yBAAyB;;AAEzB,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,kCAAkC;EAClC,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,2CAA2C;EAC3C,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;GAC/B,qBAAqB;EACtB,wBAAwB;AAC1B;;;;;AAKA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa,gBAAgB,0BAA0B;AACzD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;GACC,oBAAoB;AACvB;AACA;EACE,eAAe;AACjB;AACA;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;;;;EAIA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;EAChB;;;;;EAKA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,uEAAuE;EACvE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;EAChB;EACA,iBAAiB,wBAAwB,CAAC;AAC5C;;AAEA,+BAA+B;AAC/B;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;;;AAIA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,2EAA2E;AAC7E;AACA;EACE,yBAAyB;AAC3B,oBAAoB;AACpB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB,gBAAgB;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;EAEE,uDAAuD;EACvD,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf;qBACmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;;;;;;;;;GASG;;AAEH;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,kEAAkE;AACpE;AACA;EACE,iCAAiC;AACnC;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,iEAA0iB;EAC1iB,wCAAwC;EACxC,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;EACA;EACA,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;IACX,8BAA8B;EAChC;AACF;;AAEA;EACE;;KAEG;;EAEH;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;EAChC,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,iEAAiE;EACjE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,2EAA2E;AAC7E;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;6DAE6D;AAC7D;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;AACZ;;AAEA,wDAAwD;AACxD;;EAEE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,uEAAuE;AACvE;EACE,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;;;;GAIG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,+CAA+C;EAC/C,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,oCAAoC;EACpC,sCAAsC;EACtC,oDAAoD;EACpD,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB,uCAAuC;EACvC,6CAA6C;EAC7C,yCAAyC;EACzC,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,0DAA0D;AAC1D;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oEAAyR;AAC3R;;AAEA,iDAAiD;AACjD;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oEAAwR;AAC1R;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yDAAyD;EACzD,oEAAyR;AAC3R;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yDAAyD;EACzD,oEAAwR;AAC1R;;AAEA,mBAAmB;AACnB;;EAEE,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;GAEG;;AAEH;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;;;KAGG;AACL;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,cAAc;EAChB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;IACT,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;;KAGG;EACH;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;EAC5C,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;;AAEA,oFAAoF;AACpF;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE;IACE,+BAA+B;IAC/B,+BAA+B;IAC/B,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;;AAGA;;EAEE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;;AAEzB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;GAEG;AACH;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yDAA+vB;EAC/vB,4BAA4B;EAC5B,uCAAuC;EACvC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;AACF;;AAEA;AACA;EACE,YAAY;AACd;AACA;EACE,sCAAsC;AACxC;AACA;EACE,eAAe;AACjB;AACA;;AAEA,oDAAoD;;AAEpD,wBAAwB;;;;AAIxB;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;;AAGA,0EAA0E;;AAE1E,uBAAuB;;;AAGvB;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;GAMG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;KAChB,WAAW;EACd;AACF;;AAEA;;;;GAIG;;AAEH;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA,2BAA2B;;;;AAI3B;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE;;KAEG;AACL;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;;AAGA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,kCAAkC;EAClC,wCAAwC;EACxC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,iBAAiB;;AAEjB;EACE,iBAAiB;AACnB;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;;;;AAKA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,aAAa;EACf;AACF;AACA;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;AAClB,8CAA8C;AAC9C,uBAAuB;AACvB,sBAAsB;AACtB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB;AACA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,aAAa;AACf,mBAAmB;AACnB,SAAS;AACT,eAAe;AACf;AACA;EACE,aAAa;AACf,mBAAmB;AACnB,QAAQ;AACR;AACA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;IACf,SAAS;EACX;EACA,aAAa,WAAW,CAAC;AAC3B;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,2BAA2B;EAC7B;EACA,wBAAwB,2BAA2B,CAAC;EACpD;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV;+BAC6B;AAC/B;AACA;EACE,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,OAAO,uBAAuB,EAAE,UAAU,EAAE;EAC5C,OAAO,uBAAuB,EAAE,UAAU,EAAE;AAC9C;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB;;;sBAGoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB;;;sBAGoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iEAAiE;AACjE;EACE,gDAAgD;EAChD;IACE,eAAe;IACf,WAAW;EACb;;EAEA,sDAAsD;EACtD;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iCAAiC;IACjC,qBAAqB,QAAQ,YAAY;IACzC,WAAW;IACX,WAAW;IACX,mBAAmB,UAAU,wCAAwC;EACvE;;EAEA;IACE,aAAa;EACf;;EAEA,gDAAgD;EAChD;IACE,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,kCAAkC;EAClC;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,2DAA2D;AAC3D,mDAAmD,0EAA0E,EAAE,gBAAgB,EAAE,WAAW,EAAE,mBAAmB,EAAE;AACnL,4CAA4C,gBAAgB,EAAE;AAC9D;gDACgD,uCAAuC,EAAE,gBAAgB,EAAE;AAC3G,qDAAqD,sBAAsB,EAAE;AAC7E;sDACsD,sBAAsB,EAAE;AAC9E,gCAAgC,iCAAiC,EAAE,WAAW,EAAE;AAChF,gDAAgD,gBAAgB,EAAE,cAAc,EAAE;AAClF,kDAAkD,mBAAmB,EAAE,qBAAqB,EAAE;AAC9F,oFAAoF,iCAAiC,EAAE;AACvH,8CAA8C,WAAW,EAAE,uCAAuC,EAAE;AACpG;kDACkD,WAAW,EAAE;AAC/D,yDAAyD,2BAA2B,EAAE;;AAEtF,4CAA4C;AAC5C;;;;2EAI2E,sBAAsB,EAAE,uBAAuB,EAAE;AAC5H,wFAAwF,iCAAiC,EAAE,WAAW,EAAE;;AAExI,mBAAmB;AACnB,0DAA0D,yBAAyB,EAAE,mBAAmB,EAAE,wCAAwC,EAAE,aAAa,EAAE;AACnK,qDAAqD,mBAAmB,EAAE,wCAAwC,EAAE,yBAAyB,EAAE;AAC/I,0DAA0D,aAAa,EAAE;;AAEzE,yBAAyB;AACzB,sBAAsB,cAAc,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,wCAAwC,EAAE,gBAAgB,EAAE;AACnK,gCAAgC,SAAS,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC/E,iDAAiD,SAAS,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,SAAS,EAAE,uBAAuB,EAAE;AACpI,sDAAsD,cAAc,EAAE;AACtE;EACE,8CAA8C,gBAAgB,EAAE,SAAS,EAAE,iBAAiB,EAAE;AAChG;AACA,8CAA8C;AAC9C,uCAAuC,YAAY,EAAE,YAAY,EAAE;AACnE,uCAAuC,eAAe,EAAE;;AAExD,kCAAkC;AAClC,4CAA4C,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACzG,6CAA6C,eAAe,EAAE,YAAY,EAAE;AAC5E,iEAAiE,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,2BAA2B,EAAE,gBAAgB,EAAE;AAClL,uEAAuE,mBAAmB,EAAE,qBAAqB,EAAE;AACnH,yEAAyE,mBAAmB,EAAE,qBAAqB,EAAE;AACrH,6CAA6C,cAAc,EAAE,gBAAgB,EAAE;AAC/E,8FAA8F,cAAc,EAAE;AAC9G,kGAAkG,cAAc,EAAE;;AAElH,mEAAmE;AACnE,2DAA2D,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE;AACtG,qEAAqE,cAAc,EAAE;AACrF,8EAA8E,eAAe,EAAE,YAAY,EAAE;AAC7G,wFAAwF,WAAW,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC1I,gEAAgE,cAAc,CAAC;AAC/E,mEAAmE,eAAe,EAAE,gBAAgB,EAAE;AACtG,6DAA6D,0BAA0B,EAAE;;;AAGzF,wCAAwC;AACxC,yBAAyB,aAAa,EAAE;AACxC,4CAA4C,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,UAAU,EAAE;AAC1H,yBAAyB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAClI,6BAA6B,WAAW,EAAE,YAAY,EAAE;AACxD,0BAA0B,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACpG,wBAAwB,gBAAgB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE,qBAAqB,EAAE;;AAEnH,uBAAuB,iBAAiB,EAAE,gBAAgB,EAAE,6BAA6B,EAAE;AAC3F,qCAAqC,cAAc,EAAE,gBAAgB,EAAE,aAAa,EAAE;;AAEtF,iCAAiC;AACjC,kBAAkB,oBAAoB,EAAE;AACxC,uBAAuB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,2BAA2B,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,CAAC,gBAAgB,EAAE;AAClL,2BAA2B,WAAW,EAAE,WAAW,EAAE,YAAY,EAAE;AACnE,mEAAmE,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,UAAU,EAAE;;AAEtI,6CAA6C;AAC7C,YAAY,aAAa,EAAE;AAC3B,kBAAkB,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACjE,mBAAmB,YAAY,EAAE,YAAY,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,UAAU,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACpL,uBAAuB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AACrE,uBAAuB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AAClE,sBAAsB,YAAY,EAAE;AACpC,sBAAsB,aAAa,EAAE,sBAAsB,EAAE;AAC7D,mBAAmB,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAClF,mBAAmB,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACzE,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACrI,sBAAsB,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,cAAc,EAAE;AAC7E,qBAAqB,WAAW,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACvE,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACtE,sBAAsB,aAAa,EAAE,eAAe,EAAE,aAAa,EAAE,eAAe,EAAE;AACtF,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC5G,sBAAsB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AACjE,oBAAoB,cAAc,EAAE;AACpC,wBAAwB,cAAc,EAAE;AACxC,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC3M,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACpF,0BAA0B,iBAAiB,EAAE;AAC7C,qBAAqB,eAAe,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AAC1G,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC5F,sBAAsB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC3E,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE,UAAU,EAAE;AAChH;EACE,kBAAkB,0BAA0B,EAAE;EAC9C,0BAA0B,gBAAgB,EAAE;EAC5C,uBAAuB,wBAAwB,EAAE,2BAA2B,EAAE;AAChF;AACA,oBAAoB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC1M,wBAAwB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AACnE,0BAA0B,0BAA0B,EAAE;;;AAGtD,4BAA4B;AAC5B,UAAU,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,cAAc,EAAE,YAAY,EAAE,sBAAsB,EAAE,aAAa,EAAE;AAChK,cAAc,WAAW,EAAE,YAAY,EAAE;AACzC,eAAe,kBAAkB,EAAE,wBAAwB,EAAE,OAAO,EAAE,YAAY,EAAE,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,0CAA0C,EAAE,UAAU,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,wCAAwC,EAAE,WAAW,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC3a,gEAAgE,UAAU,EAAE,mBAAmB,EAAE,wBAAwB,EAAE;AAC3H,sBAAsB,WAAW,EAAE,kBAAkB,EAAE,SAAS,EAAE,UAAU,EAAE,6BAA6B,EAAE,yBAAyB,EAAE;;AAExI,qCAAqC,cAAc,EAAE;;AAErD,uCAAuC;AACvC,+CAA+C,yBAAyB,EAAE,kBAAkB,EAAE,wCAAwC,EAAE,gBAAgB,EAAE,aAAa,EAAE;AACzK,+EAA+E,SAAS,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,UAAU,EAAE,uBAAuB,EAAE;AACnK;kFACkF,SAAS,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,UAAU,EAAE,uBAAuB,EAAE;AACtK,0BAA0B,WAAW,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC5E,oEAAoE,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,aAAa,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,0BAA0B,EAAE;AAClR,+BAA+B,gBAAgB,EAAE;AACjD;EACE,oEAAoE,wBAAwB,EAAE,kBAAkB,EAAE;EAClH,+BAA+B,YAAY,EAAE,OAAO,EAAE;AACxD;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;;;EAGE,4BAA4B;AAC9B;AACA;EACE;IACE,yBAAyB;IACzB,uBAAuB;IACvB,4BAA4B;EAC9B;AACF;;AAEA,+DAA+D;AAC/D;wEACwE,UAAU,EAAE,SAAS,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC1I,4BAA4B,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC/G,0CAA0C,gBAAgB,EAAE;AAC5D,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE;AACtL,6BAA6B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACvG,6BAA6B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAChF,wBAAwB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;AACjE,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC9G,kDAAkD,6BAA6B,EAAE;AACjF,6BAA6B,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,UAAU,EAAE;AACjM,iCAAiC,WAAW,EAAE,YAAY,EAAE;AAC5D,6BAA6B,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,cAAc,EAAE,YAAY,EAAE;AAChH,6BAA6B,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,UAAU,EAAE;AACvL,4BAA4B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACnG,+BAA+B,aAAa,EAAE,uBAAuB;AACrE,uBAAuB,aAAa,EAAE,qBAAqB,EAAE,SAAS,EAAE;AACxE,0BAA0B,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,UAAU,EAAE;AAC1G,0BAA0B,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAErG,qEAAqE;AACrE,qEAAqE,gBAAgB,EAAE;AACvF,8FAA8F,gBAAgB,EAAE;AAChH,mEAAmE,SAAS,EAAE;;AAE9E,8CAA8C;AAC9C,mEAAmE,gBAAgB,EAAE;AACrF,mEAAmE,gBAAgB,EAAE;;AAErF,0DAA0D;AAC1D,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AACtF,+CAA+C,SAAS,EAAE,mBAAmB,EAAE,UAAU,EAAE;AAC3F,oCAAoC,SAAS,EAAE,cAAc,EAAE;AAC/D;EACE,sBAAsB,sBAAsB,EAAE,oBAAoB,EAAE,SAAS,EAAE;EAC/E;IACE,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":[":root {\n  --hw-blue-new: #0062FF;\n  --hw-blue-new-rgb: 0, 98, 255;\n  --hw-star: #F3960A;\n  --hw-light-gray: #F4F5F8;\n  --hw-blue-new-rgb: 0, 98, 255;\n  --green-bg: #0A7519;\n  --header-icon: #CDEAFF;\n  --header-icon-hover: #60B6FB;\n  --social-color: #25579E;\n}\n\n/* Skeleton loading animations for additional hotel data */\n@keyframes skeleton-pulse {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.row-gap--null {\n  row-gap: 0 !important;\n}\n.pb-null {\n  padding-bottom: 0 !important;\n}\n\n.hotel-additional-data-skeleton .skeleton-item {\n  animation: skeleton-pulse 1.5s ease-in-out infinite;\n}\n\n.hotel-additional-data-loading {\n  opacity: 0.7;\n}\n\n.hotel-additional-data-error {\n  opacity: 0.6;\n}\n\n.green-bg {\n  background-color: var(--green-bg) !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.mt-10 {\n  margin-top: 1rem !important;\n}\n\n.mt-12 {\n  margin-top: 1.2rem !important;\n}\n\n.mt-20 {\n  margin-top: 2rem !important;\n}\n\n.mb-20 {\n  margin-bottom: 2rem !important;\n}\n\n.hw-badge--text {\n  background-color: rgba(var(--hw-blue-new-rgb), 0.10);\n  color: var(--hw-brand-orange);\n  padding: .4rem 1.2rem;\n  border-radius: 99.9rem;\n  font-weight: 500;\n  display: inline-flex;\n}\n\n.hw-badge--textSmall {\n  font-size: 1.2rem;\n  line-height: 1.334;\n}\n\n.hw-hotel--list,\n.hw-hotes-module,\n.hw-hotel--singleList,\n.hw-hotel--hotelDetails,\n.hotel-search-form {\n  --hw-brand-orange: #0062FF;\n  --hw-brand-orange-light: #F2F7FF;\n}\n\n.hw-icon--blue svg {\n  color: var(--hw-brand-orange);\n}\n\n.hw-btn--small {\n  padding: .6rem 1.2rem !important;\n  font-weight: 500 !important;\n}\n\n.hw-btn--large {\n  padding: 1.4rem 3rem !important;\n}\n\n.hw-bprimary--link {\n  color: var(--hw-brand-orange);\n  font-weight: bold;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.hw-bprimary--link:hover {\n  color: var(--hw-brand-blue);\n}\n\n.hw-btn--bsecondary,\n.hw-btn--bhsecondary {\n  border: .1rem solid var(--hw-blue-new) !important;\n  color: var(--hw-blue-new) !important;\n\n}\n\n.hw-btn--bprimary {\n  background-color: var(--hw-blue-new) !important;\n  color: var(--hw-white) !important;\n}\n\n.hw-btn--bprimary:hover {\n  background-color: var(--hw-brand-blue) !important;\n  color: var(--hw-white) !important;\n}\n\n.hw-btn--bsecondary:hover {\n  background-color: var(--hw-blue-new) !important;\n  color: var(--hw-white) !important;\n  border-color: var(--hw-blue-new) !important;\n}\n\n.hw-btn--bhsecondary:hover {\n  color: var(--hw-blue-new) !important;\n  background-color: rgba(var(--hw-blue-new-rgb), 0.05) !important;\n  border-color: rgba(var(--hw-blue-new-rgb), 0.05) !important;\n}\n\n.hw-btn--bhsecondary.active {\n  color: var(--hw-blue-new) !important;\n  background-color: rgba(var(--hw-blue-new-rgb), 0.05) !important;\n  border-color: rgba(var(--hw-blue-new-rgb), 0.05) !important;\n}\n\n.hw-mt--10 {\n  margin-top: 1rem;\n}\n\n.hw-mt--20 {\n  margin-top: 2rem;\n}\n\n.hw-rc--container {\n  width: 100%;\n  max-width: 127rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n\n\n\n.hw-hotes-module {\n  background-color: var(--hw-gray-100);\n}\n\n.hw-hotes-module>.hw-widget--card {\n  min-height: 30rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 3rem 0;\n}\n\n.hw-hotes-module>.hw-widget--card .hw-input--groupCol {\n  max-width: 124rem;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  row-gap: 1rem;\n}\n\n.hw-input--groupCol {\n  padding: 1.4rem 2rem;\n  border-radius: 1rem;\n  background-color: var(--hw-white);\n}\n\n\n.hw-br--null {\n  border-radius: 0 !important;\n}\n\n.hw-hotes-module .hw-input--switchGroup>div>div {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cg clip-path='url(%23clip0_18928_50018)'%3E%3Cpath d='M9 11C9 11.7956 9.31607 12.5587 9.87868 13.1213C10.4413 13.6839 11.2044 14 12 14C12.7956 14 13.5587 13.6839 14.1213 13.1213C14.6839 12.5587 15 11.7956 15 11C15 10.2044 14.6839 9.44129 14.1213 8.87868C13.5587 8.31607 12.7956 8 12 8C11.2044 8 10.4413 8.31607 9.87868 8.87868C9.31607 9.44129 9 10.2044 9 11Z' stroke='%23283D6B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M17.657 16.6567L13.414 20.8997C13.039 21.2743 12.5306 21.4848 12.0005 21.4848C11.4704 21.4848 10.962 21.2743 10.587 20.8997L6.343 16.6567C5.22422 15.5379 4.46234 14.1124 4.15369 12.5606C3.84504 11.0087 4.00349 9.40022 4.60901 7.93844C5.21452 6.47665 6.2399 5.22725 7.55548 4.34821C8.87107 3.46918 10.4178 3 12 3C13.5822 3 15.1289 3.46918 16.4445 4.34821C17.7601 5.22725 18.7855 6.47665 19.391 7.93844C19.9965 9.40022 20.155 11.0087 19.8463 12.5606C19.5377 14.1124 18.7758 15.5379 17.657 16.6567Z' stroke='%23283D6B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_18928_50018'%3E%3Crect width='24' height='24' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");\n}\n\n.hw-hotes-module .hw-date-range-picker .hw-input--input {\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  gap: 0;\n}\n\n.hw-date--calender {\n  display: flex;\n  width: 100%;\n}\n\n.hw-date--calender>div {\n  border: .1rem solid var(--hw-gray-400);\n  padding: .7rem .5rem;\n  flex: 1 0 0;\n  margin-left: -.1rem;\n  min-height: 5.4rem;\n  justify-content: center;\n}\n\n/* Error state for date calendar */\n.hw-input--input.hw--error-cls-date-input .hw-date--calender>div {\n  border-color: red !important;\n}\n\n.hw-date--calender .hw-date--checkIn {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  column-gap: 1rem;\n  min-width: 12rem;\n  /* place-content: flex-start; */\n}\n\n.hw-date--calender .hw-date--checkOut {\n  min-width: 9rem;\n}\n\n.hw-date--calender .hw-date--checkIn svg {\n  grid-row: span 2;\n  color: var(--hw-brand-blue);\n  align-self: center;\n}\n\n.hw-hotes-module .hw-row--input.hw-row--inputFirst>.hw-input--input {\n  width: 100%;\n  margin-left: 0;\n  max-width: 100%;\n}\n\n.hw-hotes-module .hw-input--groupCol .hw-row--inputFirst .react-datepicker-wrapper {\n  max-width: 100%;\n  width: 100%;\n  padding-left: 0;\n}\n\n.hw-mBox {\n  background-color: var(--hw-white);\n  padding: 2rem;\n  border-radius: 1rem;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);\n}\n\n.hw-hotel--slideItem {\n  border-radius: 1rem;\n  border: 0.5px solid rgba(40, 61, 107, 0.20);\n  background: var(--hw-light-gray);\n  padding: 2rem;\n}\n\n.hw-pt--medium {\n  padding-top: 5rem;\n}\n\n.hw-hotel--recentSlider:not(.swiper-initialized) {\n  display: flex;\n  overflow: hidden;\n  column-gap: 2.4rem;\n}\n\n.hw-hotel--recentSlider:not(.swiper-initialized) .hw-hotel--slideItem {\n  min-width: calc(50% - 1.2rem);\n  width: 400px;\n}\n\n.hw-hotel--slideItem .img-holder {\n  position: relative;\n  aspect-ratio: 1/1;\n  overflow: hidden;\n  border-radius: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: white;\n}\n\n.hw-hotel--slideItem .img-holder img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  inset: 0;\n}\n\n.hw-whyChoose--section .hw-2col--grid {\n  align-items: center;\n  background-color: var(--hw-white);\n  padding: 2rem;\n  border: 0.5px solid rgba(40, 61, 107, 0.20);\n  border-radius: 1rem;\n}\n\n.hw-modal--hotelDetailsTop>*+* {\n  margin-top: 2rem;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n@media (min-width: 900px) {\n  .hw-date--calender .hw-date--checkIn {\n    min-width: 15rem;\n  }\n}\n\n@media (max-width: 989px) {\n  .hw-whyChoose--section .hw-text20 {\n    font-size: 1.8rem;\n  }\n}\n\n@media (max-width: 767px) {\n  .hw-whyChoose--section .hw-text20 {\n    font-size: 1.6rem;\n  }\n}\n\n@media (max-width: 479px) {\n  .hw-hotes-module>.hw-widget--card {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .hw-hotes-module>.hw-widget--card .hw-input--groupCol {\n    padding: 1.5rem;\n  }\n\n  .hw-date--calender .hw-date--checkIn {\n    column-gap: .5rem;\n  }\n\n  .hw-date--calender .hw-date--checkIn>div,\n  .hw-date--calender .hw-date--checkOut>div {\n    font-size: 1.2rem;\n    line-height: 1.5;\n  }\n\n  .hw-date--calender .hw-date--checkOut .hw-text14 {\n    min-height: 2.125rem;\n  }\n\n  .hw-hotel--recentSection .h3 {\n    font-size: 2rem;\n    line-height: 1.5;\n  }\n}\n\n/*Holder image*/\n.hw-modal--hotelDetailsTop .hw-img--main,\n.hw-modal--hotelDetailsTop .hw-img--grid {\n  position: relative;\n  overflow: hidden;\n  background-color: var(--hw-gray-100);\n  border-radius: 1rem;\n}\n\n.hw-modal--hotelDetailsTop .hw-img--main {\n  aspect-ratio: 4/3;\n}\n\n.hw-modal--hotelDetailsTop .hw-img--grid {\n  height: 100%;\n  min-height: 9rem;\n}\n\n.hw-modal--hotelDetailsTop .hw-img--main img,\n.hw-modal--hotelDetailsTop .hw-img--grid img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.row.hw-hotel--imageGallery {\n  row-gap: 1rem;\n}\n\n/*End holder image*/\n/* .hw-hotes-module .hw-input--multicityGroup > .row > .col-md-2 {\n  width: max-content;\n} */\n.hw-hotes-module .hw-input--switchGroup>div>div {\n  border-top-left-radius: 1rem;\n  border-bottom-left-radius: 1rem;\n}\n\n.hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2>div>div {\n  /* border-radius: 0;\n  border: none; */\n  padding: 0;\n  min-height: 5rem;\n  width: 100%;\n}\n\n.hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2>div>div>div {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2>div>div>div .css-1u9des2-indicatorSeparator {\n  width: 0;\n}\n\n.hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2>div>div>div .css-1xc3v61-indicatorContainer {\n  color: var(--hw-gray-800);\n}\n\n.hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2 .css-1jqq78o-placeholder {\n  margin-left: 0;\n  color: var(--hw-brand-blue);\n  font-weight: 500;\n}\n\n/* .hw-hotes-module .hw-filter--searchBtn {\n font-weight: 500;\n} */\n@media (min-width: 641px) {\n  .grid-span2 {\n    grid-column: span 2 !important;\n  }\n\n  .hw-date--calender>div {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .hw-input--groupCol {\n    padding: 2.4rem;\n    border-radius: 1rem;\n  }\n\n  .hw-hotes-module .hw-filter--searchBtn {\n    font-size: 1.6rem;\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  /* .hw-hotes-module .hw-input--multicityGroup > .row > .col-md-2 > div > div {\n  min-height: 6.8rem;\n} */\n}\n\n@media (min-width: 900px) {\n  .hw-hotes-module .hw-input--groupCol .hw-row--inputFirst .react-datepicker-wrapper {\n    width: calc(67% - .4rem);\n  }\n\n  .hw-hotes-module .hw-row--input.hw-row--inputFirst>.hw-input--input {\n    width: 33%;\n  }\n\n  .hw-modal--hotelDetailsTop .hw-img--main,\n  .hw-modal--hotelDetailsTop .hw-img--grid {\n    border-radius: 1.4rem;\n  }\n}\n\n@media (min-width: 1100px) {\n  .hw-hotes-module .hw-row--input.hw-row--inputFirst {\n    column-gap: 0;\n  }\n\n  .hw-hotes-module .hw-date-range-picker .hw-input--input {\n    margin-left: .4rem;\n    margin-right: .4rem;\n  }\n\n  .hw-hotes-module .hw-input--switchGroup {\n    width: 43rem;\n    min-width: 26rem;\n  }\n\n  /* .hw-hotes-module .hw-input--multicityGroup > .row > .col-md-2 {\n    width: calc(34% + calc(var(--bs-gutter-x) / 1.61));\n  } */\n  .hw-hotes-module .hw-input--groupCol .hw-row--inputFirst .react-datepicker-wrapper {\n    width: 42%;\n  }\n\n  .hw-hotes-module .hw-row--input.hw-row--inputFirst>.hw-input--input {\n    /* width: 24%; */\n    width: 20rem;\n    flex: 1 0 0;\n  }\n\n  .hw-hotes-module .hw-input--switchGroup>div>div {\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n  }\n}\n\n@media (min-width: 1301px) {\n  /* .hw-hotes-module .hw-input--switchGroup {\n    width: 36.5%;\n    \n  } */\n\n  .hw-hotes-module .hw-input--groupCol .hw-row--inputFirst .react-datepicker-wrapper {\n    width: 33.5%;\n  }\n\n  /* .hw-hotes-module .hw-input--multicityGroup > .row > .col-md-2 {\n    width: calc(36.5% + calc(var(--bs-gutter-x) / 1.61));\n  } */\n\n}\n\n@media (max-width: 1099px) {\n  .hw-hotes-module .hw-input--switchGroup>div>div {\n    border-top-right-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n\n  .hw-date--calender .hw-date--checkIn {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  /* .hw-hotes-module .hw-input--multicityGroup > .row.mt-1 {\n  margin-top: 0 !important;\n} */\n}\n\n@media (max-width: 899px) {\n  .hw-hotel--imageGallery .row {\n    row-gap: 1rem !important;\n    --bs-gutter-x: 1rem !important;\n  }\n\n  .hw-hotes-module .hw-date--calender .hw-date--nights {\n    border-top-right-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n  }\n\n  .hw-hotes-module .hw-row--input.hw-row--inputFirst>.hw-input--input {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .hw-hotes-module .hw-row--input .hw-input--switchGroup>div>div {\n    background-position: left 1rem center;\n    padding-left: 4.4rem !important;\n  }\n}\n\n@media (max-width: 640px) {\n  .hw-hotes-module .hw-row--input.hw-row--inputFirst>.hw-input--input {\n    padding-left: .5rem;\n    padding-right: .5rem;\n  }\n\n  .hw-hotes-module .hw-row--input .hw-input--switchGroup>div>div {\n    background-position: left .6rem center;\n    padding-left: 3rem !important;\n    background-size: 2rem 2rem;\n  }\n}\n\n/*slider css*/\n.hw-countryExplore--slider {\n  margin-top: 2rem;\n}\n\n.hw-countryExplore--slider {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  column-gap: 2rem;\n}\n\n.hw-countryExplore--slideItem {\n  cursor: pointer;\n}\n\n.hw-countryExplore--slideItem__image {\n  position: relative;\n  aspect-ratio: 1/1.2;\n  overflow: hidden;\n  border-radius: 2rem;\n}\n\n.hw-countryExplore--slideItem__image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease-in-out;\n  will-change: transform;\n}\n\n.hw-countryExplore--slideItem:hover .hw-countryExplore--slideItem__image img {\n  transform: scale(1.2);\n}\n\n.hw-countryExplore--slideItem__dt {\n  padding-top: 2rem;\n  color: var(--hw-black);\n  font-size: 1.8rem;\n  line-height: 1.55556;\n  font-weight: 500;\n}\n\n.hw-hotes-module.hw-hotel--widget {\n  overflow-x: hidden;\n}\n\n/*slider css*/\n/*Hotels List*/\n.hw-hotel--filterWidgetMain .hw-input--groupCol {\n  background: rgba(0, 0, 0, 0) !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n}\n\n.hw-hotel--filterWidgetMain {\n\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n  background-color: var(--hw-white);\n  /* box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05); */\n  overflow: visible !important;\n}\n\n.hw-hotel--list {\n  position: relative;\n}\n\n.hw-hotel--asideFilter {\n  grid-template-rows: auto 1fr;\n  display: grid;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: var(--hw-gray-200) var(--hw-gray-100);\n  transition: .2s ease-in-out;\n  background-color: var(--hw-white);\n  border-radius: 0.5rem;\n}\n\n.hw-hotel--asideFilter__top {\n  background-color: var(--hw-white);\n}\n\n\n\n.hw-hotel--filter__action {\n  display: flex;\n  justify-content: space-between;\n  column-gap: .5rem;\n  align-items: center;\n  padding: 1.4rem 1.6rem;\n  min-height: 5.6rem;\n}\n\n.hw-hotel--filter__actionFilter {\n  color: var(--hw-black);\n  font-size: 1.8rem;\n  line-height: 1.55556;\n  font-weight: bold;\n}\n\n.hw-no--link {\n  background-color: rgba(0, 0, 0, 0);\n  border: none;\n  color: var(--hw-body-color);\n  font-size: 1.6rem;\n  line-height: 1.75;\n  padding: 0;\n  cursor: pointer;\n}\n\n.hw-hotel--filterResult {\n  background-color: var(--hw-gray-100);\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 2rem;\n}\n\n.hw-hotel--filterResultTop {\n  min-height: 5.7rem;\n  align-items: center;\n  padding: 1.4rem 0;\n}\n\n.hw-blue {\n  color: var(--hw-brand-blue) !important;\n}\n\n.hw-hotel--filterResult__listItem {\n  background-color: var(--hw-white);\n  border-radius: 1rem;\n  padding: 1.5rem;\n  display: flex;\n  column-gap: 1.6rem;\n  row-gap: 1rem;\n  position: relative;\n  /* box-shadow: 0px 4px 20px rgba(15, 23, 42, 0.06); */\n  /* margin-top: 1rem; */\n}\n\n.hw-hotel--filterResult__listItem::after {\n  content: '';\n  border: 1px solid rgba(0, 0, 0, 0);\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  inset: 0;\n  border-radius: 1rem;\n  transition: border-color .2s ease-out;\n  pointer-events: none;\n}\n\n.hw-hotel--filterResult__listItem:hover:after {\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-hotel--filterResult__listItemRight {\n  flex: 1;\n}\n\n.hw-hotel--filterResult__listItemRightWrapper {\n  display: flex;\n  column-gap: 2rem;\n  /* height: 100%; */\n  flex-grow: 1;\n}\n\n.hw-hotel--filterResult__listItemInfo {\n  border-right: .1rem solid var(--hw-gray-400);\n  padding-right: 1.5rem;\n  flex: 1 0 0;\n  display: flex;\n  flex-direction: column;\n  /* row-gap: 1rem; */\n  row-gap: 0.5rem;\n}\n\n.hw-hotel--filterResult__listItemSelect {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n  row-gap: 0.8rem;\n}\n\n.hw-hotel--filterResult .hw-search--flightFilterResult__body {\n  min-height: 50vh;\n}\n\n.hw-hotel--filterResult__title {\n  /* font-size: 2rem; */\n  font-size: 1.8rem;\n  color: var(--hw-black);\n  line-height: 1.4;\n  font-weight: bold;\n  text-transform: capitalize;\n  cursor: pointer;\n}\n\n.hw-hotel--filterResult__listItemInfo .hw-link.hw-link--icon {\n  font-size: 1.4rem;\n}\n\n.hw-hotel--filterResult__listItemInfo .hw-link.hw-link--icon svg {\n  width: 2rem;\n  height: 2.1rem;\n}\n\n.hw-hotel--filterResult__listItemTimage {\n  margin-top: 0.8rem;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  column-gap: .4rem;\n}\n\n.hw-hotel--listItemm {\n  position: relative;\n  overflow: hidden;\n  border-radius: 1rem;\n  aspect-ratio: 1/.7;\n}\n.hw-hotel--listItemm svg,.hw-img--main svg,.hw-img--grid svg {\n  width: -webkit-fill-available;\n  height: -webkit-fill-available;\n}\n.hw-singleListOut--image svg {\n  width: 100%;\n  height: 250px;\n}\n.hw-singleListOut--image .slick-slider svg {\n  width: 25px;\n  height: 25px;\n}\n.hw-singleListOut--imgPlaceholder {\n  width: 100%;\n  height: 25rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.8rem;\n  background: linear-gradient(135deg, #eef2f9 0%, #e2e8f4 100%);\n  border-radius: 1rem;\n}\n.hw-singleListOut--image .hw-singleListOut--imgPlaceholder svg {\n  width: 6rem;\n  height: 6rem;\n  color: #9aa6be;\n  opacity: 0.85;\n}\n.hw-singleListOut--imgPlaceholder span {\n  font-size: 1.3rem;\n  font-weight: 500;\n  color: #9aa6be;\n}\n.hw-hotel--listItemt {\n  position: relative;\n  overflow: hidden;\n  border-radius: 1rem;\n  aspect-ratio: 1/1;\n}\n\n.hw-hotel--listItemm img,\n.hw-hotel--listItemt img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  inset: 0;\n  object-fit: cover;\n}\n\n.hw-hotel--filterResult__location {\n  display: flex;\n  align-items: center;\n  column-gap: .4rem;\n}\n\n.hw-hotel--filterResult__listItemInfo .hw-hotel--filterResult__location {\n  align-items: flex-start;\n  font-size: 1.4rem;\n  line-height: 1.71429;\n}\n\n.hw-hotel--filterResult__listItemInfo .hw-hotel--filterResult__location svg {\n  margin-top: .2em;\n  width: 2rem;\n  height: 2rem;\n}\n\n.hw-hotel--filterResult__location svg,\n.hw-hotel--filterResult__iconText li svg {\n  flex-shrink: 0;\n}\n\n.hw-hotel--filterResult__iconText {\n  margin-top: auto !important;\n  text-transform: capitalize;\n}\n\n.hw-hotel--filterResult__iconText li {\n  display: flex;\n  align-items: center;\n  column-gap: .4rem;\n  font-size: 1.4rem;\n  line-height: 1.71429;\n  font-weight: 500;\n}\n\n.hw-hotel--filterResult__iconText>li:not(:first-child) {\n  margin-top: .4rem;\n}\n\n.hw-modal--footer .room {\n  flex-shrink: 0;\n}\n\n.hw-modal--footer .room>span,\n.hw-hotel--filterResult__listItemSelect .room>span {\n  font-weight: 500;\n}\n\n.hw-hotel--filterResult__listItem+.hw-hotel--filterResult__listItem {\n  margin-top: 1.2rem;\n}\n\n/* ---------- Sticky-stacking rate list (hotel list item) ----------\n   Each hotel's main card + its expanded rate list are wrapped in\n   .hw-hotel--stickyGroup. When expanded, the two merge into one continuous\n   card: the main card pins to the top of the viewport while the rate rows\n   scroll up and tuck behind it. */\n.hw-hotel--stickyGroup {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n/* Keep the same spacing between hotels now that each item is wrapped. */\n.hw-hotel--stickyGroup+.hw-hotel--stickyGroup,\n.hw-hotel--stickyGroup+.hw-hotel--filterResult__listItem {\n  margin-top: 1.2rem;\n}\n\n/* Expanded: main card becomes the pinned, opaque header of a single card. */\n.hw-hotel--stickyGroup.is-expanded .hw-hotel--filterResult__listItem {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  background-color: var(--hw-white);\n  border-radius: 0;\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n}\n\n/* Separate divider line, inset 16px (matching the rate list padding), pinned\n   to the card bottom so it stays put while the rates scroll behind. */\n.hw-hotel--stickyGroup.is-expanded .hw-hotel--filterResult__listItem::before {\n  content: '';\n  position: absolute;\n  left: 1.6rem;\n  right: 1.6rem;\n  bottom: 0;\n  height: 1px;\n  background: #DFDFDF;\n  z-index: 2;\n  pointer-events: none;\n}\n\n/* The rate list continues the card: same shadow, rounded only at the bottom,\n   and sitting behind the sticky header so rows disappear cleanly under it. */\n.hw-hotel--stickyGroup.is-expanded .hw-rateList {\n  position: relative;\n  z-index: 1;\n}\n\n/* Expanded: the hover highlight wraps the WHOLE box (main card + rates),\n   not just the pinned header, so the two read as a single box. */\n.hw-hotel--stickyGroup.is-expanded .hw-hotel--filterResult__listItem:hover:after {\n  border-color: transparent;\n}\n\n.hw-hotel--stickyGroup.is-expanded::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border: 1px solid var(--hw-brand-orange);\n  border-radius: 1rem;\n  pointer-events: none;\n  z-index: 6;\n}\n\n\n.hw-modal--footer .room>span:not(:last-child)::after,\n.hw-hotel--filterResult__listItemSelect .room>span:not(:last-child)::after {\n  content: '';\n  border-right: .1rem solid var(--hw-gray-200);\n  margin-left: .5rem;\n  margin-right: .5rem;\n}\n\n.hw-rating--value {\n  color: var(--hw-white);\n  padding-left: .4rem;\n  padding-right: .4rem;\n  border-radius: .4rem;\n}\n\n.hw-hotel--listItemt .icon-up {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  color: var(--hw-white);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  backdrop-filter: blur(2px);\n}\n\n\n\n.hw-hotel--filterSearch {\n  position: relative;\n}\n\n.hw-hotel--filterSearch .hw-form--input {\n  padding: 0.8rem 4.5rem 0.8rem 1rem;\n}\n\n.hw-hotel--filterSearch .hw-form--input:hover,\n.hw-hotel--filterSearch .hw-form--input:focus {\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-hotel--filterSearch svg {\n  position: absolute;\n  right: 1.6rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 2rem;\n  height: 2rem;\n  color: var(--hw-brand-orange);\n}\n\n.hw-hotel--Checkbox li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: .6rem 0;\n  column-gap: .5rem;\n}\n\n.hw-hotel--Checkbox li label {\n  display: grid;\n  align-items: center;\n  column-gap: 1rem;\n  grid-template-columns: auto 1fr;\n  width: 100%;\n}\n\n.hw-hotel--asideFilter .hw-search--flightFilter__widget {\n  background-color: var(--hw-white);\n  border-radius: 0.5rem;\n}\n\n.hw-hotel--asideFilter .hw-hotel--Checkbox {\n  padding-bottom: .5rem;\n}\n\n.hw-search--flightFilter__widgetContent .hw-hotel--filterSearch {\n  margin-bottom: .5rem;\n}\n\n.hw-form--input.hw-input--outline:not(:hover),\n.hw-form--input.hw-input--outline:not(:focus) {\n  border-color: var(--hw-gray-200);\n}\n\n.hw-hotel--stars {\n  color: var(--hw-star);\n  line-height: 1;\n  font-size: 2rem;\n}\n\n.hw-img--main img,\n.hw-img--grid img {\n  max-width: 100%;\n}\n\n.hw-gapx15 {\n  row-gap: 1.5rem !important;\n}\n\n.hw-modal--hotelDetailsMap,\n.hw-modal--hotelPopular {\n  margin-top: 2.4rem;\n  border-top: .1rem solid var(--hw-gray-400);\n  padding-top: 2.4rem;\n}\n\n.hw-modal--hotelDetails .hw-modal--footer {\n  background-color: var(--hw-gray-300);\n  padding: 1.5rem;\n}\n\n.hw-modal--footer .hw-view--more {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  column-gap: 2rem;\n  flex-shrink: 0;\n}\n\n.hw-modal--footer .hw-view--more .room {\n  grid-row: 2;\n}\n\n.hw-modal--footer .hw-view--more .hw-btn {\n  grid-row: span 2;\n}\n\n.hw-modal--hotelDetails .hw-modal-header {\n  align-items: flex-start;\n}\n\n.hw-img--grid .hw-btn {\n  position: absolute;\n  bottom: 1rem;\n  right: 1rem;\n  z-index: 1;\n  font-size: 1.4rem;\n  padding: .7rem 1.5rem;\n  line-height: 1.143;\n}\n\n.hw-btn.hw-btn--circleWhite {\n  background-color: var(--hw-white);\n  border-radius: 99.9rem;\n  color: var(--hw-black);\n  transition: all 0.2s ease;\n  cursor: pointer;\n  border: none;\n  font-weight: 500;\n  box-shadow: 0 0.2rem 0.8rem rgba(0, 0, 0, 0.1);\n}\n\n.hw-btn.hw-btn--circleWhite:hover {\n  background-color: var(--hw-brand-orange-light);\n  transform: translateY(-0.1rem);\n  box-shadow: 0 0.4rem 1.2rem rgba(0, 0, 0, 0.15);\n  color: var(--hw-blue-new);\n}\n\n.hw-icon--div svg {\n  flex-shrink: 0;\n}\n.hw-icon--div{\n  text-transform: capitalize;\n}\n\n/*Hotel popup*/\n.hw-rating--tool {\n  position: relative;\n}\n\n.hw-rating--toolTip {\n  position: absolute;\n  border-radius: 4px;\n  background: var(--hw-white);\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);\n  padding: .6rem 1rem;\n  width: 100%;\n  min-width: 22.4rem;\n  right: -1.5rem;\n  font-size: 1.2rem;\n  line-height: 1.334;\n  top: 50%;\n  opacity: 0;\n  transition:\n    opacity .2s ease-out, top .2s ease-out;\n}\n\n.hw-rating--tool:hover .hw-rating--toolTip {\n  opacity: 1;\n  top: 60%;\n  z-index: 1;\n}\n\n.hw-rating--toolTip b {\n  color: var(--hw-black);\n  font-weight: 500;\n}\n\n.hotel-content--block .hw-icon--div svg {\n  width: 2.4rem;\n  height: 2.4rem;\n}\n\n/*single*/\n.hw-hotel--singleList__hotel .hotel-content {\n  background-color: var(--hw-white);\n  border-radius: 1rem;\n  padding: 1.5rem;\n  border: .1rem solid var(--hw-gray-400);\n}\n\n.hw-hotel--singleList__hotel .hotel-content+.hotel-content {\n  margin-top: 1rem;\n}\n\n.hw-hotel--singleList__hotel .hotel-content> :not(:first-child) {\n  margin-top: 1rem;\n}\n\n.hotel-content--block.heading.hw-price--wrap {\n  position: relative;\n  border-bottom: .1rem solid var(--hw-gray-200);\n  padding-bottom: 1rem;\n}\n\n.hw-price--wrapHover {\n  position: absolute;\n  border-radius: 1rem;\n  background-color: var(--hw-white);\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);\n  padding: .5rem 1rem;\n  left: 0;\n  right: 0;\n  top: calc(100% - 1.5rem);\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity .2s, top .2s;\n}\n\n.hotel-content--block.heading.hw-price--wrap:hover .hw-price--wrapHover {\n  opacity: 1;\n  top: calc(100% - 0.5rem);\n  z-index: 1;\n  pointer-events: visible;\n}\n\n.date-badge--show {\n  display: inline-flex;\n  background-color: rgba(var(--hw-blue-new-rgb), .1);\n  padding: 1rem 2rem;\n  border-radius: 2rem;\n  align-items: center;\n  column-gap: 2rem;\n}\n\n.hw-price--wrapHover .wrapHover-item {\n  font-size: 1.4rem;\n  line-height: 1.71429;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  padding: .5rem 1rem;\n}\n\n.arrow-ul {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  row-gap: .4rem;\n  list-style: none;\n}\n\n.arrow-ul li {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='21' viewBox='0 0 20 21' fill='none'%3E%3Cpath d='M10.2447 4.91107C10.5702 4.58563 11.0978 4.58563 11.4232 4.91107L16.4232 9.91107C16.5795 10.0674 16.6673 10.2793 16.6673 10.5003C16.6673 10.7213 16.5795 10.9333 16.4232 11.0896L11.4232 16.0896C11.0978 16.415 10.5702 16.415 10.2447 16.0896C9.91929 15.7641 9.91929 15.2365 10.2447 14.9111L13.8221 11.3337L4.16732 11.3337C3.70708 11.3337 3.33398 10.9606 3.33398 10.5003C3.33398 10.0401 3.70708 9.66699 4.16732 9.66699L13.8221 9.66699L10.2447 6.08958C9.91929 5.76414 9.91929 5.23651 10.2447 4.91107Z' fill='%230062FF'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: top .25em left;\n  padding-left: 3rem;\n  background-size: 2rem 2rem;\n}\n\n.cc-code {\n  color: var(--hw-brand-orange);\n  font-weight: inherit;\n}\n\n.wrapHover-itemGroup {\n  background-color: var(--hw-gray-200);\n  border-radius: 1rem;\n  padding-top: .4rem;\n  padding-bottom: .4rem;\n}\n\n.hw-hotel--singleList__hotel .hw-img--main,\n.hw-hotel--singleList__hotel .hw-img--grid {\n  position: relative;\n  overflow: hidden;\n  background-color: var(--hw-gray-200);\n  border-radius: 1rem;\n  height: 100%;\n  min-height: 16rem;\n}\n\n.hw-hotel--singleList__hotel .hw-img--main img,\n.hw-hotel--singleList__hotel .hw-img--grid img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.hw-hotel--singleList__hotelGallery .row {\n  --bs-gutter-x: 1rem;\n}\n\n.hw-sticky--scroller {\n  position: sticky;\n  z-index: 10;\n  top: 11.1rem;\n  overflow: hidden;\n\n}\n\n.hw-hotel--singleListScroller {\n  display: flex;\n  align-items: center;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  background-color: var(--hw-gray-100);\n  column-gap: .5rem;\n  overflow-x: auto;\n}\n\n.hw-hotel--singleListScrollerTab {\n  border: .1rem solid var(--hw-gray-400);\n  background-color: var(--hw-white);\n  padding: .5rem .8rem;\n  font-size: 1.6rem;\n  line-height: 1.55556;\n  color: var(--hw-black);\n  font-weight: 500;\n  text-transform: capitalize;\n  border-radius: 99.9rem;\n  min-width: 9.8rem;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color .2s ease-out;\n}\n\n.hw-hotel--singleListScrollerTab:hover {\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-section--box {\n  background-color: var(--hw-white);\n  border-radius: 1rem;\n  padding: 1.6rem;\n  border: .1rem solid var(--hw-gray-400);\n}\n\n.hw-hotel--singleListScrollerItem>.hw-hotel--singleListSection:not(:first-child) {\n  padding-top: 4rem;\n}\n\n.hw-hotel--singleListOut {\n  background-color: var(--hw-white);\n  border: .1rem solid var(--hw-gray-400);\n  border-radius: 1rem;\n  padding: 1.5rem;\n}\n\n.hw-singleListOut--content {\n  display: flex;\n  flex-direction: column;\n}\n\n.hw-singleListOut--content .hw-hotel--filterResult__listItemSelect {\n  padding-bottom: 2rem;\n}\n\n.hw-singleListOut--content>.hw-hotel--filterResult__listItemRightWrapper:not(:first-child) {\n  border-top: .1rem solid var(--hw-gray-400);\n}\n\n.hw-singleListOut--content>.hw-hotel--filterResult__listItemRightWrapper:not(:first-child) .hw-hotel--filterResult__listItemInfo,\n.hw-singleListOut--content>.hw-hotel--filterResult__listItemRightWrapper:not(:first-child) .hw-hotel--filterResult__listItemSelect {\n  padding-top: 2rem;\n}\n\n.hw-section--box .box-ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.hw-hotel--listItem__info .info-list svg,\n.hw-hotel--facilitiesList .hw-icon--div svg {\n  width: 2rem;\n  height: 2rem;\n  display: block;\n}\n\n.hw-hotel--facilitiesList .hw-icon--div svg {\n  color: var(--hw-gray-800);\n}\n\n.hw-hotel--listItem__info .info-list {\n  margin-top: 2rem;\n  text-transform: capitalize;\n}\n\n.hw-hotel--singleListOut>.row {\n  --bs-gutter-x: 2rem;\n}\n\n.hw-hotel--listItem__info .info-list+.info-list {\n  border-top: .1rem solid var(--hw-gray-200);\n  padding-top: 2rem;\n}\n\n.hw-hotel--singleListOut+.hw-hotel--singleListOut {\n  margin-top: 2rem;\n}\n\n.hw-hotel--facilitiesPopular {\n  padding-bottom: 2rem;\n  border-bottom: .1rem solid var(--hw-gray-200);\n  margin-bottom: 2rem;\n}\n\n.hw-amenity--chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.hw-amenity--chip {\n  display: inline-flex;\n  align-items: center;\n  gap: .8rem;\n  padding: .9rem 1.4rem;\n  background: #f5f7fb;\n  border: .1rem solid var(--hw-gray-200);\n  border-radius: 10rem;\n  font-size: 1.4rem;\n  font-weight: 500;\n  line-height: 1.2;\n  color: var(--hw-gray-900);\n  text-transform: capitalize;\n  transition: border-color .15s ease, background .15s ease;\n}\n\n.hw-amenity--chip:hover {\n  background: var(--hw-brand-orange-light);\n  border-color: var(--hw-blue-new);\n}\n\n.hw-amenity--chip svg {\n  width: 1.8rem;\n  height: 1.8rem;\n  flex-shrink: 0;\n  color: var(--hw-blue-new);\n}\n\n.hw-hotel--facilitiesList .no-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.hw-hotel--facilitiesList .no-list>li {\n  margin-top: 1rem;\n}\n\n/* facilities: masonry columns so categories pack tightly (no big row gaps) */\n.hw-hotel--facilitiesGrid {\n  column-count: 4;\n  column-gap: 2.4rem;\n}\n.hw-hotel--facilityCol {\n  break-inside: avoid;\n  -webkit-column-break-inside: avoid;\n  page-break-inside: avoid;\n  margin-bottom: 2.8rem;\n}\n@media (max-width: 1199px) {\n  .hw-hotel--facilitiesGrid {\n    column-count: 3;\n  }\n}\n@media (max-width: 767px) {\n  .hw-hotel--facilitiesGrid {\n    column-count: 2;\n  }\n}\n@media (max-width: 479px) {\n  .hw-hotel--facilitiesGrid {\n    column-count: 1;\n  }\n}\n\n.hw-section--box ul:not(:last-child) {\n  margin-bottom: 2rem;\n}\n\n.hw-hotel--facilitiesList:not(.show)>.row {\n  max-height: 14rem;\n  overflow: hidden;\n}\n\n/* smooth expand/collapse of the extra facility categories */\n.hw-hotel--facilitiesReveal {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.35s ease;\n}\n.hw-hotel--facilitiesReveal.is-open {\n  grid-template-rows: 1fr;\n}\n.hw-hotel--facilitiesReveal__inner {\n  min-height: 0;\n  overflow: hidden;\n}\n.hw-hotel--facilitiesReveal.is-open .hw-hotel--facilitiesReveal__inner {\n  padding-top: 2.8rem;\n}\n\n/* .hw-rating--graph {\n  display: grid;\n  row-gap: .5rem;\n} */\n.hw-rating--graphRow {\n  display: flex;\n  align-items: center;\n  column-gap: 1rem;\n}\n\n.hw-rating--graphRow {\n  display: flex;\n  align-items: center;\n  column-gap: 1rem;\n}\n\n.hw-rating--graphRow .hw-rating--graphBar {\n  flex: 1 0 0;\n  height: .4rem;\n  background-color: var(--hw-gray-400);\n  border-radius: .2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.hw-rating--graphBarProgress {\n  position: absolute;\n  top: 0;\n  background-color: var(--hw-brand-orange);\n  left: 0;\n  height: 100%;\n  border-radius: .2rem;\n}\n\n.rating-star {\n  color: var(--hw-star);\n  line-height: 0;\n  font-size: 2rem;\n}\n\n.hw-graph--text {\n  min-width: 1rem;\n  text-align: center;\n}\n\n.hw-review--box {\n  background-color: var(--hw-white);\n  border: .1rem solid var(--hw-gray-400);\n  border-radius: 1rem;\n  padding: 2rem;\n  min-height: 26.3rem;\n}\n\n.hw-review--top {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  column-gap: 1rem;\n  align-items: center;\n}\n\n.hw-review--avtar {\n  grid-row:\n    span 2;\n  background-color: var(--hw-brand-blue);\n  width: 4rem;\n  height: 4rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--hw-white);\n  font-family: var(--hw-head-font-family);\n  font-size: 2.2rem;\n  font-weight: 600;\n  line-height: 0;\n  border-radius: 99.9rem;\n  overflow: hidden;\n  padding: 1rem;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n}\n\n.hw-review--user {\n  font-size: 1.8rem;\n  line-height: 1.55556;\n  font-weight: 500;\n  color: var(--hw-black);\n}\n\n.overflowx-hidden {\n  overflow-x: auto;\n}\n\n/*slider*/\n.hw-rating--graphRow>.d-flex {\n  line-height: 1.5;\n}\n\n.hw-review--slider {\n  display: flex;\n  overflow: hidden;\n  column-gap: 2rem;\n}\n\n.hw-review--slider .hw-review--box {\n  min-width: 25.8rem;\n}\n\n.hw-review--text:not(.hw-read--more) {\n  max-height: 13rem;\n  overflow: hidden;\n}\n\n/*End slider*/\n.hw-hotel--recentSection .slick-list,\n.hw-countryExplore--section .slick-list {\n  margin-left: -1.2rem;\n  margin-right: -1.2rem;\n}\n\n.hw-hotel--recentSection .slick-slider .slick-slide,\n.hw-countryExplore--section .slick-slider .slick-slide {\n  padding-left: 1.2rem;\n  padding-right: 1.2rem;\n}\n\n.hw-hotel--recentSection .slick-arrow {\n  background-color: var(--hw-brand-blue-light);\n  padding: .5rem 1rem;\n  width: 4rem;\n  height: 3rem;\n  opacity: 1;\n  margin: 0;\n  top: -5.5rem;\n  transform: translateY(0);\n}\n\n.hw-hotel--recentSection .slick-arrow.slick-prev {\n  right: 5rem;\n  left: auto;\n  border-radius: 5rem 0 0 5rem;\n}\n\n.hw-hotel--recentSection .slick-arrow.slick-next {\n  right: 0;\n  border-radius: 0 5rem 5rem 0;\n}\n\n.hw-hotel--recentSection .slick-prev::before,\n.hw-hotel--recentSection .slick-next::before {\n  content: '';\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='21' viewBox='0 0 20 21' fill='none'%3E%3Cg clip-path='url(%23clip0_110_95253)'%3E%3Cpath d='M7.49805 5.5L12.498 10.5L7.49805 15.5' stroke='%233264FF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_110_95253'%3E%3Crect width='20' height='20' fill='white' transform='matrix(-1 0 0 1 19.998 0.5)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");\n  font-size: 0;\n  background-size: 2rem 2rem;\n  width: 2rem;\n  height: 2rem;\n  display: block;\n  background-position: center center;\n  opacity: 1;\n}\n\n.hw-hotel--recentSection .slick-prev::before {\n  transform: scaleX(-1);\n}\n\n.hw-hotel--recentSection .slick-arrow:hover {\n  background-color: var(--hw-gray-100);\n}\n\n.hw-hotes-module .hw-input--input:not(.active):hover {\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-hotes-module .hw-input--multicityGroup {\n  row-gap: .5rem;\n}\n\n.hw-hotel--singleList.hw-passenger--pageList {\n  background-color: rgba(0, 0, 0, 0);\n  grid-template-columns: 100%;\n}\n\n/* .hw-countryExplore--section .slick-list {\n  padding-left: 10rem;\n} */\n.hw-rating--graph {\n  overflow: hidden;\n}\n\n.hw-icon--divTop svg {\n  margin-top: .2em;\n}\n\n.hw-section--box>.map-section {\n  margin-top: 1.6rem;\n}\n\n.hw-loader--patchFix .hw-before-loader--status {\n  left: 0;\n}\n\n.hw-hotelContact--listShow__widget .hw-passenger--detailsGroup #react-select-2-placeholder {\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.hw-hotel--singleListOut .hw-singleListOut--image .slick-slide img {\n  border-radius: 1rem;\n}\n\n@media (min-width: 576px) {\n  .hw-review--slider .hw-review--box {\n    min-width: 41.8rem;\n    min-height: 26.3rem;\n  }\n\n  .hw-hotel--singleListScroller {\n    column-gap: 1rem;\n  }\n\n  .hw-modal--hotelDetails .hw-modal-dialog {\n    max-width: 94.4rem;\n  }\n\n  .hw-modal--footer .room>span:not(:last-child)::after,\n  .hw-hotel--filterResult__listItemSelect .room>span:not(:last-child)::after {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n\n  .hw-rating--sectionCol {\n    min-height: 26.3rem;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n@media (min-width: 768px) {\n  .hw-section--box>.map-section {\n    margin-top: 2rem;\n  }\n\n  .hw-hotel--singleListScroller {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n    column-gap: 1.4rem;\n  }\n\n  .hw-hotel--singleListScrollerTab {\n    padding: 1rem 1.6rem;\n    font-size: 1.8rem;\n  }\n\n  .hw-modal--hotelDetails .hw-modal-header {\n    padding: 2.4rem 2.4rem 1rem 2.4rem;\n  }\n\n  .hw-modal--hotelDetails .hw-modal-body {\n    padding: 2.4rem;\n  }\n\n  .hw-modal--hotelDetails .hw-modal--footer {\n    padding: 1.6rem 2.4rem;\n  }\n\n  .hw-hotel--singleList__hotel .hotel-content {\n    border-radius: 2rem;\n    padding: 2rem;\n  }\n\n  .hw-hotel--singleList__hotel .hotel-content> :not(:first-child) {\n    margin-top: 1.5rem;\n  }\n\n  .hw-hotel--singleListOut>.row {\n    --bs-gutter-x: 2rem;\n  }\n\n  .hw-singleListOut--content {\n    border-left: .1rem solid var(--hw-gray-400);\n  }\n\n  .hw-review--text:not(.hw-read--more) {\n    max-height: 11.6rem;\n    overflow: hidden;\n  }\n\n  /* .hw-hotel--singleListOut>.row {\n    align-items: flex-start;\n  } */\n\n  .hw-hotel--singleListOut .hw-singleListOut--image {\n    position: sticky;\n    top: 21rem;\n    z-index: 1;\n  }\n}\n\n@media (min-width: 901px) {\n  .hw-hotel--singleListOut {\n    border-radius: 2rem;\n    padding: 2rem;\n  }\n\n  .hw-hotel--filterResultTop {\n    padding-top: 2.4rem;\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  .hw-hotel--filterResult .hw-search--flightFilterResult__body {\n    padding-left: 2rem;\n  }\n\n  .hw-hotel--filterResult {\n    row-gap: 2rem;\n  }\n\n  /* .hw-hotel--filter__body {\n  padding: 2rem 1.6rem;\n  display: flex;\n  flex-direction: column;\n  row-gap: 1rem;\n} */\n}\n\n@media (min-width: 992px) {\n\n  .hw-hotel--singleList__hotel .hw-img--main,\n  .hw-hotel--singleList__hotel .hw-img--grid {\n    border-radius: 1.4rem;\n  }\n\n  .hw-hotel--singleListOut>.row {\n    --bs-gutter-x: 4rem;\n  }\n\n  .hw-section--box {\n    padding: 2.4rem;\n  }\n}\n\n@media (min-width: 1080px) {\n  .hw-singleListOut--content .hw-hotel--filterResult__listItemInfo {\n    padding-left: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .hw-singleListOut--content .hw-hotel--filterResult__listItemSelect {\n    max-width: 30.8rem;\n    width: 40%;\n  }\n}\n\n@media (min-width: 1200px) {\n  #hotel_guest_reviews>.row {\n    --bs-gutter-x: 3rem;\n  }\n}\n\n@media (min-width: 1400px) {\n\n  .hw-hotel--singleList__hotel .hw-img--main,\n  .hw-hotel--singleList__hotel .hw-img--grid {\n    border-radius: 2rem;\n  }\n\n  .hw-hotel--singleList__hotel .hotel-content,\n  .hw-hotel--singleListOut {\n    padding: 2.4rem;\n  }\n\n  .hw-hotel--singleList__hotel .hotel-content> :not(:first-child) {\n    margin-top: 2rem;\n  }\n}\n\n@media (max-width: 991px) {\n  .row.hw-hotel--singleList__hotel {\n    row-gap: 1.5rem;\n  }\n\n  .hw-hotelContact--listShow__widget .hw-passenger--detailsGroup #react-select-2-placeholder {\n    font-size: 1.4rem;\n  }\n}\n\n@media (max-width: 767px) {\n  .hw-modal--hotelDetailsTop .hw-text18 {\n    font-size: 1.6rem;\n    line-height: 1.5;\n  }\n}\n\n@media (max-width: 599px) {\n  .hw-modal--hotelDetails .hw-modal--footer>.d-flex {\n    flex-direction: column;\n    row-gap: .5rem;\n  }\n\n  .hw-modal--hotelDetails .hw-modal--footer>.d-flex>div {\n    width: 100%;\n  }\n\n  .hw-sticky--scroller {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n\n  .hw-hotel--singleListScroller {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  .hw-hotel--facilitiesPopular .hw-text20.hw-icon--div {\n    font-size: 1.6rem;\n    line-height: 1.75;\n  }\n}\n\n@media (max-width: 479px) {\n  .hw-modal--footer .hw-view--more .hw-btn {\n    padding: .9rem 1.5rem !important;\n  }\n\n  .hw-hotel--recentSection .slick-arrow {\n    top: -5rem;\n  }\n\n  .hw-hotel--singleList__hotel .hw-img--main,\n  .hw-hotel--singleList__hotel .hw-img--grid {\n    min-height: 10rem;\n  }\n}\n\n/*End Hotel popup*/\n\n@media (min-width: 901px) {\n  .hide-up900 {\n    display: none !important;\n  }\n\n  .filter-collapsed .hw-search--flightFilterResult__body .hw-before-loader--status {\n    left: 32rem;\n  }\n\n  .hw-hotes-module>.hw-widget--card .hw-input--groupCol {\n    row-gap: 1.6rem;\n  }\n\n  .hw-hotel--filterResult__listItem {\n    padding: 1.6rem;\n  }\n\n  .hw-hotel--list {\n    display: flex;\n    flex: 1;\n    align-items: flex-start;\n  }\n\n  .hw-hotel--asideFilter {\n    width: 32rem;\n    position: sticky;\n    min-width: 32rem;\n    max-height: calc(100dvh - 12rem);\n    top: 12rem;\n    /* border-right: .1rem solid var(--hw-gray-400); */\n    min-height: calc(100dvh - 12rem);\n    margin-top: 2.4rem;\n  }\n\n  .hw-hotel--asideFilter__top {\n    position: sticky;\n    top: 0;\n    border-bottom: .1rem solid var(--hw-gray-400);\n    z-index: 1;\n  }\n\n  .hw-rating--toolTip {\n    right: -2rem;\n  }\n}\n\n/* @media (min-width: 990px) {\n  .hw-hotel--asideFilter {\n    max-height: calc(100dvh - 9.6rem);\n    top: 9.6rem;\n    min-height: calc(100dvh - 9.6rem);\n  }\n} */\n\n/* @media (min-width: 1240px) {\n  .hw-hotes-module>.hw-widget--card .hw-input--groupCol {\n    row-gap: 2.4rem;\n  }\n} */\n\n\n\n@media (min-width: 1400px) {\n  .hw-rating--toolTip {\n    right: -2.4rem;\n  }\n}\n\n@media (max-width: 1079px) {\n  .hw-hotel--filterResult__listItemSelect .hw-mt--20 {\n    margin-top: 1rem !important;\n  }\n\n  .hw-hotel--filterResult__location {\n    font-size: 1.4rem;\n    line-height: 1.71429;\n  }\n\n  .hw-hotel--filterResult__title {\n    font-size: 1.8rem;\n    line-height: 1.556;\n  }\n}\n\n/* Prevent browser scroll anchoring from jumping when new hotel cards are added */\n.hw-hotel--filterResult__list {\n  overflow-anchor: none;\n}\n\n@media (min-width: 901px) and (max-width: 1079px) {\n  .hw-hotel--filterResult__list {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    column-gap: 1rem;\n  }\n\n  .hw-hotel--filterResult__listItem {\n    flex-direction: column;\n  }\n\n  .hw-hotel--filterResult__listItemRightWrapper {\n    flex-direction: column;\n    row-gap: .5rem;\n  }\n\n  .hw-hotel--filterResult__listItemSelect {\n    align-items: flex-start;\n  }\n\n  .hw-hotel--filterResult__listItemInfo {\n    row-gap: .5rem;\n    border-right-width: 0;\n    padding-right: 0;\n  }\n\n  .hw-hotel--filterResult__listItem+.hw-hotel--filterResult__listItem {\n    margin-top: 0;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 900px) {\n  .hw-hotel--filterResult__listItemLeft {\n    width: 33.33%;\n    max-width: 28rem;\n  }\n}\n\n@media (min-width: 1080px) {\n  .hw-hotel--filterResult__listItemLeft {\n    width: 33.33%;\n    /* max-width: 28rem; */\n    max-width: 24rem;\n  }\n\n  .hw-hotel--filterResult__listItemSelect {\n    max-width: 22.1rem;\n  }\n  .hw-hotel--filterResult__listItemRightWrapper {\n    align-items: flex-end;\n  }\n  .hw-singleListOut--content .hw-hotel--filterResult__listItemInfo {\n      align-self: stretch;\n  }\n  .hw-hotel--filterResult__listItemRightWrapper .hw-hotel--filterResult__listItemSelect {\n    position: sticky;\n    bottom: 0;\n    z-index: 1;\n  }\n}\n\n@media (min-width: 1440px) {\n  .hw-hotel--filterResult__listItemRightWrapper {\n    column-gap: 4rem;\n  }\n}\n\n\n\n@media (min-width: 901px) and (max-width: 1079px) {\n  .hw-hotel--filterResult__listItemSelect .text-right {\n    text-align: left !important;\n  }\n\n  .hw-hotel--filterResult__listItemSelect>* {\n    width: 100%;\n  }\n}\n\n@media (min-width: 480px) and (max-width: 900px) {\n.hw-hotel--filterResult__listItemRightWrapper {\n    align-items: flex-end;\n  }\n   .hw-singleListOut--content .hw-hotel--filterResult__listItemInfo {\n      align-self: stretch;\n  }\n  .hw-hotel--filterResult__listItemRightWrapper .hw-hotel--filterResult__listItemSelect {\n    position: sticky;\n    bottom: 0;\n  }\n  .hw-hotel--filterResult__listItemRightWrapper > .hw-hotel--filterResult__listItemInfo {\n  padding-bottom: 2rem;\n}\n}\n\n@media (max-width: 900px) {\n  .hide-down900 {\n    display: none !important;\n  }\n\n  body.filter-collapsed {\n    height: 100%;\n    overflow: hidden;\n  }\n\n  .hw-hotel--asideFilter__top {\n    position: fixed;\n    border-top: .1rem solid var(--hw-gray-400);\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: auto;\n    z-index: 11112;\n  }\n\n  .hw-hotel--filter__body {\n    position: fixed;\n    width: 100%;\n    height: calc(100dvh + -5rem);\n    background-color: rgba(0, 0, 0, 0.6);\n    top: 0;\n    z-index: 111111;\n    left: 0;\n    right: 0;\n    transition: opacity 0.3s ease-in-out;\n  }\n\n  /* .filter-collapsed .hw-hotel--filter__body {\n  display: flex;\n} */\n  body:not(.filter-collapsed) .hw-hotel--filter__body {\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  .hw-hotel--asideFilter__top .hw-hotel--filter__action {\n    background-color: var(--hw-brand-orange);\n    color: var(--hw-white);\n    cursor: pointer;\n  }\n\n  .hw-hotel--asideFilter__top .hw-hotel--filter__action .hw-hotel--filter__actionFilter,\n  .hw-hotel--asideFilter__top .hw-no--link {\n    color: inherit;\n  }\n}\n\n@media (min-width: 480px) and (max-width: 899px) {\n  .hw-hotel--filterResult__listItemSelect {\n    max-width: 18.1rem;\n  }\n}\n\n@media (max-width: 767px) {\n\n.hw-hotel--singleListOut > .row > .hw-singleListOut--content {\n  margin-top: 1.6rem;\n}\n  .hw-hotel--filterResult__listItem {\n    background-color: var(--hw-white);\n    border-radius: 1rem;\n    padding: 1.5rem;\n    display: flex;\n    column-gap: 1.6rem;\n    row-gap: 1rem;\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 479px) {\n\n\n  .hw-hotel--filterResult__listItemRightWrapper {\n    flex-direction: column;\n    row-gap: 1rem;\n  }\n\n  .hw-hotel--filterResult__listItemInfo {\n    row-gap: .5rem;\n    border-right-width: 0;\n    padding-right: 0;\n  }\n\n  .hw-hotel--filterResult__listItemSelect {\n    align-items: flex-start;\n  }\n\n  .hw-hotel--filterResult__listItemSelect .text-right {\n    text-align: left !important;\n  }\n\n  .hw-hotel--filterResult__listItemSelect>* {\n    width: 100%;\n  }\n}\n\n/*Hotels List End*/\n\n/*Hotel order section*/\n.hw-hotel--steps {\n  overflow: hidden;\n  background-color: var(--hw-gray-100);\n  display: grid;\n}\n\n.hw-hotel--steps .row {\n  --bs-gutter-x: 2rem;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n}\n\n.hw-hotel--steps .row>.hw-step:not(:last-child)::after {\n  content: '';\n  background-color: var(--hw-gray-400);\n  height: .2rem;\n  min-width: 10rem;\n  display: inline-flex;\n  flex: 1;\n}\n\n.hw-hotel--steps .row>.hw-step.complete::after {\n  background-color: var(--hw-green);\n}\n\n.radius-null {\n  border-radius: 0 !important;\n}\n\n.hw-hotel--hotelDetails.hw-passenger--pageList {\n  background-color: var(--hw-gray-100);\n}\n\n/* .hw-hotel--hotelDetails.hw-passenger--pageList .hw-flight--stepsWrapper {\n\n  top: 11.1rem;\n  position: relative;\n} */\n.hw-hotel--hotelDetails .hw-passenger--wrapper {\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.hw-hotel--hotelDetails .hw-passenger--fareSummary {\n  border-radius: 1rem;\n  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.10);\n  margin-top: 1rem;\n}\n\n\n.hw-hotel--hotelDetails .hw-passenger--list .hw-passenger--head {\n  border-bottom-width: 0;\n}\n\n.hw-primary--icon svg {\n  color: var(--hw-brand-orange);\n}\n\n.hw-pointer {\n  cursor: pointer;\n}\n\n.hw-hotel--hotelDetails .hw-passenger--listShow,\n.hw-hotel--hotelDetails .hw-passenger--list .hw-passenger--head {\n  padding-left: 0;\n}\n\n.hw-hotel--hotelDetails .hw-radio--inline {\n  gap: 1.2rem;\n}\n\n.hw-radio--btnIcon {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.hw-radio--btnIcon input[type=\"radio\"] {\n  border: .1rem solid var(--hw-brand-orange);\n  min-width: 9.6rem;\n  min-height: 4rem;\n  border-radius: .4rem;\n  outline: none !important;\n  box-shadow: none !important;\n  background: var(--hw-white);\n  transition: .12s ease-in-out;\n  cursor: pointer;\n}\n\n.hw-radio--btnIcon input[type=\"radio\"]:hover {\n  background-color: var(--hw-brand-orange-light);\n  border-color: var(--hw-brand-orange-light);\n}\n\n.hw-radio--btnIcon input[type=\"radio\"]:checked {\n  background-color: var(--hw-brand-orange);\n  border-color: var(--hw-brand-orange);\n  color: var(--hw-white);\n}\n\n.hw-radio--btnText {\n  position: absolute;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  column-gap: .4rem;\n  color: var(--hw-brand-orange);\n  font-weight: 500;\n  pointer-events: none;\n}\n\n.hw-radio--btnIcon input[type=\"radio\"]:checked~.hw-radio--btnText {\n  color: var(--hw-white);\n}\n\n.hw-radio--btnText svg {\n  width: 2rem;\n  height: 2rem;\n  display: block;\n}\n\n/* .hw-hotel--hotelDetails .hw-passenger--fareSummary__tfoot {\n  border-top: .1rem solid var(--hw-gray-400);\n  margin-left: 2rem;\n  margin-right: 2rem;\n  padding-left: 0;\n  padding-right: 0;\n} */\n.hw-hotel--hotelDetails .hw-term--conditionInput {\n  column-gap: 1rem;\n}\n\n.hw-hotel--bookingConfirmed {\n  background-color: var(--hw-brand-blue);\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n  color: var(--hw-white);\n}\n\n.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary__box {\n  padding: 0;\n}\n\n.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary {\n  top: 0;\n  margin-top: 0;\n  background-color: rgba(0, 0, 0, 0) !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n}\n\n.hw-hotel--summaryTotal {\n  border-top: .1rem solid var(--hw-gray-200);\n  padding-top: 1rem;\n}\n\n.hw-hotel-checkout--preview .hw-passenger--fareShowToggleContent {\n  padding: 0;\n  border-width: 0;\n}\n\n.hw-passenger--listShow__widget.hw-hotel-checkout--terms {\n  padding: 0;\n}\n\n.hw-passenger--listShow__widget.hw-hotel-checkout--terms .hw-passenger--fareShowToggle {\n  padding: 1.5rem;\n}\n\n.hw-passenger--listShow__widget.hw-hotel-checkout--terms .arrow-ul {\n  padding: 1.5rem;\n  border-top: .1rem solid var(--hw-gray-400);\n}\n\n.arrow-ul ul {\n  list-style: none;\n  padding: 0;\n}\n\n.hw-hotel-checkout--preview .hw-table--defaultDiv {\n  margin-top: 0;\n}\n\n.hotel-loader {\n  /* position: relative; */\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n  background-color: var(--hw-brand-orange-light);\n}\n\n.hw-before-loader--status.hotel {\n  height: 100%;\n}\n\n/* Room Selection Loader - Simple Centered Spinner */\n.hw-room-selection-loader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  visibility: hidden;\n  background: transparent;\n  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out, background 0.3s ease-in-out;\n}\n\n.hw-before-loader--status.hotel {\n  height: 100%;\n  z-index: 0;\n  position: relative;\n}\n\n.hw-before-loader--status-half.hotel {\n  z-index: 0;\n  position: relative;\n}\n\n@media (min-width: 901px) {\n  .hw-loader--text {\n    font-size: 1.8rem;\n  }\n\n  .hw-before-loader--status,\n  .hw-before-loader--status-half {\n    left: 0 !important;\n  }\n\n  .filter-collapsed .hw-before-loader--status,\n  .filter-collapsed .hw-before-loader--status-half {\n    left: 7.4rem;\n  }\n}\n\n.hw-room-selection-loader.show {\n  opacity: 1;\n  visibility: visible;\n  background: rgba(242, 242, 242, 0.747);\n}\n\n.hw-room-selection-loader-spinner {\n  width: 4.8rem;\n  height: 4.8rem;\n  border: 0.5rem solid var(--hw-brand-orange-light);\n  border-top-color: var(--hw-brand-orange);\n  border-radius: 50%;\n  animation: hw-room-selection-spin 2s linear infinite;\n}\n\n@keyframes hw-room-selection-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive adjustments for room selection loader */\n@media (max-width: 768px) {\n  .hw-room-selection-loader-spinner {\n    width: 4rem;\n    height: 4rem;\n    border-width: 0.3rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .hw-room-selection-loader-spinner {\n    width: 3.6rem;\n    height: 3.6rem;\n    border-width: 0.3rem;\n  }\n}\n\n.hw-hotelPassenger--listShow__widget .hw-passenger--detailsGroup {\n  margin-top: 1.5rem;\n}\n\n.hw-hotelContact--listShow__widget .hw-passenger--fareShowToggleContent {\n  padding: 0;\n  border-top-width: 0;\n}\n\n.hw-hotelContact--listShow__widget .hw-passenger--detailsGroup {\n  margin-top: 1.5rem;\n}\n\n@media (min-width: 480px) {\n  .hw-passenger--listShow__widget.hw-hotel-checkout--terms .hw-passenger--fareShowToggle {\n    padding: 2rem;\n  }\n\n  .hw-passenger--listShow__widget.hw-hotel-checkout--terms .arrow-ul {\n    padding: 2rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .hw-hotel--steps .row {\n    --bs-gutter-x: 4rem;\n  }\n\n  .hw-hotel--hotelDetails .hw-passenger--fareSummary__box,\n  .hw-hotel--hotelDetails .hw-passenger--listShow__widget {\n    padding: 2rem;\n  }\n}\n\n@media (max-width: 1024px) {\n\n  .hw-hotel--hotelDetails .hw-passenger--listShow,\n  .hw-hotel--hotelDetails .hw-passenger--list .hw-passenger--head {\n    padding-right: 0;\n  }\n\n  .hw-hotel--hotelDetails .hw-passenger--fareSummary {\n    position: relative;\n    max-height: 100%;\n  }\n\n  .hw-hotel--bookingConfirmed {\n    margin-bottom: 1rem;\n  }\n}\n\n/* @media (min-width: 1025px) {\n  .hw-hotel--hotelDetails .hw-passenger--fareSummary {\n     top: 24rem;\n  }\n} */\n/*End hotel order section*/\n\n\n/*This design related header footer & structure changes*/\nhtml,\nbody {\n  min-height: 100dvh;\n  height: auto;\n\n  /* height: 100%; */\n}\n\nbody>#root {\n  display: grid;\n  grid-template-columns: 100%;\n  min-height: 100dvh;\n  height: auto;\n\n  /* display: grid;\n  grid-template-rows: 1fr;\n  grid-template-columns: 100%;\n  min-height: 100%; */\n  /* height: 100%; */\n}\n\n.hw-app--main {\n\n  background-color: var(--hw-gray-100);\n}\n\n/*Header*/\n\n.hw-main--menuItem {\n  display: flex;\n}\n\n.hw-main--menuItemLink {\n  display: inline-flex;\n  align-items: center;\n  column-gap: .8rem;\n  color: var(--hw-gray-700);\n  position: relative;\n  font-weight: normal;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.hw-main--menuItemLink.show {\n  color: var(--hw-brand-orange);\n}\n\n.hw-main--menuItemLink.show span {\n  color: inherit !important;\n}\n\n.hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink.show::after {\n  width: 100%;\n}\n\n.hw-main--menuItem.active .hw-main--menuItemLink {\n  color: var(--hw-brand-orange);\n}\n\n.dropdown-menu .hw-main--menuItemLink {\n  column-gap: 1rem;\n}\n\n.hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink::after {\n  content: '';\n  background-color: var(--hw-brand-orange);\n  position: absolute;\n  bottom: -1px;\n  width: 0;\n  height: .2rem;\n  transition: width .2s ease-out;\n}\n\n.hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink:hover::after {\n  width: 100%;\n  transform-origin: right;\n}\n\n.hw-main--menuItemLink span {\n  font-weight: bold;\n  color: var(--hw-gray-700);\n}\n\n.dropdown-menu .hw-main--menuItemLink span {\n  font-weight: 500;\n}\n\n.hw-main--menuItemLink:hover span {\n  color: var(--hw-brand-orange);\n}\n\n.hw-main--menuItem.active .hw-main--menuItemLink span {\n  color: var(--hw-brand-orange);\n}\n\n\n\n\n.pe-10 {\n  padding-left: 1rem;\n}\n\n.hw-opacity7 {\n  opacity: 0.7 !important;\n}\n\n.hw-nav--notification {\n  cursor: pointer;\n}\n\n.hw-nav--notification .hw-nav--icon {\n  color: var(--hw-brand-blue);\n}\n\n.header-nav .nav-item.dropdown>.nav-link.nav-currency {\n  color: var(--hw-brand-blue);\n}\n\n.hw-main--menuItem.dropdown .dropdown-menu .hw-main--menuItemLink,\n.hw-profile--dropdown .dropdown-menu .hw-main--menuItemLink {\n  width: 100%;\n}\n\n.hw-main--menuItem.dropdown .dropdown-menu>.hw-main--menuItem:not(:first-child) .hw-main--menuItemLink,\n.hw-profile--dropdown .dropdown-menu>.hw-main--menuItem:not(:first-child) .hw-main--menuItemLink {\n  padding-top: 1rem;\n}\n\n.hw-header--wrapper .hw-main--menu>.hw-main--menuItem {\n  position: relative;\n}\n\n.hw-header--wrapper .hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink {\n  column-gap: 1.6rem;\n  min-width: 5rem;\n  row-gap: 0.4rem;\n}\n\n.hw-header--wrapper .hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink span {\n  font-weight: bold;\n  color: var(--hw-brand-blue);\n}\n\n.hw-header--wrapper .hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink .hw-main--menuIcon {\n  width: 3.5rem;\n  height: 3.5rem;\n  color: var(--header-icon);\n  transition: color 0.3s ease-out;\n}\n\n.hw-header--wrapper .hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink:hover .hw-main--menuIcon,\n.hw-header--wrapper .hw-main--menu>.hw-main--menuItem.active>.hw-main--menuItemLink .hw-main--menuIcon {\n  color: var(--header-icon-hover);\n}\n\n.new-menu--badge {\n  border-radius: 2px;\n  background: linear-gradient(90deg, #F696FF 0%, #8A38F5 100%);\n  font-size: 1.4rem;\n  line-height: 1.8rem;\n  font-weight: bold;\n  color: var(--hw-white);\n  min-height: 1.8rem;\n  min-width: 5rem;\n  text-align: center;\n  max-width: 5rem;\n}\n\n.hw-header--avtar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  /*min-width: 9.6rem;*/\n}\n.hw-profile-text {\n    display: flex;\n    flex-direction: column;\n    line-height: 1;\n    white-space: nowrap;\n}\n\n.hw-avtar--circle {\n  border-radius: 50%;\n  background: linear-gradient(180deg, #3264FF -11%, #668BFF 111%);\n  line-height: 1;\n  font-weight: bold;\n  color: var(--hw-white);\n  width: 40px;\n  height: 40px;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* .hw-wallet--boxDropdown svg {\n  position: absolute;\n  right: 0;\n  top: 0.7rem;\n  width: 2.4rem;\n  height: 2.4rem;\n  display: block;\n} */\n\n.hw-main--menuItem .hw-main--menuIcon svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.hw-profile--dropdown::before{\n      content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    background: var(--hw-gray-400);\n    width: 1px;\n    height: 100%;\n    left: 0;\n}\n\n@media (min-width: 990px) {\n  .hw-profile--dropdown {\n    padding-left: 2.4rem;\n  }\n  .new-menu--badge {\n    position: absolute;\n    top: 0.4rem;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .hw-header--wrapper .hw-main--menu>.hw-main--menuItem,\n  .hw-header--wrapper .header-nav>ul {\n    padding-top: 1.2rem;\n  }\n\n  .hw-header--avtar {\n    row-gap: 0.4rem;\n  }\n\n  .hw-main--menu>.hw-main--menuItem.active>.hw-main--menuItemLink::after {\n    width: 100%;\n  }\n}\n\n/* .dropdown-menu.hw-header--dropdown {\n  margin-top: -1rem !important;\n} */\n\n/*sidebar toggle*/\n.hw-nav--profile.show .icon-chevronDown {\n  transform: scaleY(-1);\n}\n\n.hw-wallet--amount {\n  background-color: #E6EFFF;\n  padding: 0.4rem 1.2rem;\n  border-radius: 999px;\n  white-space: nowrap;\n  font-size: 1.2rem;\n  line-height: 1.33333;\n  color: var(--hw-brand-orange) !important;\n  margin-left: 0.4rem;\n  overflow: hidden;\n}\n\n@media (min-width: 1250px) {\n  span.hw-wallet--amount {\n    margin-left: 0.8rem;\n  }\n\n  .hw-toggle--sidebarBtn {\n    display: none !important;\n  }\n\n  .hw-header--wrapper .hw-main--menu {\n    flex: 1 0 0;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    justify-content: center;\n  }\n\n  .hw-main--menu {\n    display: flex;\n    column-gap: 1.6rem;\n    flex-wrap: wrap;\n  }\n\n  .dropdown-menu .hw-main--menuItemLink {\n    column-gap: 1.6rem;\n  }\n\n  .hw-header--wrapper .hw-main--menu>.hw-main--menuItem>.hw-main--menuItemLink {\n    flex-direction: column;\n    height: 100%;\n    justify-content: center;\n  }\n}\n\n@media (min-width: 990px) and (max-width: 1080px) {\n  .hw-main--menuItemLink {\n    font-size: 1.5rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .hw-header--wrapper .hw-main--menu {\n    padding-right: 2.8rem;\n  }\n\n  .hw-main--menuItem.dropdown .dropdown-menu>.hw-main--menuItem:not(:first-child) .hw-main--menuItemLink,\n  .hw-profile--dropdown .dropdown-menu>.hw-main--menuItem:not(:first-child) .hw-main--menuItemLink {\n    padding-top: 1.6rem;\n  }\n\n  .hw-main--menu {\n    column-gap: 2rem;\n  }\n}\n\n@media (min-width: 1400px) {\n  /* .hw-main--menu {\n    column-gap: 3rem;\n    justify-content: center;\n  } */\n}\n\n\n@media (max-width: 1250px) {\n  .sidebar-collapsed {\n    height: 100%;\n    overflow: hidden;\n  }\n\n  .hw-sidebar {\n    transition: left .2s ease;\n  }\n\n  .hw-main--menu {\n    position: fixed;\n    top: 11rem;\n    left: 0;\n    bottom: 0;\n    width: 95%;\n    z-index: 1000;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: thin;\n    scrollbar-color: var(--hw-brand-orange-light) var(--hw-gray-100);\n    background-color: var(--hw-white);\n    border-top-right-radius: 1rem;\n    max-width: 50rem;\n    border-bottom-right-radius: 1rem;\n    padding: 2rem !important;\n    transition: left 0.3s ease-in-out, opacity 0.6s ease-in-out;\n  }\n\n  .hw-main--menu>.hw-main--menuItem {\n    margin-bottom: 1rem;\n    align-items: center;\n    column-gap: 1rem;\n  }\n\n  .hw-main--menu>.hw-main--menuItem .hw-main--menuItemLink {\n    /* width: 100%; */\n    padding: 0.8rem 0;\n  }\n\n  .hw-main--menu>.hw-main--menuItem.dropdown .dropdown-menu {\n    box-shadow: none !important;\n    border-radius: 0;\n    min-width: 26.1rem;\n    border: none;\n    padding: 0 0 0 2rem;\n  }\n\n  body:not(.sidebar-collapsed) .hw-sidebar {\n    left: -26.5rem;\n  }\n\n  body:not(.sidebar-collapsed) .hw-main--menu {\n    left: -26.5rem;\n    pointer-events: none;\n    opacity: 0;\n  }\n\n  .hw-toggle--sidebarBtn {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 1rem;\n    margin-left: -1rem;\n    cursor: pointer;\n  }\n\n  .hw-toggle--hamburg {\n    display: block;\n    width: 2rem;\n    height: 2rem;\n  }\n\n  .hw-toggle--hamburg span {\n    display: block;\n    width: 1.8rem;\n    height: .2rem;\n    margin-bottom: .4rem;\n    position: relative;\n    background: var(--hw-black);\n    transform-origin: 4px 0px;\n    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0), background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0), opacity 0.55s ease;\n  }\n\n  .hw-toggle--hamburg>span:nth-of-type(3) {\n    transform-origin: 0% 0%;\n  }\n\n  .sidebar-collapsed .hw-toggle--hamburg span {\n    opacity: 1;\n    transform: rotate(45deg) translate(1px, 1px);\n  }\n\n  .sidebar-collapsed .hw-toggle--hamburg span:nth-of-type(2) {\n    opacity: 0;\n    transform: rotate(0deg) scale(0.2, 0.2);\n  }\n\n  .sidebar-collapsed .hw-toggle--hamburg span:nth-of-type(3) {\n    transform: rotate(-45deg) translate(0, -1px);\n  }\n\n  body:not(.sidebar-collapsed) .hw-menu--overlay {\n    opacity: 0;\n  }\n\n  .hw-menu--overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(var(--hw-brand-blue-rgb), .5);\n    z-index: 99;\n    pointer-events: none;\n    opacity: 1;\n    transition: opacity .3s ease;\n  }\n}\n\n@media (max-width: 599px) {\n  .hw-mhide {\n    display: none !important;\n  }\n\n  .hw-header--logo img {\n    max-width: 30vw;\n    max-height: 5rem;\n  }\n\n  .header-nav .pe-10 {\n    padding-left: .5rem;\n  }\n}\n\n@media (max-width: 900px) {\n  /* compact, shrink-safe header: AED switcher never gets clipped */\n  .hw-header--wrapper { gap: 8px; align-items: center; }\n  .hw-header--wrapper .header-nav { flex: 0 1 auto; min-width: 0; }\n  .header-nav > ul { gap: 8px; flex-wrap: nowrap; min-width: 0; }\n  .header-nav > ul > li { min-width: 0; }\n  .hw-profile--dropdown { min-width: 0; }\n  .hw-nav--profile .hw-profile-text .hw-text14 {line-height: 2.4 !important; min-width: 0; }\n  .hw-nav--profile { column-gap: 6px; min-width: 0;padding-right: 0 !important; }\n  .hw-header--avtar { gap: 6px; min-width: 0; }\n  .hw-avtar--circle { width: 32px; height: 32px; flex: none; }\n  .hw-profile-text { min-width: 0; }\n  .hw-nav--profile .hw-profile-text .hw-text12 { display: none; }\n  .hw-nav--profile .hw-profile-text .hw-text14 { font-size: 1.3rem !important; line-height: 2.4 !important; min-width: 0; }\n  .hw-nav--profile .hw-profile-text .hw-text14 > div { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n  .hw-profile--dropdown::before { display: none; }\n  .hw-currency-switch-li { flex: 0 0 auto; }\n}\n\n@media (max-width: 575px) {\n  /* phones: bar shows avatar + chevron + AED; balance moves to the avatar dropdown (My Wallet) */\n  .hw-nav--profile .hw-profile-text .hw-text14 > div { display: none; }\n}\n\n@media (max-width: 479px) {\n  .hw-input--switchGroup .hw-text14 {\n    font-size: 1.2rem !important;\n    line-height: normal;\n  }\n  .hw-header--logo img { max-width: 26vw; }\n  .hw-avtar--circle { width: 30px; height: 30px; }\n}\n\n@media (max-width: 1250px) {\n  /* hamburger layout: logo stays left, profile + currency pinned right (overrides the centered desktop grid) */\n  .hw-header .hw-header--wrapper { display: flex; align-items: center; }\n  .hw-header .hw-header--wrapper .header-nav { margin-left: auto; margin-right: 0; align-items: center; }\n}\n\n@media (min-width: 768px) and (max-width: 989px) {\n  /* tablet / iPad: clean, overflow-safe (balance stays visible) */\n  .hw-nav--profile .hw-profile-text .hw-text12 { display: none; }\n  .hw-nav--profile { column-gap: 1rem; min-width: 0; }\n  .hw-header--avtar { gap: 8px; min-width: 0; }\n  .hw-header--wrapper .header-nav { min-width: 0; }\n  .header-nav > ul { flex-wrap: nowrap; min-width: 0; }\n  .header-nav > ul > li { min-width: 0; }\n  .hw-nav--profile .hw-profile-text { min-width: 0; }\n  .hw-nav--profile .hw-profile-text .hw-text14 > div { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n  .hw-currency-switch-li { flex: 0 0 auto; }\n}\n\n/*End sidebar toggle*/\n\n/*End header*/\n\n.hw-page--width {\n  max-width: 144rem;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n@media (min-width: 600px) {\n  .hw-page--width {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .hw-page--width {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n}\n\n@media (min-width: 1300px) {\n  .hw-page--width {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n}\n\n@media (min-width: 1400px) {\n  .hw-page--width {\n    padding-left: 10rem;\n    padding-right: 10rem;\n  }\n}\n\n/*End This design related header footer & structure changes*/\n#hotel_guest_reviews .slick-list {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n\n#hotel_guest_reviews .slick-slide {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.hw-passenger--listShow__widget.hw-hotel-checkout--terms {\n  padding: 0;\n}\n\n\n\n/*Date-Picker Mobile*/\n@media (max-width: 479px) {\n  body main .react-datepicker {\n    font-size: 1rem;\n    border-radius: 0.4rem;\n    padding: .2rem;\n  }\n\n  body main .react-datepicker__current-month,\n  body main .react-datepicker-time__header,\n  body main .react-datepicker-year-header {\n    font-size: 1.2rem;\n    line-height: 1.5;\n  }\n\n  body main .react-datepicker .react-datepicker__navigation {\n    background-size: 1.8rem 1.8rem;\n    width: 1.8rem;\n    height: 1.8rem;\n    top: 4px;\n  }\n\n  body main .react-datepicker__day-names {\n    column-gap: 0;\n    margin-bottom: -4px;\n    margin-top: 0;\n  }\n\n  body main .react-datepicker__day-name {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 360px) {\n  body main .react-datepicker {\n    font-size: 0.8rem;\n    padding: .1rem;\n  }\n\n  body main .react-datepicker__current-month,\n  body main .react-datepicker-time__header,\n  body main .react-datepicker-year-header {\n    font-size: 1rem;\n  }\n\n  body main .react-datepicker__day-name {\n    font-size: 0.8rem;\n  }\n\n  body main .react-datepicker .react-datepicker__navigation {\n    background-size: 1.4rem 1.4rem;\n    width: 1.4rem;\n    height: 1.4rem;\n    top: 1px;\n  }\n}\n\n/*End Date-Picker Mobile*/\n\n/* Image Gallery Popup Styles */\n.hw-gallery-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n}\n\n.hw-gallery-modal.show {\n  opacity: 1;\n  visibility: visible;\n}\n\n.hw-gallery-modal-dialog {\n  width: 100%;\n  /* max-width: 90vw; */\n  max-width: clamp(50vw,90vw,80rem);\n  max-height: 90vh;\n  margin: 2rem;\n  position: relative;\n}\n\n.hw-gallery-modal-content {\n  background: var(--hw-white);\n  border-bottom-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n  box-shadow: 0 2rem 6rem rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.hw-gallery-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.6rem;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.10);\n  background: var(--hw-white);\n  flex-shrink: 0;\n}\n\n.hw-gallery-modal-headerTitle {\n  font-size: 2rem;\n  font-weight: bold;\n  color: var(--hw-brand-blue);\n}\n\n.hw-gallery-modal-close {\n  background: none;\n  border: none;\n  padding: 0.8rem;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n  color: #6b7280;\n}\n\n.hw-gallery-modal-close:hover {\n  background-color: #f3f4f6;\n  color: #374151;\n}\n\n.hw-gallery-modal-close svg {\n  width: 2.4rem;\n  height: 2.4rem;\n}\n\n.hw-gallery-modal-body {\n  padding: 1.6rem;\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  row-gap: 1.2rem;\n}\n\n.hw-gallery-main-image-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40rem;\n  background: #f9fafb;\n  border-radius: 1.2rem;\n  overflow: hidden;\n}\n\n.hw-gallery-main-image {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hw-gallery-main-image img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  border-radius: 0.8rem;\n  transition: transform 0.3s ease;\n}\n\n.hw-gallery-main-image img:hover {\n  transform: scale(1.02);\n}\n\n.hw-gallery-nav-btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  width: 4.8rem;\n  height: 4.8rem;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  z-index: 10;\n  box-shadow: 0 0.4rem 1.2rem rgba(0, 0, 0, 0.15);\n}\n\n.hw-gallery-nav-btn:hover {\n  background: rgba(255, 255, 255, 1);\n  transform: translateY(-50%) scale(1.05);\n  box-shadow: 0 0.6rem 1.8rem rgba(0, 0, 0, 0.2);\n}\n\n.hw-gallery-nav-btn svg {\n  width: 2.4rem;\n  height: 2.4rem;\n  color: #374151;\n}\n\n.hw-gallery-nav-prev {\n  left: 2rem;\n}\n\n.hw-gallery-nav-next {\n  right: 2rem;\n}\n\n.hw-gallery-thumbnails {\n  display: flex;\n  gap: 1.2rem;\n  overflow-x: auto;\n  padding: 0.8rem 0;\n  scrollbar-width: thin;\n  scrollbar-color: #d1d5db #f3f4f6;\n   scrollbar-width: none;      \n  -ms-overflow-style: none;\n}\n\n\n\n\n.hw-gallery-thumbnails::-webkit-scrollbar {\n  height: 0.8rem;\n}\n\n.hw-gallery-thumbnails::-webkit-scrollbar-track {\n  background: #f3f4f6;\n  border-radius: 0.4rem;\n}\n\n.hw-gallery-thumbnails::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 0.4rem;\n}\n\n.hw-gallery-thumbnails::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\n.hw-gallery-thumbnails::-webkit-scrollbar {\n  display: none;               /* Chrome, Safari, Opera */\n}\n\n.hw-gallery-thumbnail {\n  flex-shrink: 0;\n  width: 8rem;\n  height: 8rem;\n  border-radius: 0.8rem;\n  overflow: hidden;\n  cursor: pointer;\n  border: 0.2rem solid transparent;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.hw-gallery-thumbnail:hover {\n  border-color: #0062FF;\n  transform: scale(1.05);\n}\n\n.hw-gallery-thumbnail.active {\n  border-color: #0062FF;\n  box-shadow: 0 0 0 0.2rem rgba(0, 98, 255, 0.2);\n}\n\n.hw-gallery-thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.2s ease;\n}\n\n.hw-gallery-thumbnail:hover img {\n  transform: scale(1.1);\n}\n\n.hw-gallery-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  /* z-index: 10000; */\n  z-index: 99999;\n  cursor: pointer;\n}\n\n/* Responsive Design */\n@media (min-width: 768px) {\n  .hw-gallery-modal-header {\n   padding: 2rem 2.4rem;\n}\n.hw-gallery-modal-body {\n  padding: 2.4rem;\n}\n}\n\n@media (max-width: 768px) {\n  .hw-gallery-modal-dialog {\n    max-width: 95vw;\n    margin: 1rem;\n  }\n\n \n\n  .hw-gallery-modal-headerTitle {\n    font-size: 1.8rem;\n  }\n\n  .hw-gallery-modal-body {\n    padding: 1.6rem;\n    gap: 1.6rem;\n  }\n\n  .hw-gallery-main-image-container {\n    min-height: 30rem;\n  }\n\n  .hw-gallery-nav-btn {\n    width: 4rem;\n    height: 4rem;\n  }\n\n  .hw-gallery-nav-btn svg {\n    width: 2rem;\n    height: 2rem;\n  }\n\n  .hw-gallery-nav-prev {\n    left: 1rem;\n  }\n\n  .hw-gallery-nav-next {\n    right: 1rem;\n  }\n\n  .hw-gallery-thumbnail {\n    width: 6rem;\n    height: 6rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .hw-gallery-modal-dialog {\n    max-width: 98vw;\n    margin: 0.5rem;\n  }\n\n\n\n\n  .hw-gallery-modal-body {\n    padding: 1.2rem;\n    gap: 1.2rem;\n  }\n\n  .hw-gallery-main-image-container {\n    min-height: 25rem;\n  }\n\n  .hw-gallery-nav-btn {\n    width: 3.6rem;\n    height: 3.6rem;\n  }\n\n  .hw-gallery-nav-btn svg {\n    width: 1.8rem;\n    height: 1.8rem;\n  }\n\n  .hw-gallery-thumbnail {\n    width: 5rem;\n    height: 5rem;\n  }\n}\n\n/* Animation for popup */\n@keyframes galleryFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.hw-gallery-modal.show .hw-gallery-modal-content {\n  animation: galleryFadeIn 0.3s ease-out;\n}\n\n/* Touch-friendly navigation for mobile */\n@media (hover: none) and (pointer: coarse) {\n  .hw-gallery-nav-btn {\n    width: 5.6rem;\n    height: 5.6rem;\n  }\n\n  .hw-gallery-nav-btn svg {\n    width: 2.8rem;\n    height: 2.8rem;\n  }\n\n  .hw-gallery-thumbnail {\n    width: 7rem;\n    height: 7rem;\n  }\n}\n\n/* Gallery Zoom Styles */\n.hw-gallery-clickable-image {\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.hw-gallery-clickable-image:hover {\n  transform: scale(1.02);\n}\n\n.hw-gallery-zoom-hint {\n  position: absolute;\n  bottom: 1rem;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 0.6rem 1.2rem;\n  border-radius: 2rem;\n  font-size: 1.2rem;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.hw-gallery-main-image:hover .hw-gallery-zoom-hint {\n  opacity: 1;\n}\n\n/* Full Screen Zoom Overlay */\n.hw-gallery-zoom-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.95);\n  z-index: 99999990;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: zoomFadeIn 0.3s ease-out;\n}\n\n.hw-gallery-zoom-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.hw-gallery-zoom-header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2rem 3rem;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8), transparent);\n  z-index: 10;\n}\n\n.hw-gallery-zoom-title {\n  color: white;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.hw-gallery-zoom-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  padding: 1rem;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  color: white;\n}\n\n.hw-gallery-zoom-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.hw-gallery-zoom-close svg {\n  width: 2.4rem;\n  height: 2.4rem;\n}\n\n.hw-gallery-zoom-image-container {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 8rem 3rem 12rem 3rem;\n}\n\n.hw-gallery-zoom-image {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.hw-gallery-zoom-image img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  border-radius: 0.8rem;\n  transition: transform 0.3s ease;\n  box-shadow: 0 2rem 6rem rgba(0, 0, 0, 0.5);\n}\n\n.hw-gallery-zoom-image img:hover {\n  transform: scale(1.02);\n}\n\n.hw-gallery-zoom-nav-btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  width: 6rem;\n  height: 6rem;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  z-index: 10;\n  color: white;\n}\n\n.hw-gallery-zoom-nav-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-50%) scale(1.1);\n}\n\n.hw-gallery-zoom-nav-btn svg {\n  width: 3rem;\n  height: 3rem;\n}\n\n.hw-gallery-zoom-nav-prev {\n  left: 3rem;\n}\n\n.hw-gallery-zoom-nav-next {\n  right: 3rem;\n}\n\n.hw-gallery-zoom-instructions {\n  position: absolute;\n  bottom: 3rem;\n  left: 50%;\n  transform: translateX(-50%);\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 1.4rem;\n  text-align: center;\n  background: rgba(0, 0, 0, 0.5);\n  padding: 1rem 2rem;\n  border-radius: 2rem;\n  backdrop-filter: blur(10px);\n}\n\n@keyframes zoomFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Responsive Zoom Styles */\n@media (max-width: 768px) {\n  .hw-gallery-zoom-header {\n    padding: 1.5rem 2rem;\n  }\n\n  .hw-gallery-zoom-title {\n    font-size: 1.6rem;\n  }\n\n  .hw-gallery-zoom-image-container {\n    padding: 6rem 2rem 10rem 2rem;\n  }\n\n  .hw-gallery-zoom-nav-btn {\n    width: 5rem;\n    height: 5rem;\n  }\n\n  .hw-gallery-zoom-nav-btn svg {\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n\n  .hw-gallery-zoom-nav-prev {\n    left: 2rem;\n  }\n\n  .hw-gallery-zoom-nav-next {\n    right: 2rem;\n  }\n\n  .hw-gallery-zoom-instructions {\n    font-size: 1.2rem;\n    padding: 0.8rem 1.6rem;\n    bottom: 2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .hw-gallery-zoom-header {\n    padding: 1rem 1.5rem;\n  }\n\n  .hw-gallery-zoom-title {\n    font-size: 1.4rem;\n  }\n\n  .hw-gallery-zoom-image-container {\n    padding: 5rem 1.5rem 8rem 1.5rem;\n  }\n\n  .hw-gallery-zoom-nav-btn {\n    width: 4.5rem;\n    height: 4.5rem;\n  }\n\n  .hw-gallery-zoom-nav-btn svg {\n    width: 2.2rem;\n    height: 2.2rem;\n  }\n\n  .hw-gallery-zoom-nav-prev {\n    left: 1.5rem;\n  }\n\n  .hw-gallery-zoom-nav-next {\n    right: 1.5rem;\n  }\n\n  .hw-gallery-zoom-instructions {\n    font-size: 1.1rem;\n    padding: 0.6rem 1.2rem;\n    bottom: 1.5rem;\n  }\n  .hw-header-line {display: none !important;}\n}\n\n/* Hotel Gallery Image Styles */\n.hw-hotel--imageGallery .hw-img--main,\n.hw-hotel--imageGallery .hw-img--grid {\n  position: relative;\n  overflow: hidden;\n  background-color: var(--hw-gray-100);\n  border-radius: 1rem;\n}\n\n.hw-hotel--imageGallery .hw-img--main img,\n.hw-hotel--imageGallery .hw-img--grid img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* .hw-hotel--imageGallery .hw-img--main {\n  aspect-ratio: 4/3;\n} */\n\n.hw-hotel--imageGallery .hw-img--grid {\n  height: 100%;\n  min-height: 9rem;\n}\n\n.row.hw-hotel--imageGallery {\n  row-gap: 1rem;\n}\n\n\n\n/*New flight design*/\n.hw-top--fixImg {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n\n}\n\n.hw-excursion-banner-img {\n  height: 436px;\n  /* background-image: url('../../../assets/img/excursion-banner-img.jpg'); */\n}\n.hw-excursion-banner-title{\n  color: var(--White, #FFF);\nfont-family: Poppins;\nfont-size: 35px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\nmax-width: 500px;\n}\n\n.hw-top--fixImg img {\n  width: 100%;\n  object-fit: cover;\n  display: block;\n  height: 100%;\n}\n\n.hw-widget.hw-widget--flight:not(.hw-widget--flight__open) {\n  margin-top: 4.8rem;\n}\n\n.hw-widget.hw-widget--flight .hw-widget--card {\n  background-color: var(--hw-white);\n  position: relative;\n}\n\n.hw-widget.hw-widget--flight .hw-input--groupCol {\n  padding: 0;\n}\n\n.hw-recent--viewedList {\n  margin-top: 1.6rem !important;\n  display: flex;\n  column-gap: 2.4rem;\n  overflow-x: auto;\n  padding-bottom: 1.4rem !important;\n}\n\n.hw-recent--viewedList li,\n.hw-recent--viewedList .swiper-slide {\n  border: 1px solid rgba(var(--hw-brand-orange-rgb), 0.2);\n  padding: 1.6rem;\n  border-radius: 0.5rem;\n  min-width: 38.1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  row-gap: 0.6rem;\n  /* max-height: 13rem;\n  overflow-y: auto; */\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.hw-recent--viewedList .swiper-slide:hover {\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-recent--innerList+.hw-recent--innerList {\n  border-top: 1px solid var(--hw-gray-200);\n  margin-top: 0.6rem;\n  padding-top: 0.6rem;\n}\n\n.hw-twoLine--iconFilter {\n  display: flex;\n  width: 100%;\n}\n\n.hw-flight--cTab {\n  background-color: var(--hw-white);\n  padding: 0.1rem 1rem 0.6rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  /* flex-grow: 1; */\n}\n\n.hw-twoLine--iconFilter>.hw-flight--cTab:first-child {\n  border-top-left-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n}\n\n.hw-twoLine--iconFilter>.hw-flight--cTab:last-child {\n  border-top-right-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n\n/* .hw-flight--cTab::before {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 0.4rem;\n  background-color: var(--hw-brand-orange);\n  left: 0;\n  bottom: 0px;\n  transition: width 0.2s linear;\n} */\n\n.hw-flight--cTab.active,\n.hw-flight--cTab:hover {\n  background-color: var(--hw-brand-blue-light);\n}\n\n.hw-flight--cTab.active {\n  background: linear-gradient(90deg, #3264FF 21.17%, #1846D6 82.33%);\n}\n.hw-flight--cTab.active .hw-black900 {\n  color: var(--hw-white) !important;\n}\n.hw-flight--cTab.active .hw-no-price {\n  color: var(--hw-white);\n  opacity: 0.8;\n}\n\n/* .hw-flight--cTab.active::before {\n  width: 100%;\n} */\n\n.hw-twoLine--iconFilter>.hw-flight--cTab:not(:last-child) {\n  border-right: 1px solid var(--hw-gray-600);\n}\n\n.hw-search--flightFilter__stops {\n  display: flex;\n  flex-direction: column;\n  /* row-gap: 0.8rem; */\n  row-gap: 0.2rem;\n}\n\n.hw-search--flightFilter__widget.stops-widget {\n  margin-top: 1rem;\n}\n\n.hw-search--flightFilter__stops>span {\n  padding-top: 0.4rem;\n  padding-bottom: 0.4rem;\n  cursor: pointer;\n  position: relative;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  column-gap: 0.8rem;\n  color: var(--hw-black-900);\n  font-size: 1.4rem;\n  line-height: 1.71429;\n}\n\n.hw-search--flightFilter__stops>span::before {\n  content: '';\n  border: 1px solid var(--hw-gray-700);\n  width: 1.8rem;\n  height: 1.8rem;\n  border-radius: 0.4rem;\n  background-color: var(--hw-white);\n}\n\n.hw-search--flightFilter__stops>span.active::before {\n  --hw-form-check-bg-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'%3E%3Cpath d='M15.4983 4.18945C15.8079 4.46464 15.8358 4.93869 15.5606 5.24828L7.56056 14.2483C7.41824 14.4084 7.21424 14.5 7.00001 14.5C6.78578 14.5 6.58178 14.4084 6.43945 14.2483L2.43945 9.74828C2.16426 9.43869 2.19215 8.96464 2.50174 8.68945C2.81132 8.41426 3.28538 8.44215 3.56056 8.75173L7.00001 12.6211L14.4395 4.25174C14.7146 3.94215 15.1887 3.91426 15.4983 4.18945Z' fill='%23ffffff'/%3E%3C/svg%3E\");\n  background-color: var(--hw-brand-orange);\n  border-color: var(--hw-brand-orange);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  background-image: var(--hw-form-check-bg-image);\n}\n\n.hw-search--flightCheckbox .hw-grid--2auto {\n  grid-template-columns: auto 1fr;\n}\n\n.hw-flight--listBoxAction {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n}\n\n.hw-flight--listOut .f-place {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 0.1rem;\n}\n\n.hw-flight--listOut {\n  display: flex;\n  column-gap: 1.2rem;\n  position: relative;\n}\n\n.hw-flight--marker {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 12px;\n}\n\n.hw-flight--marker .dot {\n  width: 1rem;\n  height: 1rem;\n  background-color: rgba(18, 24, 38, 0.30);\n  border-radius: 50%;\n  position: relative;\n  margin-top: 7px;\n}\n\n.hw-flight--marker .line {\n  width: 2px;\n  background-color: var(--hw-black);\n  flex-grow: 1;\n  opacity: 0.3;\n  margin-top: 7px;\n}\n\n@media (min-width: 600px) {\n  .hw-flight--listOut {\n    column-gap: 2.4rem;\n  }\n\n  .hw-flight--listBox .destination .destination-from,\n  .hw-flight--listBox .destination .destination-to {\n    width: 9rem;\n  }\n\n  .hw-flight--marker .dot {\n    width: 1.4rem;\n    height: 1.4rem;\n  }\n\n  .hw-flight--listOut .f-place {\n    margin-top: 0.4rem;\n  }\n  .hw-flight--cTab {\n  padding: 0.5rem 2rem 1rem;\n  /* min-width: 22.5rem; */\n  min-width: 14rem;\n}\n}\n\n@media (min-width: 1101px) {\n  .hw-flight--listBoxAction {\n    flex-direction: column;\n  }\n\n  .hw-flight--listBox .destination {\n    max-width: 62.6rem;\n  }\n}\n\n@media (max-width: 1100px) {\n  .hw-flight--listBoxAction {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n\n@media (max-width: 599px) {\n  /* .hw-twoLine--iconFilter {\n    flex-wrap: wrap;\n  } */\n\n  .hw-twoLine--iconFilter>.hw-flight--cTab:not(:last-child) {\n    border-right-width: 0;\n  }\n\n  .hw-flight--cTab {\n    flex-grow: 1;\n  }\n\n  .hw-search--flightFilterResult>h3 {\n    font-size: 2rem;\n    line-height: 1.5;\n  }\n}\n\n@media (max-width: 479px) {\n  .hw-twoLine--iconFilter > .hw-flight--cTab .hw-no-price {\n    line-height: 1.25;\n  }\n}\n\n/*Flight Popup - Modern Redesign*/\n.hw-modal--flightBook .hw-modal-dialog {\n  max-width: 100rem;\n  width: 95%;\n}\n\n.hw-modal--flightBook .hw-modal-content {\n  border-radius: 1.2rem;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.15);\n  background-color: var(--hw-white);\n}\n\n.hw-fare-modal-top-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.6rem 2.4rem 1.2rem;\n  background-color: #ffffff;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.hw-fare-modal-title {\n  font-size: 2.5rem;\n  font-weight: 600;\n  color: var(--hw-brand-blue);\n  margin: 0;\n}\n\n.hw-fare-header-close {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748b;\n  padding: 0.6rem;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.hw-fare-header-close:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n/* Collapsible Flight Details Strip matching Reference Image */\n.hw-fare-collapse-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.2rem 2.4rem;\n  background-color: #ffffff;\n  cursor: pointer;\n  border-bottom: 1px solid #e2e8f0;\n  transition: background-color 0.2s ease;\n  user-select: none;\n}\n\n.hw-fare-collapse-bar:hover {\n  background-color: #f8fafc;\n}\n\n.hw-fare-collapse-bar.return-bar {\n  border-top: 1px dashed #e2e8f0;\n}\n\n.hw-fare-collapse-bar-left {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n  font-size: 1.35rem;\n  color: #334155;\n  line-height: 1.3;\n}\n\n.hw-fare-header-airline-img {\n  width: 2.4rem;\n  height: 2.4rem;\n  object-fit: contain;\n  border-radius: 4px;\n}\n\n.hw-fare-collapse-airline {\n  font-weight: 500;\n  color: #1e293b;\n  margin-right: 0.2rem;\n}\n\n.hw-fare-collapse-station {\n  font-weight: 700;\n  color: #0f172a;\n  font-size: 1.45rem;\n}\n\n.hw-fare-collapse-blue-arrow {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #2563eb;\n  margin: 0 0.1rem;\n}\n\n.hw-fare-collapse-blue-arrow svg {\n  stroke: #2563eb !important;\n}\n\n.hw-fare-collapse-meta-text {\n  font-weight: 400;\n  color: #475569;\n}\n\n.hw-fare-collapse-dot {\n  color: #94a3b8;\n  font-size: 1.3rem;\n  margin: 0 0.1rem;\n}\n\n.hw-fare-collapse-toggle-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #0f172a;\n  cursor: pointer;\n  flex-shrink: 0;\n  padding: 0.4rem;\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s ease;\n}\n\n.hw-fare-collapse-toggle-icon.is-open {\n  transform: rotate(180deg);\n}\n\n.hw-fare-collapse-toggle-icon:hover {\n  color: #2563eb;\n}\n\n/* Smooth Accordion Drawer Transitions */\n.hw-fare-drawer-wrapper {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.38s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n}\n\n.hw-fare-drawer-wrapper.is-open {\n  grid-template-rows: 1fr;\n}\n\n.hw-fare-drawer-inner {\n  min-height: 0;\n  overflow: hidden;\n}\n\n.hw-fare-drawer-wrapper .hw-fare-itinerary-drawer {\n  opacity: 0;\n  transform: translateY(-8px);\n  transition: opacity 0.3s ease, transform 0.38s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.hw-fare-drawer-wrapper.is-open .hw-fare-itinerary-drawer {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Collapsible Itinerary Drawer */\n.hw-fare-itinerary-drawer {\n  background: #ffffff;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 2.2rem 2.4rem 2.6rem;\n  /* margin-bottom: 2rem; */\n  max-height: 48rem;\n  overflow-y: auto;\n}\n\n.hw-itinerary-combo-section:not(:first-child) {\n  margin-top: 2rem;\n  padding-top: 1.6rem;\n  border-top: 1px dashed #e2e8f0;\n}\n\n.hw-itinerary-section-heading {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #2563eb;\n  margin-bottom: 1.4rem;\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n/* ========================================================\n   Clean Vertical Itinerary Timeline (matching Reference Image)\n   ======================================================== */\n.hw-flight-timeline {\n  position: relative;\n  padding: 0.6rem 0 0.6rem 3rem;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Continuous vertical track */\n.hw-flight-timeline::before {\n  content: '';\n  position: absolute;\n  left: 0.9rem;\n  top: 0.4rem;\n  bottom: 0.4rem;\n  width: 2px;\n  background-color: #cbd5e1;\n}\n\n.hw-tl-step {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 2rem;\n}\n\n.hw-tl-step:last-child {\n  margin-bottom: 0;\n}\n\n.hw-tl-step.is-layover-step {\n  margin-bottom: 2rem;\n  justify-content: center;\n}\n\n/* Timeline Nodes */\n.hw-tl-node {\n  position: absolute;\n  left: -2rem;\n  top: 1.1rem;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  box-sizing: border-box;\n  z-index: 2;\n}\n\n/* Start & End Nodes: Navy circle with light halo ring */\n.hw-tl-node.is-start,\n.hw-tl-node.is-end {\n  width: 1.4rem;\n  height: 1.4rem;\n  background-color: #0f172a;\n  border: 3px solid #e2e8f0;\n}\n\n/* Mid Nodes: Solid light gray dot */\n.hw-tl-node.is-mid {\n  width: 1rem;\n  height: 1rem;\n  background-color: #cbd5e1;\n}\n\n/* Layover Node: Solid amber dot, vertically centered with the banner */\n.hw-tl-step.is-layover-step .hw-tl-node.is-layover {\n  top: 50%;\n  width: 1rem;\n  height: 1rem;\n  background-color: #f59e0b;\n}\n\n/* Main Row: Datetime, Airport Code, Airport Name, Terminal */\n.hw-tl-main-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.9rem;\n  line-height: 1.3;\n}\n\n.hw-tl-datetime {\n  display: inline-flex;\n  align-items: baseline;\n  line-height: 1.2;\n}\n\n.hw-tl-date {\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n  white-space: nowrap;\n}\n\n.hw-tl-date.is-next-day {\n  color: #0f172a;\n}\n\n.hw-tl-comma {\n  font-size: 1.55rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0.4rem 0 0.1rem;\n}\n\n.hw-tl-time {\n  font-size: 14px;\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n}\n\n.hw-tl-code {\n  font-size: 14px;\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n}\n\n.hw-tl-name {\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: var(--hw-brand-blue);\n}\n\n.hw-tl-terminal-badge {\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: #64748b;\n  background-color: #f1f5f9;\n  padding: 0.2rem 0.6rem;\n  border-radius: 4px;\n  line-height: 1.2;\n}\n\n/* Sub Row: Airline · FlightNumber • Flight time */\n.hw-tl-sub-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.8rem;\n  margin-top: 0.5rem;\n  font-size: 1.3rem;\n  color: #64748b;\n  line-height: 1.3;\n}\n\n.hw-tl-airline-info {\n  font-weight: 500;\n  color: var(--hw-brand-blue);\n}\n\n.hw-tl-bullet {\n  color: var(--hw-brand-blue);\n  font-size: 1.1rem;\n}\n\n.hw-tl-duration-info {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--hw-brand-blue);\n  font-weight: 500;\n}\n\n.hw-tl-clock-icon {\n  color: var(--hw-brand-blue);\n  flex-shrink: 0;\n}\n\n/* Layover Amber Banner */\n.hw-tl-layover-banner {\n  display: flex;\n  align-items: center;\n  /* justify-content: space-between; */\n  max-width: 450px;\n  background-color: #fffdf5;\n  border: 1px solid #fef3c7;\n  border-radius: 8px;\n  padding: 1.1rem 1.6rem;\n  box-sizing: border-box;\n  gap: 1.2rem;\n}\n\n.hw-tl-layover-left {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  flex-wrap: wrap;\n}\n\n.hw-tl-layover-clock {\n  color: #d97706;\n  flex-shrink: 0;\n}\n\n.hw-tl-layover-text {\n  font-size: 1.35rem;\n  font-weight: 600;\n  color: #78350f;\n}\n\n.hw-tl-layover-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background-color: #fef3c7;\n  color: #b45309;\n  border-radius: 6px;\n  padding: 0.4rem 0.9rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.hw-modal--flightBook .hw-modal-body {\n  padding: 1.8rem 2.4rem 2.4rem !important;\n  padding-top: 0 !important;\n  background-color: #fbfcfd;\n}\n\n.hw-modal--bodyFares {\n  padding-top: 0;\n  position: relative;\n}\n\n/* Modern Fare Cards matching Image 2 */\n.hw-fare--slider .swiper-slide {\n  min-width: 28rem !important;\n  max-width: 31rem !important;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.8rem;\n  background-color: #ffffff;\n  transition: all 0.2s ease;\n  overflow: hidden;\n}\n\n.hw-fare--slider .swiper-slide:hover {\n  border-color: var(--hw-brand-orange, #ff4f17);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n}\n\n/* .hw-fare--slideItem.is-selected,\n.hw-fare--slider .swiper-slide:has(.is-selected) {\n  border: 2px solid #008cff !important;\n  box-shadow: 0 4px 16px rgba(0, 140, 255, 0.15) !important;\n} */\n\n.hw-fare--slideItem {\n  height: 100%;\n}\n\n.hw-fare--slideBox {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #ffffff;\n}\n\n.hw-fare--slideItem .b-top {\n  display: flex;\n  flex-direction: column;\n  padding: 1.6rem 1.6rem 1.2rem;\n  border-bottom: 1px solid #f1f5f9;\n  background: #ffffff;\n}\n\n.hw-fare--slideItem .b-top--header-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.hw-fare--slideItem .hw-price-amount {\n  font-size: 2.2rem;\n  font-weight: 800;\n  color: #111827;\n  line-height: 1.2;\n}\n\n.hw-fare--slideItem .hw-per-adult {\n  font-size: 1.2rem;\n  color: #6b7280;\n  font-weight: 500;\n  margin-left: 0.6rem;\n}\n\n.hw-fare-card-badge {\n  border: 1px solid var(--hw-brand-orange);\n  color: var(--hw-brand-orange);\n  font-size: 1.05rem;\n  font-weight: 700;\n  border-radius: 4px;\n  padding: 0.2rem 0.6rem;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  background: #ffffff;\n  white-space: nowrap;\n}\n\n.hw-fare-identifier {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-top: 0.4rem;\n}\n\n.hw-fare--slideBox .b-middle {\n  padding: 1.4rem 1.6rem;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1.4rem;\n}\n\n.hw-fare--slideBox .b-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.hw-fare--slideBox .b-middle .b-mmiddle--title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n  text-transform: capitalize;\n}\n\n.hw-fare--slideBox .b-mmiddle--list {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.8rem;\n  font-size: 1.25rem;\n  color: #374151;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.hw-fare-icon-green,\n.hw-fare-icon-amber,\n.hw-fare-icon-red {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 0.2rem;\n}\n\n.hw-text-teal {\n  color: #0d9488;\n  font-weight: 700;\n}\n\n.b-bundle-box {\n  background: #fffbeb;\n  border: 1px solid #fef3c7;\n  border-radius: 6px;\n  padding: 0.8rem 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #92400e;\n}\n\n.hw-fare--slideBox .b-footer {\n  padding: 1.4rem 1.6rem 1.6rem;\n  background: #ffffff;\n  /* border-top: 1px solid #f8fafc; */\n}\n\n.hw-btn--book-now {\n  background: rgba(50, 100, 255, 0.10) !important;\n  color: var(--hw-brand-orange) !important;\n  font-weight: 700 !important;\n  font-size: 1.4rem !important;\n  padding: 1.2rem 1.6rem !important;\n  border-radius: 6px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.5px !important;\n  border: none !important;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.hw-btn--book-now:hover {\n  background: var(--hw-blue-new) !important;\n  color: #ffffff !important;\n}\n\n.hw-btn--selected-fare {\n  background: var(--hw-blue-new) !important;\n  color: #ffffff !important;\n  font-weight: 700 !important;\n  font-size: 1.4rem !important;\n  padding: 1.2rem 1.6rem !important;\n  border-radius: 6px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.5px !important;\n  border: none !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  width: 100%;\n}\n\n/* Swiper top-right navigation buttons - placed side-by-side near each other */\n.hw-fare--slider {\n  position: relative;\n}\n\n.hw-fare--slider .swiper {\n  position: relative;\n  padding-top: 4.8rem !important;\n  padding-bottom: 1.6rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n}\n\n.hw-fare--slider .swiper-button-prev,\n.hw-fare--slider .swiper-button-next {\n  position: absolute !important;\n  top: 0.4rem !important;\n  bottom: auto !important;\n  margin-top: 0 !important;\n  transform: none !important;\n  width: 3.6rem !important;\n  height: 3.6rem !important;\n  border-radius: 50% !important;\n  background-color: #ffffff !important;\n  border: 1.5px solid #e2e8f0 !important;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;\n  z-index: 25 !important;\n  cursor: pointer !important;\n  outline: none !important;\n  background-repeat: no-repeat !important;\n  background-position: center center !important;\n  background-size: 1.8rem 1.8rem !important;\n  transition: all 0.2s ease !important;\n  font-size: 0 !important;\n}\n\n.hw-fare--slider .swiper-button-prev::after,\n.hw-fare--slider .swiper-button-next::after {\n  display: none !important;\n}\n\n/* Prev button: placed near next button on the top right */\n.hw-fare--slider .swiper-button-prev {\n  left: auto !important;\n  right: 4.8rem !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%231e293b' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M15 18L9 12L15 6'/%3E%3C/svg%3E\") !important;\n}\n\n/* Next button: placed at right side top corner */\n.hw-fare--slider .swiper-button-next {\n  left: auto !important;\n  right: 0.6rem !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%231e293b' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M9 18L15 12L9 6'/%3E%3C/svg%3E\") !important;\n}\n\n.hw-fare--slider .swiper-button-prev:hover {\n  background-color: #f8fafc !important;\n  border-color: #2563eb !important;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.18) !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%232563eb' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M15 18L9 12L15 6'/%3E%3C/svg%3E\") !important;\n}\n\n.hw-fare--slider .swiper-button-next:hover {\n  background-color: #f8fafc !important;\n  border-color: #2563eb !important;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.18) !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%232563eb' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M9 18L15 12L9 6'/%3E%3C/svg%3E\") !important;\n}\n\n/* Disabled state */\n.hw-fare--slider .swiper-button-prev.swiper-button-disabled,\n.hw-fare--slider .swiper-button-next.swiper-button-disabled {\n  opacity: 0.3 !important;\n  cursor: not-allowed !important;\n  pointer-events: none !important;\n  background-color: #f1f5f9 !important;\n  border-color: #e2e8f0 !important;\n  box-shadow: none !important;\n}\n\n.hw-search--flightListBottomFooter {\n  /* position: sticky; */\n  position: fixed;\n  bottom: 5.2rem;\n  left: 0;\n  right: 0;\n  z-index: 101;\n  background-color: var(--hw-brand-blue-light);\n  min-height: 6.8rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n/* .hw-flight--listBoxInner.hw-mlCity {\n  max-width: 57.6rem;\n} */\n\n.hw-fare--slider .swiper-container {\n  user-select: none;\n  /* Prevent text selection */\n}\n\n.hw-fare--slider .swiper-slide {\n  user-select: none;\n  /* Prevent text selection */\n}\n\n.hw-fare--slider {\n  /* margin-top: 1.2rem; */\n}\n\n@media (min-width: 576px) {\n  /* .hw-modal--flightBook .hw-modal-dialog {\n    --bs-modal-width: 97.4rem;\n  max-width: var(--bs-modal-width);\n  } */\n}\n\n@media (min-width: 768px) {\n  .hw-widget.hw-widget--flight:not(.hw-widget--flight__open) {\n    margin-top: 11rem;\n  }\n\n  .hw-modal--flightBook .hw-modal-body {\n    padding: 1.8rem 2.4rem 2.4rem;\n  }\n\n  .hw-fare--slider {\n    /* margin-top: 1.4rem; */\n    margin-left: 0;\n  }\n\n  .hw-fare--slider .swiper {\n    padding: 4.8rem 0.4rem 1.6rem !important;\n  }\n\n  .hw-modal--bodyFares {\n    margin-right: 0;\n  }\n}\n\n@media (min-width: 901px) {\n  .hw-search--flightListBottomFooter {\n    bottom: 0;\n    margin-top: 4rem;\n  }\n}\n\n@media (min-width: 990px) {\n  .hw-modal--bodyFares {\n    padding-top: 0.8rem;\n  }\n\n  .hw-modal--flightBook .hw-modal-headerTitle {\n    column-gap: 0.8rem;\n    font-size: 2.5rem;\n  }\n\n  .hw-modal--bodyTop {\n    row-gap: 1.6rem;\n  }\n\n  .hw-fare--slideItem .b-top {\n    padding: 1.6rem 1.6rem 1.2rem 1.6rem;\n    gap: 0.4rem;\n  }\n\n  .hw-fare--slideBox .b-footer {\n    /* padding-top: 2.4rem; */\n  }\n\n  .hw-fare--slideBox .b-middle {\n    padding: 1.2rem 1.6rem 0;\n  }\n\n  /* .hw-fare--slideItem {\n    min-width: 35rem;\n    max-width: 35rem;\n  } */\n  .hw-fare--slider .swiper-slide {\n    min-width: 29rem !important;\n    max-width: 32rem !important;\n  }\n}\n\n@media (min-width: 1440px) {\n  .hw-modal--bodyFares {\n    /* padding-top: 4rem; */\n    /* padding-top: 3rem; */\n  }\n}\n\n@media (max-width: 900px) {\n  .hw-modal.hw-modal--flightBook .hw-modal-dialog {\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n    min-height: calc(100% - 6rem * 2);\n    height: calc(100% - 6rem * 2);\n  }\n}\n\n@media (max-width: 989px) {\n  .hw-fare--slideItem .b-top .hw-text20 {\n    font-size: 1.8rem;\n  }\n\n  .hw-fare--slideItem .b-top .hw-text18 {\n    font-size: 1.4rem;\n  }\n}\n\n@media (max-width: 749px) {\n  .hw-flight--listOut .f-place .hw-text18 {\n    font-size: 1.4rem;\n    line-height: 1.5;\n  }\n}\n\n@media (max-width: 575px) {\n  .hw-search--flightListBottomFooter .col-fix-right {\n    flex-direction: column;\n    row-gap: 0.2rem;\n  }\n\n  .hw-search--flightListBottomFooter .hw-text20.hw-dtr--dtext {\n    font-size: 1.6rem;\n  }\n}\n\n/*End flight Popup*/\n.hw-inner--flightBookingBox {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1.6rem;\n}\n\n.hw-inner--flightBookingBox .flight-list {\n  background-color: rgba(29, 78, 229, 0.03);\n  padding: 1.6rem;\n}\n\n.hw-inner--flightBookingBox .flight-list .hw-baggage--line {\n  border-top: 1px solid var(--hw-gray-600);\n  padding-top: 1.6rem;\n  margin-top: 1.6rem;\n}\n\n.f-timeDate--inline {\n  display: flex;\n  align-items: center;\n  column-gap: 0.8rem;\n}\n\n.f-timeDate .f-dot {\n  width: 0.5rem;\n  height: 0.5rem;\n  background-color: #d9d9d9;\n  border-radius: 1rem;\n}\n\n.hw-recent--viewedList {\n  margin-left: -1.6rem !important;\n  padding-left: 1.6rem !important;\n  padding-right: 1.6rem !important;\n}\n\n.hw-divider--clickShow {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  column-gap: 1rem;\n  cursor: pointer;\n  min-height: 3.6rem;\n}\n\n.hw-divider--clickShow::before,\n.hw-divider--clickShow::after {\n  content: '';\n  background-color: var(--hw-gray-600);\n  flex-grow: 1;\n  height: 1px;\n}\n\n.hw-divider--clickShow .span-svgWrap {\n  border: 1px solid var(--hw-gray-600);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 3.2rem;\n  min-height: 3.2rem;\n  color: var(--hw-brand-blue);\n  transition: .2s ease-in-out;\n}\n\n.hw-divider--clickShow .span-svgWrap:hover {\n  background-color: var(--hw-brand-blue-light);\n  color: var(--hw-brand-orange);\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-divider--clickShow .span-svgWrap:hover {\n  background-color: var(--hw-brand-blue-light);\n  color: var(--hw-brand-orange);\n  border-color: var(--hw-brand-orange);\n}\n\n.hw-divider--clickShow .span-svgWrap svg {\n  width: 2rem;\n  height: 2rem;\n}\n\n.hw-modal--bodyTop.hw-modal--bodyTopPrev:not(.active) .hw-divider--clickShow~.hw-flight--timelineColumn {\n  display: none;\n}\n\n.hw-exchk--sectionHead {\n  display: flex;\n  align-items: center;\n  gap: 1.2rem;\n  padding-bottom: 1.4rem;\n  margin-bottom: 2rem;\n  border-bottom: 0.1rem solid var(--hw-gray-200);\n}\n.hw-exchk--sectionIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3.6rem;\n  height: 3.6rem;\n  flex-shrink: 0;\n  border-radius: 1rem;\n  background: var(--hw-brand-orange-light);\n  color: var(--hw-brand-orange);\n}\n.hw-exchk--sectionIcon svg {\n  width: 1.8rem;\n  height: 1.8rem;\n  color: var(--hw-brand-orange);\n}\n.hw-exchk--sectionTitle {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: var(--hw-black);\n  letter-spacing: -0.01em;\n}\n.hw-hotelContact--listShow__widget .hw-exchk--sectionHead,\n.hw-hotel--reviewContact .hw-exchk--sectionHead {\n  margin-top: 2.8rem;\n}\n\n.hw-exchk--sectionHead__toggle {\n  cursor: pointer;\n  user-select: none;\n  margin-bottom: 0;\n  transition: margin-bottom 0.2s ease;\n}\n.hw-exchk--sectionHead__toggle.is-open {\n  margin-bottom: 2rem;\n}\n.hw-exchk--sectionToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 1rem;\n  margin-left: auto;\n}\n.hw-exchk--sectionMeta {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: black;\n}\n.hw-exchk--sectionChevron {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: black;\n  transition: transform 0.25s ease;\n}\n.hw-exchk--sectionChevron svg {\n  width: 2rem;\n  height: 2rem;\n}\n.hw-exchk--sectionHead__toggle.is-open .hw-exchk--sectionChevron {\n  transform: rotate(180deg);\n}\n\n.hw-passenger--toggleChevron {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.25s ease;\n}\n.hw-passenger--toggleChevron svg {\n  width: 2.4rem;\n  height: 2.4rem;\n}\n.hw-passenger--toggleChevron.is-open {\n  transform: rotate(180deg);\n}\n\n.hw-hotel--guestRoom + .hw-hotel--guestRoom {\n  margin-top: 2.8rem;\n}\n.hw-hotel--guestRoomTitle {\n  margin-bottom: 0.4rem;\n}\n\n/* tax-not-included warning (shown under the price breakdown instead of a tooltip) */\n.hw-hotel--taxNote {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.8rem;\n  margin-top: 1.4rem;\n  padding: 1rem 1.2rem;\n  background: #fff6e9;\n  border: 0.1rem solid #f3d9a8;\n  border-radius: 0.8rem;\n  font-size: 1.2rem;\n  line-height: 1.5;\n  color: #8a6d3b;\n}\n.hw-hotel--taxNote__icon {\n  flex: none;\n  display: inline-flex;\n  margin-top: 0.1rem;\n  color: #d9962b;\n}\n.hw-hotel--taxNote__icon svg {\n  width: 1.6rem;\n  height: 1.6rem;\n}\n\n@media (min-width: 641px) {\n  .hw-recent--viewedList {\n    margin-left: -2.4rem !important;\n    padding-left: 2.4rem !important;\n    padding-right: 2.4rem !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .hw-widget.hw-widget--flight .hw-widget--card {\n    padding: 1.6rem;\n  }\n}\n\n@media (min-width: 990px) {\n  .hw-recent--viewedList {\n    margin-top: 3.2rem !important;\n  }\n}\n\n\n.hw-input--switchGroup .icon-chevronDown,\n.hw-input--switchGroup .icon-chevronUp {\n  display: none;\n}\n\n.hw-search--flightFilterResult__tab .hw-nav--tabFareRules .hw-table--border tr>td+td {\n  color: var(--hw-gray-800);\n}\n\n.hw-contact--inputSingleField {\n  border: 1px solid var(--hw-gray-600);\n  border-radius: 0.5rem;\n  display: grid;\n  grid-template-columns: auto 1fr;\n}\n\n.hw-passenger--listShow .hw-contact--inputSingleField .hw-inner--fullWidth>div>div {\n  border: none !important;\n}\n\n.hw-contact--inputSingleField .hw-form--input {\n  border: none !important;\n\n}\n\n.hw-contact--inputSingleField>div {\n  position: relative;\n}\n.hw-hotel-number {\n  border-left: 1px solid var(--hw-gray-600);\n}\n\n.hw-contact--inputSingleField .hw-p-error-cls {\n  position: absolute;\n  margin: 0;\n}\n\n.hw-contact--inputSingleField>.hw-inner--fullWidth {\n  min-width: 15rem;\n}\n\n.hw-modal--bodyTop.hw-modal--bodyTopPrev-multi-city:not(.multicity-active)~.hw-modal--bodyTop.hw-modal--bodyTopPrev-multi-city {\n  display: none;\n}\n\n.hw-modal--bodyTop.hw-modal--bodyTopPrev-multi-city:not(.multicity-active) .hw-divider--clickShow~* {\n  display: none;\n}\n\n.hw-inputCheck--airline .css-1u9des2-indicatorSeparator {\n  display: none;\n}\n\n.hw-inputCheck--airline svg {\n  color: var(--hw-brand-blue) !important;\n}\n\n.hw-inputCheck--airline .css-1p3m7a8-multiValue {\n  margin: 1px;\n  color: var(--hw-brand-blue);\n  background-color: var(--hw-brand-blue-light);\n}\n\n.hw-hover--underline:hover {\n  text-decoration: underline;\n  text-underline-offset: 0.8rem;\n}\n\n/* .hw-contact--inputSingleField .css-1u9des2-indicatorSeparator {\n  display: none !important;\n} */\n.hw-contact--inputSingleField .css-1xc3v61-indicatorContainer {\n  padding: 0 !important;\n}\n\n.hw-contact--inputSingleField .input-m--field .hw-form--input {\n  padding-left: 2.3rem;\n}\n\n.hw-row--s2 .react-datepicker-wrapper .hw-form--input {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cg clip-path='url(%23clip0_2211_7404)'%3E%3Cpath d='M16 3V7M8 3V7M4 11H20M11 15H12V18M4 7C4 6.46957 4.21071 5.96086 4.58579 5.58579C4.96086 5.21071 5.46957 5 6 5H18C18.5304 5 19.0391 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V7Z' stroke='%23555555' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2211_7404'%3E%3Crect width='24' height='24' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: left 1.2rem center;\n  background-size: 2.4rem 2.4rem;\n  padding-left: 4.2rem;\n}\n\n.react-datepicker__close-icon::after {\n  background-color: var(--hw-brand-orange);\n}\n\n.hw-table--baggage tbody td {\n  color: var(--hw-gray-800);\n}\n\n.hw-table--baggage tbody tr>td:not(:last-child) {\n  border-right: 1px solid var(--hw-gray-600);\n}\n\n.hw-table--responsive {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.hw-flight--ntavailable,\n.hw-hotel--ntavailable {\n  margin-top: 2.4rem;\n  background-color: var(--hw-white);\n  /* margin: 0 !important; */\n  padding: 4rem 1.6rem;\n  border-radius: 0.5rem;\n}\n\n.hw-flight--ntavailable>div {\n  max-width: 48rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n@media (min-width: 480px) {\n  .hw-contact--inputSingleField > .hw-inner--fullWidth {\n    min-width: 18rem;\n  }\n}\n\n@media (max-width: 1100px) {\n.hw-mauto--1100 {\n  margin-left: auto;\n}\n.hw-hotel--hotelDetails .hw-passenger--fareSummary__box .mt-6 {\n  margin-top: 2.4rem !important;\n}\n}\n\n@media (max-width: 599px) {\n  .hw-passenger--head .h3 {\n    font-size: 2rem;\n    line-height: 1.5;\n  }\n\n  .hw-flight--listBoxAction {\n    flex-wrap: wrap;\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 599px) {\n.hw-xs--grow1 {\n  flex-grow: 1;\n}\n.hw-xs--grow1--leftAlign {\n  justify-content: flex-start !important;\n}\n.hw-flight--listBoxAction {\n  row-gap: 0.4rem;\n}\n}\n\n/* .hw-contact--inputSingleField .icon-chevronDown */\n\n/*End new flight design*/\n\n\n\n@media (min-width: 901px) {\n  main:has(.hw-search--flightListBottomFooter)~.hw-footer {\n    padding-bottom: 10rem;\n  }\n\n  main:has(.hw-search--flightListBottomFooter) .hw-search--flightFilter {\n    max-height: calc(100dvh - 19rem);\n  }\n}\n\n@media (max-width: 900px) {\n  main:has(.hw-search--flightListBottomFooter)~.hw-footer {\n    padding-bottom: 14rem;\n  }\n}\n\n\n/* main:has(.hw-search--flightListBottomFooter) .hw-search--flightFilter */\n\n/*New hotel design css*/\n\n\n.hw-hotes-module .hw-input--multicityGroup .hw-input--input {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.hw-hotes-module .DT--section {\n  padding-bottom: 1.6rem;\n}\n\n/* .hw-hotel--asideFilter .hw-search--flightFilter__title {\n  padding: 1rem;\n}\n\n.hw-hotel--asideFilter .hw-search--flightFilter__widgetContent {\n  padding: 0 1rem;\n} */\n\n.hw-hotel--singleListExtra .hw-sticky--scroller {\n  top: 33.8rem;\n}\n\n.hw-hotel-checkout--preview>.hw-passenger--detailsGroup+.hw-blue {\n  margin-top: 1.6rem;\n}\n@media (min-width: 491px) {\n  .hw-hotel--singleListExtra .hw-sticky--scroller {\n    top: 27.2rem;\n  }\n}\n@media (min-width: 641px) {\n  .hw-hotel--singleListExtra .hw-sticky--scroller {\n    top: 22.2rem;\n  }\n}\n@media (min-width: 768px) {\n  .hw-hotes-module .hw-input--switchGroup>div {\n    max-width: 100%;\n  }\n}\n\n@media (min-width: 901px) {\n\n  .hw-hotel--asideFilter .hw-search--flightFilter__body {\n    display: flex !important;\n  }\n}\n\n@media (min-width: 990px) {\n  .hw-hotel--singleListExtra .hw-sticky--scroller {\n    /* top: 8.8rem; */\n    /* top: 9.6rem; */\n     top: 9.4rem;\n  }\n}\n\n/* @media (min-width: 1240px) {\n  .hw-hotes-module .hw-date--calender {\n    min-height: 76px;\n  }\n} */\n\n@media (max-width: 479px) {\n  .wrap-this--mob {\n    flex-wrap: wrap;\n    row-gap: 1rem;\n  }\n}\n\n/*End New hotel design css*/\n\n\n\n.hw-fare--slider .swiper-slide {\n  height: auto;\n  min-height: 100%;\n}\n\n.hw-fare--slideItem {\n  height: 100%;\n}\n\n.fixed-top {\n  z-index: 99999;\n}\n\n.hw-hotes-module .DT--section select {\n  min-height: 3.2rem;\n}\n.hw-passenger--fareShowToggleContent .hw-p-error-cls {\n  margin-bottom: 0;\n}\n\n@media (min-width: 768px) and (max-width: 1099px) {\n  .hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2 {\n    width: 50%\n  }\n}\n\n@media (min-width: 900px) and (max-width: 1099px) {\n  .hw-hotes-module .hw-input--groupCol .hw-row--inputFirst .react-datepicker-wrapper {\n    width: calc(67% - 1.2rem);\n  }\n\n  .hw-hotes-module .hw-input--groupCol .hw-row--input.hw-row--inputFirst {\n    row-gap: 1.2rem;\n    column-gap: 1.2rem;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1099px) {\n  .hw-hotes-module .hw-input--groupCol .hw-input--switchGroup {\n    width: 100%;\n  }\n}\n\n@media (min-width: 1100px) {\n  .hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2 {\n    width: 35%\n  }\n}\n\n@media (max-width: 899px) {\n  .hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2 {\n    width: 100%;\n  }\n}\n\n@media (max-width: 479px) {\n  .hw-hotel--hotelDetails .hw-passenger--wrapper .hw-p-error-cls {\n    font-size: 1.2rem;\n  }\n}\n\n.hw-row--input.hw-row--inputFirst>.hw-input--input {\n  place-content: center;\n}\n\n@media screen and (min-width: 768px) {\n\n  /* .hw-hotelContact--listShow__widget #email.hw-form--input {\n    height: 100%;\n  } */\n}\n\n@media screen and (min-width: 641px) and (max-width: 991px) {\n  .hw-hotel--imageGallery .hw-img--grid {\n    min-height: 14rem;\n  }\n}\n\n@media screen and (min-width: 480px) and (max-width: 640px) {\n  .hw-hotel--imageGallery .hw-img--grid {\n    min-height: 10rem;\n  }\n}\n\n.hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2>div>div>div .css-1xc3v61-indicatorContainer svg {\n  color: var(--hw-brand-blue) !important;\n}\n\nbody .hw-modal-backdrop {\n  z-index: 99999;\n}\n\nbody .hw-modal {\n  z-index: 999999;\n}\n\n/* Wrapper spacing fix */\n.hw-page--width {\n  width: 100%;\n}\n\n.skeleton-gallery {\n  display: flex;\n  gap: 1rem;\n  width: 100%;\n}\n\n.skeleton-gallery-left {\n  width: 70%;\n}\n\n.skeleton-gallery-right {\n  width: 30%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* Stack gallery on mobile */\n@media (max-width: 768px) {\n  .skeleton-gallery {\n    flex-direction: column;\n  }\n\n  .skeleton-gallery-left,\n  .skeleton-gallery-right {\n    width: 100%;\n  }\n}\n\n.skeleton-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.skeleton-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.skeleton-rooms {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.skeleton-room-group {\n  display: flex;\n  gap: 1rem;\n}\n\n.skeleton-room-left {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 40%;\n}\n\n.room-img {\n  width: 30%;\n}\n\n@media (max-width: 768px) {\n\n  .skeleton-room-group {\n    flex-direction: column;\n  }\n\n  .skeleton-room-left,\n  .room-img {\n    width: 100%;\n  }\n}\n\n@media (min-width: 1301px) {\n  .hw-hotes-module .hw-input--multicityGroup>.row>.col-md-2 {\n    width: 37.5%;\n  }\n}\n\n\n.hw-hotel-search .css-1dimb5e-singleValue{\n  color: var(--hw-brand-blue);\n  font-weight: bold;\n}\n.hw-hotel-search .css-15lsz6c-indicatorContainer svg {\n  color: var(--hw-brand-blue) !important;\n}\n\n/* Hotel Tax Warning Box */\n.hw-hotel--taxWarningBox {\n  border-radius: 0.5rem;\n  background: rgba(255, 193, 7, 0.1);\n  border: 1px solid rgba(255, 193, 7, 0.3);\n  padding: 1rem 1.2rem;\n  margin-top: 1rem;\n}\n\n.hw-hotel--taxWarningIcon {\n  color: #FFC107;\n  display: flex;\n  align-items: flex-start;\n  padding-top: 2px;\n}\n\n.hw-hotel--taxWarningIcon svg {\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n}\n\n.hw-hotel--taxWarningText {\n  flex: 1;\n  color: #856404;\n}\n\n.hw-hotel--taxWarningText p {\n  color: #856404;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/*End latest css*/\n\n.hw-countryExplore--section .slick-list{\n  overflow: visible;\n}\n.hw--hotel-phonecode .css-1wy0on6{\n  flex-direction: row-reverse !important;\n}\n\n.hw--hotel-phonecode {\n  display: flex;\n}\n.hw--hotel-phonecode p {\n  margin-top: 48px !important;\n}\n.hw-contact--inputSingleField > .hw-inner--fullWidth.hw--hotel-phonecode {\n  width: 18rem;\n  min-width: 14rem;\n}\n.hw--hotel-phonecode .hw-pcsel {\n  position: relative;\n  width: 100%;\n}\n.hw--hotel-phonecode .hw-pcsel--menu {\n  z-index: 1000;\n  max-height: 42rem;\n}\n.hw--hotel-phonecode .hw-pcsel--list {\n  max-height: 38rem;\n}\n\n\n\n\n.hw-top--fixImg:not(.hw-excursion-banner-img) {\n  max-height: 27rem;\n}\n\n.hw-rateList {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding-inline: 1.6rem;\n  padding-top: 8px;\n  padding-bottom : 1.6rem;\n  background: white;\n  min-width: 0;\n  box-sizing: border-box;\n  border-bottom-left-radius: 1rem;\n  border-bottom-right-radius: 1rem;\n}\n\n.hw-rateList__card {\n  display: flex;\n  gap: 20px;\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  padding: 16px 0;\n  min-width: 0;\n}\n\n.hw-rateList__card:not(:first-child) {\n  border-top: 1px solid #DFDFDF;\n}\n\n.hw-rateList__card:hover {\n  border-color: #DFDFDF;\n  box-shadow: none;\n}\n\n.hw-rateList__main {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.hw-rateList__aside {\n  flex: 0 0 190px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 20px;\n  padding-left: 18px;\n}\n\n.hw-rateList__head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 10px;\n}\n\n.hw-rateList__name {\n  margin: 0;\n  font-size: 1.6rem;\n  font-weight: 600;\n  color:  Black;\n  overflow-wrap: anywhere;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.hw-rateList__class {\n  font-size: 12px;\n  font-weight: 500;\n  color: #0062ff;\n  background: #e9f0ff;\n  border-radius: 20px;\n  padding: 3px 10px;\n  white-space: nowrap;\n}\n\n.hw-rateList__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 18px;\n  color: #55617a;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 12px;\n}\n\n.hw-rateList__meta span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.hw-rateList__meta svg {\n  width: 16px;\n  height: 16px;\n  flex: none;\n}\n\n.hw-rateList__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.hw-rateList__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #384152;\n  background: #f1f4f9;\n  border-radius: 8px;\n  padding: 5px 10px;\n}\n\n.hw-rateList__chip svg {\n  width: 14px;\n  height: 14px;\n  color: #1d9e75;\n}\n\n.hw-rateList__chip--more {\n  color: #0062ff;\n  background: #e9f0ff;\n}\n\n.hw-rateList__cancel {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 13.5px;\n  line-height: 1.5;\n}\n\n.hw-rateList__cancel svg {\n  width: 18px;\n  height: 18px;\n  flex: none;\n  margin-top: 1px;\n}\n\n.hw-rateList__cancel.is-free {\n  color: #0f6e56;\n}\n\n.hw-rateList__cancel.is-nonref {\n  color: #b42318;\n}\n\n.hw-rateList__cancelText {\n  display: flex;\n  flex-direction: column;\n}\n\n.hw-rateList__cancelMain {\n  font-weight: 500;\n}\n\n.hw-rateList__cancelSub {\n  color: #7a8598;\n  font-size: 12.5px;\n}\n\n.hw-rateList__cancelSub svg {\n  width: 13px;\n  height: 13px;\n  vertical-align: -2px;\n}\n\n.hw-rateList__priceLabel {\n  font-size: 12px;\n  color: #7a8598;\n}\n\n.hw-rateList__price {\n  font-size: 22px;\n  font-weight: 700;\n  color: #1f2a44;\n  white-space: nowrap;\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n}\n.hw-rateList__price p{\n  font-size: 16px;\n  font-weight: 500;\n  color: #555;\n  white-space: nowrap;\n  margin-bottom: 0 !important;\n}\n\n.hw-rateList__aside .hw-btn {\n  margin-top: 6px;\n}\n\n.hw-rateList__viewAll {\n  display: flex;\n  justify-content: center;\n  padding-top: 4px;\n}\n\n.hw-rateList__viewAll .hw-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  width: auto;\n  padding-inline: 24px;\n}\n\n.hw-rateList__viewAll .hw-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n@media (max-width: 767px) {\n  .hw-rateList__card {\n    flex-direction: column;\n    gap: 14px;\n  }\n  .hw-rateList__aside {\n    flex-basis: auto;\n    border-left: 0;\n    padding-left: 0;\n    border-top: 1px solid #eef1f6;\n    padding-top: 12px;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .hw-rateList__aside .hw-btn {\n    width: auto;\n    margin-top: 0;\n  }\n}\n.hw-select-btn {\n  padding : 15px;\n  display : flex;\n  gap : 10px;\n  border-radius : 10px;\n  background-color: transparent;\n  border : 1px solid #0062FF;\n  justify-content : center;\n  align-items : center;\n  font-size : 16px;\n  color : #0062FF;\n  font-weight : 700;\n  line-height: 28px;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n}\n.hw-select-btn:hover {\n  color:white;\n  background-color: #0062FF;\n  border-color:transparent;\n}\n.hw-select-btn:hover svg path{\n  fill : white;\n}\n.hw-book-btn {\n  padding-block : 15px;\n  padding-inline : 30px;\n  display : flex;\n  gap : 10px;\n  border-radius : 10px;\n  background-color: #0062FF;\n  border : none;\n  justify-content : center;\n  align-items : center;\n  font-size : 16px;\n  color : #ffffff;\n  font-weight : 700;\n  line-height: 28px;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n}\n.detail-btn{\n  width: 172px;\n}\n.hw-book-btn:hover {\n  color:white;\n  background-color: var(--hw-brand-blue);\n  border-color:transparent;\n}\n\n.hw-rateList__moreLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0;\n  background: none;\n  border: 0;\n  color: #0062ff;\n  font-size: 14px !important;\n  font-weight: 700;\n  cursor: pointer;\n  line-height: 1.71429;\n}\n.hw-rateList__moreLink svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* ---------- Room details popup (rate row > View More Details) ---------- */\n.hw-roomDetail--dialog {\n  max-width: 560px;\n  width: 100%;\n  margin-inline: auto;\n}\n.hw-roomDetail--header .hw-modal-headerTitle {\n  color: #1f2a44;\n  font-size: 1.8rem;\n  font-weight: 700;\n}\n.hw-roomDetail--features {\n  background: #f6f8fb;\n  border-radius: 12px;\n  padding: 16px 18px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n.hw-roomDetail--feature {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #555;\n  text-transform: capitalize;\n}\n.hw-roomDetail--feature svg {\n  width: 18px;\n  height: 18px;\n  flex: none;\n  color: #1d9e75;\n}\n.hw-roomDetail--policies {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n.hw-roomDetail--policie {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.hw-roomDetail--policy {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #555;\n  line-height: 28px;\n}\n.hw-roomDetail--policy svg {\n  width: 20px;\n  height: 20px;\n  flex: none;\n}\n.hw-hotel--detailListOut {\n  padding: 24px;\n  border-radius: 20px;\n  border: 1px solid #DFDFDF;\n  display: flex;\n  padding: 24px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  background: #fff;\n  margin-bottom: 20px;\n}\n.hw-hotel--detailListOut img {\n  object-fit: cover;\n  aspect-ratio: 5/4;\n}\n.hw-hotel--detailList {\n  display: flex;\n  gap: 24px;\n}\n.hw-hotel--detailList h4 {\n  overflow: hidden;\ncolor: var(--General-Colors-Brand-Black, #000);\ntext-overflow: ellipsis;\nfont-family: \"DM Sans\";\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 700;\nline-height: 28px;\n}\n.hw-hotel--detailList h6 {\n  overflow: hidden;\n  color: var(--General-Colors-Brand-Black, #555);\n  text-overflow: ellipsis;\n  font-family: \"DM Sans\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.5;\n  text-transform: capitalize;\n  max-width: 600px;\n}\n.hw-hotel--detailListContent__price {\n  display: flex;\nalign-items: center;\ngap: 20px;\nfont-size: 14px;\n}\n.hw-hotel--detailListContent__price span {\n  display: flex;\nalign-items: center;\ngap: 4px;\n}\n.hw-hotel--detailListContent__price svg {\n  width: 18px;\n  height: 18px;\n}\n\n\n@media (max-width: 1024px) {\n  .hw-book-btn {\n    white-space: nowrap;\n  }\n}\n@media (max-width: 768px) {\n  .hw-hotel--detailListContent__price {\n    font-size: 12px;\n    gap: 12px;\n  }\n  .detail-btn {width: 100%;}\n}\n@media (max-width: 468px) {\n  .hw-hotel--detailList,.hw-hotel--detailListOut {\n    flex-direction: column;\n  }\n  .hw-hotel--detailListOut{\n    align-items: start;\n  }\n  .hw-hotel--detailListOut .price span{\n    text-align: left !important;\n  }\n  .hw-rateList__price div{text-align: left !important;}\n  .hw-hotel--detailListOut img {\n    width: 100%;\n    height: 200px;\n  }\n}\n\n/* Smooth height reveal when \"Select a room\" expands the rate list. */\n.hw-rateList__reveal {\n  display: grid;\n  grid-template-rows: 0fr;\n  opacity: 0;\n  transition: grid-template-rows 0.35s cubic-bezier(0.22, 1, 0.36, 1),\n              opacity 0.3s ease;\n}\n.hw-rateList__reveal.is-open {\n  grid-template-rows: 1fr;\n  opacity: 1;\n}\n.hw-rateList__revealInner {\n  min-height: 0;\n  overflow: hidden;\n}\n@keyframes hw-rateReveal {\n  from { grid-template-rows: 0fr; opacity: 0; }\n  to   { grid-template-rows: 1fr; opacity: 1; }\n}\n.hw-currency-switch-li {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n/* ── Sort By tab strip ──────────────────────────────────────── */\n.hw-sortby--strip {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  flex-shrink: 0;\n  gap: 0.8rem;\n}\n\n.hw-sortby--tab {\n  flex-shrink: 0;\n  padding: 0.8rem 2rem;\n  height: 3.8rem;\n  border: 1px solid transparent;\n  background: #fff;\n  font-size: 1.4rem;\n  color: #444;\n  cursor: pointer;\n  white-space: nowrap;\n  border-radius: 0.7rem;\n  transition:\n    background 0.15s,\n    color 0.15s,\n    border-color 0.15s;\n}\n\n.hw-sortby--tab:hover {\n  background: #ebf3ff;\n  color: #0062ff;\n  border-color: #0062ff;\n}\n\n.hw-sortby--tab.active {\n  background: #ebf3ff;\n  color: #0062ff;\n  font-weight: 600;\n  border-color: #0062ff;\n}\n\n.hw-sortby--clear {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0 1.2rem;\n  height: 3.8rem;\n  border: 1px solid transparent;\n  border-radius: 0.7rem;\n  background: #fff;\n  font-size: 1.35rem;\n  color: #666;\n  cursor: pointer;\n  flex-shrink: 0;\n  white-space: nowrap;\n  transition:\n    background 0.15s,\n    color 0.15s,\n    border-color 0.15s;\n}\n\n.hw-sortby--clear:hover {\n  background: #FBE7E9;\n  color: #d32f2f;\n  font-weight: 600;\n  border-color: #d32f2f;\n}\n\n.hw-sortby--clear:hover .hw-sortby--clear-icon {\n  stroke-width: 0.3rem;\n}\n\n/* ── Sort By — mobile responsive ───────────────────────────── */\n@media (max-width: 768px) {\n  /* Parent wrapper: stack label above the strip */\n  .d-flex.align-items-center.hw-gapy10.mt-12 {\n    flex-wrap: wrap;\n    gap: 0.6rem;\n  }\n\n  /* Strip: allow tabs to wrap and scroll horizontally */\n  .hw-sortby--strip {\n    overflow-x: auto;\n    overflow-y: hidden;\n    flex-wrap: nowrap;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;       /* Firefox */\n    gap: 0.5rem;\n    width: 100%;\n    padding-bottom: 2px;         /* room for scrollbar on some browsers */\n  }\n\n  .hw-sortby--strip::-webkit-scrollbar {\n    display: none;     \n  }\n\n  /* Tabs: smaller padding, full height on touch */\n  .hw-sortby--tab {\n    padding: 0.6rem 1.2rem;\n    height: 3.2rem;\n    font-size: 1.2rem;\n    white-space: nowrap;\n  }\n\n  /* Clear button: keep it compact */\n  .hw-sortby--clear {\n    padding: 0 0.8rem;\n    height: 3.2rem;\n    font-size: 1.2rem;\n    white-space: nowrap;\n  }\n}\n\n/* ===== Hotel checkout — new brand design (scoped) ===== */\n.hw-hotel--hotelDetails .hw-flight--stepsWrapper { background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%); box-shadow: none; color: #fff; padding: 6px 0 10px; }\n.hw-hotel--hotelDetails .hw-flight--steps { padding-top: 8px; }\n.hw-hotel--hotelDetails .hw-step .hw-text14,\n.hw-hotel--hotelDetails .hw-step .hw-black900 { color: rgba(255,255,255,.65) !important; font-weight: 600; }\n.hw-hotel--hotelDetails .hw-step.active .hw-text14 { color: #fff !important; }\n.hw-hotel--hotelDetails .hw-step.complete .hw-text14,\n.hw-hotel--hotelDetails .hw-step.complete .hw-black { color: #fff !important; }\n.hw-hotel--hotelDetails .lm-i { background: rgba(255,255,255,.16); color: #fff; }\n.hw-hotel--hotelDetails .hw-step.active .lm-i { background: #fff; color: #283D6B; }\n.hw-hotel--hotelDetails .hw-step.complete .lm-i { background: #4ade80; border-color: #4ade80; }\n.hw-hotel--hotelDetails .hw-flight--steps .row > .hw-step:not(:last-child)::after { background: rgba(255,255,255,.28); }\n.hw-hotel--hotelDetails .hw-expire--session { color: #fff; border-top-color: rgba(255,255,255,.18); }\n.hw-hotel--hotelDetails .hw-expire--session .hw-primary,\n.hw-hotel--hotelDetails .hw-expire--session svg { color: #fff; }\n.hw-hotel--hotelDetails .hw-expire--session .hw-text14 { color: rgba(255,255,255,.9); }\n\n/* confirm success banner on the dark hero */\n.hw-hotel--hotelDetails .hw-expire--session__bookingConfirmed,\n.hw-hotel--hotelDetails .hw-expire--session__bookingConfirmed h4,\n.hw-hotel--hotelDetails .hw-expire--session__bookingConfirmed .hw-black900,\n.hw-hotel--hotelDetails .hw-expire--session__bookingConfirmed .color-inherit,\n.hw-hotel--hotelDetails .hw-expire--session__bookingConfirmed .hw-bookId { color: #fff !important; background: transparent; }\n.hw-hotel--hotelDetails .hw-expire--session__bookingConfirmed .hw-icon--tickcircleBox { background: rgba(255,255,255,.16); color: #fff; }\n\n/* floating cards */\n.hw-hotel--hotelDetails .hw-passenger--listShow__widget { border: 1px solid #eceef3; border-radius: 12px; box-shadow: 0 1px 2px rgba(16,24,40,.04); padding: 20px; }\n.hw-hotel--hotelDetails .hw-passenger--fareSummary { border-radius: 12px; box-shadow: 0 1px 2px rgba(16,24,40,.04); border: 1px solid #eceef3; }\n.hw-hotel--hotelDetails .hw-passenger--fareSummary__box { padding: 18px; }\n\n/* sticky right summary */\n.hw-hotel--asideCol { display: block; background: #fff; border: 1px solid #eceef3; border-radius: 6px; box-shadow: 0 1px 2px rgba(16,24,40,.04); overflow: hidden; }\n.hw-hotel--asideCol .hw-hcard { border: 0; box-shadow: none; border-radius: 0; }\n.hw-hotel--asideCol .hw-passenger--fareSummary { border: 0; box-shadow: none; border-radius: 0; margin: 0; background: transparent; }\n.hw-hotel--asideCol .hw-passenger--fareSummary__box { padding-top: 0; }\n@media (min-width: 990px) {\n  .hw-hotel--hotelDetails .hw-hotel--asideCol { position: sticky; top: 16px; align-self: start; }\n}\n/* hotel card fits the narrower right column */\n.hw-hotel--asideCol .hw-hcard--thumb { width: 100px; height: 70px; }\n.hw-hotel--asideCol .hw-hcard--title { font-size: 18px; }\n\n/* payment method as brand cards */\n.hw-hotel--hotelDetails .hw-radio--inline { display: flex; flex-wrap: wrap; gap: 12px; margin-top: 10px; }\n.hw-hotel--hotelDetails .hw-radio--btnIcon { flex: 1 1 150px; min-width: 0; }\n.hw-hotel--hotelDetails .hw-radio--btnIcon input[type=\"radio\"] { width: 100%; min-width: 0; min-height: 54px; border-radius: 12px; border: 1.5px solid #e2e6ee; background: #fff; }\n.hw-hotel--hotelDetails .hw-radio--btnIcon input[type=\"radio\"]:hover { background: #f5f8ff; border-color: #c3ccdb; }\n.hw-hotel--hotelDetails .hw-radio--btnIcon input[type=\"radio\"]:checked { background: #f5f8ff; border-color: #3264FF; }\n.hw-hotel--hotelDetails .hw-radio--btnText { color: #283D6B; font-weight: 700; }\n.hw-hotel--hotelDetails .hw-radio--btnIcon input[type=\"radio\"]:checked ~ .hw-radio--btnText { color: #3264FF; }\n.hw-hotel--hotelDetails .hw-radio--btnIcon input[type=\"radio\"]:checked ~ .hw-radio--btnText svg { color: #3264FF; }\n\n/* confirm: download tickets side by side + price breakup heading */\n.hw-hotel--hotelDetails .hw-after--bookingWidget.tickets { display: flex; flex-wrap: wrap; gap: 10px; }\n.hw-hotel--hotelDetails .hw-after--bookingWidget.tickets > .d-flex { flex: 1 1 100%; }\n.hw-hotel--hotelDetails .hw-after--bookingWidget.tickets > div:not(.d-flex) { flex: 1 1 200px; min-width: 0; }\n.hw-hotel--hotelDetails .hw-after--bookingWidget.tickets > div:not(.d-flex) > .hw-btn { width: 100%; padding: 11px 14px; font-size: 14px; }\n.hw-hotel--hotelDetails .hw-after--bookingWidget.price-backup { padding-top: 0;}\n.hw-hotel--hotelDetails .hw-after--bookingWidget.price-backup h4 { font-size: 16px; font-weight: 700; }\n.hw-hotel--hotelDetails .hw-hotel--summaryTotal .hw-text22 { font-size: 18px !important; }\n\n\n/* Hotel summary card (sticky sidebar) */\n.hw-hotel--summaryCard { padding: 18px; }\n.hw-hotel--summaryCard .hw-exchk--tourImg { width: 96px; height: 66px; border-radius: 8px; object-fit: cover; flex: none; }\n.hw-hotel--summaryIcon { display: inline-flex; align-items: center; justify-content: center; background: #f2f5fb; color: #283D6B; }\n.hw-hotel--summaryIcon svg { width: 34px; height: 34px; }\n.hw-hotel--summaryStars { color: #f5a623; font-size: 13px; letter-spacing: 1px; margin-bottom: 2px; }\n.hw-hotel--policyLink { margin-top: 14px; padding-top: 14px; border-top: 1px solid #eef1f7; display: inline-block; }\n\n.hw-hotel--roomBlock { padding-top: 14px; margin-top: 14px; border-top: 1px solid #eef1f7; }\n.hw-hotel--roomBlock:first-of-type { padding-top: 0; margin-top: 10px; border-top: 0; }\n\n/* Hotel hero (excursion-style) */\n.hw-hotel--hero { padding: 16px 0 60px; }\n.hw-hotel--heroTimer { display: inline-flex; align-items: center; gap: 8px; color: rgba(255,255,255,.9); font-size: 13px; font-weight: 500; white-space: nowrap;min-width: 250px; }\n.hw-hotel--heroTimer svg { color: #fff; width: 18px; height: 18px; }\n.hw-hotel--hotelDetails .hw-page--width > .hw-passenger--wrapper { padding-top: 0; margin-top: -34px; position: relative; z-index: 1; }\n\n/* Hotel details card — clean modern layout */\n.hw-hcard { padding: 18px; }\n.hw-hcard--head { display: flex; gap: 14px; align-items: center; }\n.hw-hcard--thumb { width: 108px; height: 84px; border-radius: 10px; overflow: hidden; flex: none; background: #f2f5fb; display: flex; align-items: center; justify-content: center; }\n.hw-hcard--thumb img { width: 100%; height: 100%; object-fit: cover; }\n.hw-hcard--thumb svg { width: 40px; height: 40px; color: #283D6B; }\n.hw-hcard--headInfo { min-width: 0; }\n.hw-hcard--titleRow { display: flex; flex-direction: column; }\n.hw-hcard--title { margin: 0; font-size: 18px; color: #1b2439; line-height: 1.25; }\n.hw-hcard--stars { color: #f5a623; font-size: 14px; letter-spacing: 1px; }\n.hw-hcard--addr { display: flex; align-items: center; gap: 6px; color: #3264FF; font-weight: 500; font-size: 14px; margin-top: 16px; }\n.hw-hcard--addr svg { width: 16px; height: 16px; flex: none; color: #3264FF; }\n.hw-hcard--divider { height: 1px; background: #eef1f7; margin: 12px 0; }\n.hw-hcard--roomName { font-size: 14px; font-weight: 600; color: #000; }\n.hw-hcard--features { display: flex; flex-wrap: wrap; gap: 6px 14px; margin-top: 8px; }\n.hw-hcard--feat { display: inline-flex; align-items: center; gap: 6px; font-size: 13.5px; font-weight: 500; }\n.hw-hcard--feat svg { width: 16px; height: 16px; color: #98a2b6; }\n.hw-hcard--featOk { color: #137333; }\n.hw-hcard--featOk svg { color: #137333; }\n.hw-hcard--stay { display: grid; grid-template-columns: 1fr 1fr; align-items: center; gap: 12px; margin-top: 16px; padding: 14px 16px; border: 1px solid #3264FF; border-radius: 6px; background: #f5f8ff; }\n.hw-hcard--stayCol { display: flex; flex-direction: column; gap: 3px; min-width: 0; }\n.hw-hcard--stayCol--out { text-align: right; }\n.hw-hcard--stayLbl { font-size: 11px; text-transform: uppercase; letter-spacing: .04em; font-weight: 700; }\n.hw-hcard--stayDate { font-size: 14px; font-weight: 700; color: #1b2439; line-height: 1.25; }\n.hw-hcard--stayTime { font-size: 12.5px; color: #6b7280; font-weight: 500; }\n.hw-hcard--stayArrow { display: flex; align-items: center; justify-content: center; color: #3264FF; flex: none; }\n@media (max-width: 400px) {\n  .hw-hcard--stay { grid-template-columns: 1fr; }\n  .hw-hcard--stayCol--out { text-align: left; }\n  .hw-hcard--stayArrow { transform: rotate(90deg); justify-content: flex-start; }\n}\n.hw-hcard--policy { display: inline-flex; align-items: center; gap: 6px; margin-top: 12px; background: none; border: 0; padding: 0; color: #3264FF; font-weight: 600; font-size: 13.5px; cursor: pointer; }\n.hw-hcard--policy svg { width: 14px; height: 14px; color: #3264FF; }\n.hw-hcard--policy:hover { text-decoration: underline; }\n\n\n/* info tooltip (tax note) */\n.hw-tip { position: relative; display: inline-flex; align-items: center; margin-left: 5px; color: #b8860b; cursor: help; vertical-align: middle; outline: none; }\n.hw-tip svg { width: 15px; height: 15px; }\n.hw-tip__box { position: absolute; bottom: calc(100% + 8px); left: 0; width: 230px; max-width: 62vw; background: #1b2439; color: #fff; font-size: 12px; font-weight: 500; line-height: 1.45; padding: 10px 12px; border-radius: 8px; box-shadow: 0 10px 26px rgba(16,24,40,.28); opacity: 0; visibility: hidden; transform: translateY(4px); transition: opacity .15s, transform .15s; z-index: 30; text-align: left; white-space: normal; }\n.hw-tip:hover .hw-tip__box, .hw-tip:focus-within .hw-tip__box { opacity: 1; visibility: visible; transform: translateY(0); }\n.hw-tip__box::after { content: \"\"; position: absolute; top: 100%; left: 12px; border: 6px solid transparent; border-top-color: #1b2439; }\n\n.hw-hotel--hero .hw-exchk--heroBar { gap: 16px 24px; }\n\n/* merged guest + contact single card */\n.hw-hotel--hotelDetails .hw-hotel--guestCard { border: 1px solid #eceef3; border-radius: 6px; box-shadow: 0 1px 2px rgba(16,24,40,.04); background: #fff; padding: 20px; }\n.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-passenger--listShow__widget { border: 0; border-radius: 0; box-shadow: none; padding: 0; background: transparent; }\n.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotelPassenger--listShow__widget,\n.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotelContact--listShow__widget { border: 0; border-radius: 0; box-shadow: none; padding: 0; background: transparent; }\n.hw-hotel--guestDivider { height: 1px; background: #eef1f7; margin: 12px 0; }\n.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotel--guestFoot { position: sticky; bottom: 0; z-index: 3; display: flex; justify-content: flex-end; background: #fff; margin: 22px -20px -20px; padding: 14px 20px; border-top: 1px solid #eef1f7; border-radius: 0 0 6px 6px; }\n.hw-hotel--guestFoot .hw-btn { min-width: 220px; }\n@media (max-width: 767px) {\n  .hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotel--guestFoot { margin: 18px -20px -20px; padding: 12px 20px; }\n  .hw-hotel--guestFoot .hw-btn { min-width: 0; flex: 1; }\n}\n.hw-hotel--hotelDetails .hw-passenger--list {\n  display: block !important;\n  height: auto !important;\n  overflow: visible !important;\n}\n.hw-hotel--hotelDetails .hw-passenger--wrapper,\n.hw-hotel--hotelDetails .hw-passenger--listShow,\n.hw-hotel--hotelDetails .hw-hotel--guestCard {\n  overflow: visible !important;\n}\n@media (min-width: 1025px) {\n  .hw-hotel--hotelDetails .hw-passenger--list {\n    display: block !important;\n    height: auto !important;\n    overflow: visible !important;\n  }\n}\n\n/* review step: clean guest details preview (excursion style) */\n.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotel--reviewGuests,\n.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotel--reviewContact { padding: 0; border: 0; box-shadow: none; background: transparent; }\n.hw-hotel--reviewRoomCard { border: 1px solid #eef1f7; border-radius: 6px; overflow: hidden; margin-top: 12px; }\n.hw-hotel--reviewRoomCard:first-of-type { margin-top: 10px; }\n.hw-hotel--reviewRoomHead { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 14px; background: #F8FAFC; border-bottom: 1px solid #e2e6ee; }\n.hw-hotel--reviewRoomBadge { font-size: 13px; font-weight: 700; color: #283D6B; letter-spacing: .01em; }\n.hw-hotel--reviewRoomCount { font-size: 12px; font-weight: 600; color: #64748b; }\n.hw-hotel--reviewList { list-style: none; margin: 0; padding: 0; }\n.hw-hotel--reviewGuest { display: flex; align-items: center; gap: 12px; padding: 12px 14px; background: #fff; }\n.hw-hotel--reviewGuest + .hw-hotel--reviewGuest { border-top: 1px solid #f0f2f7; }\n.hw-hotel--reviewGuestIcon { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%; background: #eaf0ff; color: #3264FF; flex: none; }\n.hw-hotel--reviewGuestIcon svg { width: 16px; height: 16px; }\n.hw-hotel--reviewGuestName { font-size: 14.5px; font-weight: 600; color: #283D6B; flex: 1 1 auto; min-width: 0; }\n.hw-hotel--reviewGuestType { font-size: 11.5px; font-weight: 600; color: #64748b; background: #f7f9fc; border: 1px solid #e2e6ee; border-radius: 999px; padding: 3px 11px; flex: none; }\n.hw-hotel--reviewSubTitle { font-size: 16px; font-weight: 700; color: #384152; margin-bottom: 6px; }\n.hw-hotel--reviewContactRows { display: flex; flex-direction: column }\n.hw-hotel--reviewRow { display: flex; align-items: baseline; gap: 12px; }\n.hw-hotel--reviewRowLbl { font-size: 13px; color: #6b7280; font-weight: 500; min-width: 62px; flex: none; }\n.hw-hotel--reviewRowVal { font-size: 14px; color: #283D6B; font-weight: 600; word-break: break-word; }\n\n/* review step: payment method (inside guest card, excursion cards) */\n.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-exchk--panelTitle { margin: 0 0 14px; }\n.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-exchk--panelTitle.hw-hotel--reviewPayTitle { margin-top: 32px; }\n.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-exchk--pay-wrap { margin: 0; }\n\n/* left payment: booking ref + terms spacing */\n.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-hotel--payField { margin-top: 16px; }\n.hw-hotel--hotelDetails .hw-hotel--guestCard .hw-term--condition { margin-top: 16px; }\n\n/* confirm: download tickets label + buttons on one line */\n.hw-hotel--dlInline { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }\n.hw-hotel--dlInline .hw-exchk--panelSubTitle { margin: 0; white-space: nowrap; flex: none; }\n.hw-hotel--dlInline .hw-tk--dlRow { margin: 0; flex: 1 1 auto; }\n@media (max-width: 575px) {\n  .hw-hotel--dlInline { flex-direction: column; align-items: stretch; gap: 10px; }\n  .hw-contact--inputSingleField > .hw-inner--fullWidth.hw--hotel-phonecode {\n    width: 145px;\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
